import { useRef, forwardRef, useState, useEffect, useReducer, useCallback, useImperativeHandle, PureComponent, createRef, createContext, useContext, useMemo, Children, isValidElement, Component, Fragment as Fragment$1 } from 'react';
import cn from 'classnames';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { createI18nPack } from '@mapado/i18next-pack';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/l10n/de.js';
import Phone, { isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input/min';
import flags from 'react-phone-number-input/flags';
import frLabels from 'react-phone-number-input/locale/fr.json';
import enLabels from 'react-phone-number-input/locale/en.json';
import Select, { components } from 'react-select';
import Creatable from 'react-select/creatable';
import { createPortal } from 'react-dom';
import dialogPolyfill from 'dialog-polyfill-universal';

// Pure JS with checking all nodes between
var isTopElement = function isTopElement(wrapperElement, node) {
  if (typeof node.isSameNode === 'function') {
    return node.isSameNode(wrapperElement);
  }
  return node.isEqualNode(wrapperElement);
};
function delegate(wrapperElement, eventName, selector, listener) {
  // eslint-disable-next-line func-names, prefer-arrow-callback
  wrapperElement.addEventListener(eventName, function (event) {
    var checkingNode = event.target;
    while (checkingNode) {
      if (isTopElement(wrapperElement, checkingNode)) {
        // checking element itself
        return;
      }
      if (checkingNode.matches(selector)) {
        // found delegated element
        listener.call(checkingNode, event); // "this" will be delegated element

        return;
      }

      // going to parent node
      checkingNode = checkingNode.parentNode;
    }
  });
}

// breakpoints are in px

var breakpoints = {
  'breakpoint-to-tiny': 479,
  'breakpoint-from-tiny': 480,
  'breakpoint-to-mini': 619,
  'breakpoint-from-mini': 620,
  'breakpoint-to-small': 767,
  'breakpoint-from-small': 768,
  'breakpoint-to-medium': 879,
  'breakpoint-from-medium': 880,
  'breakpoint-to-large': 989,
  'breakpoint-from-large': 990,
  'breakpoint-to-wide': 1199,
  'breakpoint-from-wide': 1200
};

var hasClass = function hasClass(element, className) {
  return element.classList.contains(className);
};
var isAnimated = function isAnimated(element) {
  return hasClass(element, 'mpd-dropDown--animate');
};
function triggerDropdownEvent(dropdown, opened) {
  dropdown.dispatchEvent(new CustomEvent('mpd_dropdown::change', {
    detail: {
      opened: opened
    }
  }));
}
function closeDropDown(dropdown) {
  if (!dropdown) {
    return;
  }
  dropdown.classList.remove('mpd-dropDown--open');
  if (isAnimated(dropdown)) {
    dropdown.classList.add('mpd-dropDown--closing');
    setTimeout(function () {
      dropdown.classList.remove('mpd-dropDown--closing');
      dropdown.classList.add('mpd-dropDown--close');
      triggerDropdownEvent(dropdown, false);
    }, 500);
  } else {
    dropdown.classList.add('mpd-dropDown--close');
    triggerDropdownEvent(dropdown, false);
  }
}
function openDropDown(dropdown) {
  if (!dropdown) {
    return;
  }
  dropdown.classList.remove('mpd-dropDown--closing');
  dropdown.classList.remove('mpd-dropDown--close');
  dropdown.classList.add('mpd-dropDown--open');
  triggerDropdownEvent(dropdown, true);
}
function toggleDropDown(item, action) {
  if (!item) {
    return;
  }
  var innerAction = action;
  if (typeof innerAction === 'undefined' || innerAction !== 'open' && innerAction !== 'close') {
    if (hasClass(item, 'mpd-dropDown--open')) {
      innerAction = 'close';
    } else if (hasClass(item, 'mpd-dropDown--close') || hasClass(item, 'mpd-dropDown--closing')) {
      innerAction = 'open';
    } else if (hasClass(item, 'mpd-dropDown--open-from-sm') && window.innerWidth > breakpoints['breakpoint-from-small']) {
      innerAction = 'close';
    } else if (hasClass(item, 'mpd-dropDown--open-from-md') && window.innerWidth > breakpoints['breakpoint-from-medium']) {
      innerAction = 'close';
    } else if (hasClass(item, 'mpd-dropDown--open-from-lg') && window.innerWidth > breakpoints['breakpoint-from-large']) {
      innerAction = 'close';
    } else if (hasClass(item, 'mpd-dropDown--open-from-wide') && window.innerWidth > breakpoints['breakpoint-from-wide']) {
      innerAction = 'close';
    } else {
      innerAction = 'open';
    }
  }
  if (innerAction === 'open') {
    openDropDown(item);
  } else if (innerAction === 'close') {
    closeDropDown(item);
  }
}
function dropDownDocumentClicked(event) {
  var dropDownList = document.querySelectorAll('.mpd-dropDown--open:not(.mpd-dropDown--keepOpen)');
  for (var i = 0; i < dropDownList.length; ++i) {
    var element = dropDownList.item(i);
    if (!element.contains(event.target)) {
      toggleDropDown(element, 'close');
    }
  }
}
function dropdownLinkClicked(event) {
  event.preventDefault();
  var dropDown = this.closest('.mpd-dropDown');
  toggleDropDown(dropDown);
}
var dropDownInitialized = false;
function dropDownInit() {
  if (dropDownInitialized === false) {
    // close all dropdown when a click on document occurs
    document.addEventListener('click', dropDownDocumentClicked);

    // toggle dropdown state when a link is clicked. delegate allow to add DOM Elements after init
    delegate(document, 'click', '.mpd-dropDown-link', dropdownLinkClicked);
    dropDownInitialized = true;
  }
}

var isInitialized$1 = false;
function mpdTabInit() {
  if (isInitialized$1) {
    return;
  }
  isInitialized$1 = true;
  delegate(document, 'change', '.mpd-tabs__tab-selector',
  // eslint-disable-next-line prefer-arrow-callback
  function onSelectTab(event) {
    var _evtTarget$closest;
    var evtTarget = event.target;
    var parentTabNode = evtTarget.closest('.mpd-tabs');
    if (!parentTabNode) {
      throw new Error('.mpd-tabs should be defined. This should not happen.');
    }
    var targetId = evtTarget.getAttribute('data-target');
    if (!targetId) {
      throw new Error('Unable to get "data-target" for change target.');
    }
    var targetOpenedTab = document.getElementById(targetId);
    if (!targetOpenedTab) {
      throw new Error('Unable to get target for "data-target" attribute. Check that you defined an "id" matching your "data-target" attribute.');
    }
    var openedTabContentToHide = parentTabNode.querySelectorAll('.mpd-tabs__content.opened');
    var openedTabToUnselect = parentTabNode.querySelectorAll('.mpd-tabs__tab.selected');

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < openedTabContentToHide.length; i++) {
      openedTabContentToHide[i].classList.remove('opened');
    }

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var _i = 0; _i < openedTabToUnselect.length; _i++) {
      openedTabToUnselect[_i].classList.remove('selected');
    }
    targetOpenedTab.classList.add('opened');
    (_evtTarget$closest = evtTarget.closest('.mpd-tabs__tab')) === null || _evtTarget$closest === void 0 || _evtTarget$closest.classList.add('selected');
  });
}

// main function
function scrollToY() {
  var scrollTargetY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (typeof document.documentElement.style.scrollBehavior === 'undefined') {
    // scrollTo options are not supported (IE11 for example)
    // in fact the "smooth" behaviour is not supported but this check is sufficient for us
    window.scrollTo(0, scrollTargetY);
  } else {
    window.scrollTo({
      top: scrollTargetY,
      behavior: 'smooth'
    });
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _classPrivateFieldGet2(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _classPrivateFieldSet2(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _excluded$c = ["color", "title", "description", "className", "checked", "disabled", "onChange"];
var OFFER_COLOR = /*#__PURE__*/function (OFFER_COLOR) {
  OFFER_COLOR["PINK"] = "pink";
  OFFER_COLOR["BLUE"] = "blue";
  OFFER_COLOR["BLUE_DARK"] = "blue-dark";
  OFFER_COLOR["GREY"] = "grey";
  OFFER_COLOR["YELLOW"] = "yellow";
  OFFER_COLOR["BROWN"] = "brown";
  OFFER_COLOR["CYAN"] = "cyan";
  OFFER_COLOR["ORANGE"] = "orange";
  OFFER_COLOR["PURPLE"] = "purple";
  OFFER_COLOR["PURPLE_DARK"] = "purple-dark";
  OFFER_COLOR["PURPLE_LIGHT"] = "purple-light";
  OFFER_COLOR["PURPLE_SECONDARY"] = "purple-secondary";
  OFFER_COLOR["GREEN"] = "green";
  OFFER_COLOR["GREEN_DARK"] = "green-dark";
  return OFFER_COLOR;
}({});
function MpdOffer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? OFFER_COLOR.PINK : _ref$color,
    title = _ref.title,
    description = _ref.description,
    className = _ref.className,
    checked = _ref.checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  var checkboxMode = checked !== undefined;
  var checkboxRef = useRef(null);
  return /*#__PURE__*/jsxs("div", _objectSpread2(_objectSpread2({
    className: cn('mpd-offer', "mpd-offer--".concat(color), {
      'mpd-offer--checkbox': checkboxMode,
      'mpd-offer--disabled': disabled
    }, className),
    "aria-hidden": "true",
    onClick: function onClick() {
      var _checkboxRef$current;
      if (disabled) {
        return;
      }
      if (!checkboxMode) {
        return;
      }
      var event = new window.MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      (_checkboxRef$current = checkboxRef.current) === null || _checkboxRef$current === void 0 || _checkboxRef$current.dispatchEvent(event);
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest), {}, {
    children: [checkboxMode && /*#__PURE__*/jsx("div", {
      className: "checkbox",
      children: /*#__PURE__*/jsxs("div", {
        className: "mpd-checkbox",
        children: [/*#__PURE__*/jsx("input", {
          ref: checkboxRef,
          type: "checkbox",
          checked: checked,
          onClick: function onClick(event) {
            if (disabled) {
              return;
            }
            event.stopPropagation();
            if (onChange) {
              onChange(event);
            }
          }
        }), /*#__PURE__*/jsx("label", {})]
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-offer__container",
      children: [/*#__PURE__*/jsx("span", {
        className: "title",
        children: title
      }), /*#__PURE__*/jsx("span", {
        className: "description small",
        children: description
      })]
    })]
  }));
}

// Solid colors
// warning : if the color list changes here it must also be changed in styles/base/colors.scss
var SOLID_COLOR = /*#__PURE__*/function (SOLID_COLOR) {
  SOLID_COLOR["DARK_VIOLET"] = "#6C00C1";
  SOLID_COLOR["DULL_LAVENDER"] = "#B290FA";
  SOLID_COLOR["BASH_FUL_PINK"] = "#D00073";
  SOLID_COLOR["BRINK_PINK"] = "#FD5D83";
  SOLID_COLOR["ROSE_BUD"] = "#FFA79B";
  SOLID_COLOR["MAROON"] = "#811902";
  SOLID_COLOR["MUDDY_WATERS"] = "#BC865F";
  SOLID_COLOR["FADE_JADE"] = "#377266";
  SOLID_COLOR["KHAKI"] = "#A3A777";
  SOLID_COLOR["SALAD_GREEN"] = "#A9D136";
  SOLID_COLOR["NEON_CARROT"] = "#FD912E";
  SOLID_COLOR["PASTEL_ORANGE"] = "#FFBC3F";
  SOLID_COLOR["TURQUOISE"] = "#4ED3F0";
  return SOLID_COLOR;
}({});

// Gradiant colors
var GRADIANT_COLOR = _objectSpread2({}, OFFER_COLOR);
var SOLID_COLOR_LIST = Object.values(SOLID_COLOR);
var GRADIANT_COLOR_LIST = Object.values(GRADIANT_COLOR);

function callOnElementOrList(elements, cb) {
  if (Array.isArray(elements)) {
    // @ts-expect-error -- element should be good, I don't really understand the error
    elements.forEach(cb);
  } else if (elements instanceof NodeList || elements instanceof HTMLCollection) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements.item(i);
      if (element !== null) {
        // @ts-expect-error -- element should be good, I don't really understand the error
        cb(element);
      }
    }
  } else {
    // @ts-expect-error -- elements should be good, I don't really understand the error
    cb(elements);
  }
}

/**
 * Check the scroll state of a `containerElt`, to see if its `scrollableElt` children is scrollable to the top and/or to the bottom
 * This function applies the class `.is-scrollable-top` if you can scroll
 * @param  DOM Element Object containerElt the parent container element on which to apply the classes
 * @param  DOM Element Object scrollableElt the scrollable DOM element on which to check the scroll state
 */
function checkScrollable(containerElt, scrollableElt) {
  var eltScrollHeight = scrollableElt.scrollHeight;
  var offsetHeight = scrollableElt.offsetHeight,
    scrollTop = scrollableElt.scrollTop;
  var classTopScrollable = 'is-scrollable-top';
  var classBottomScrollable = 'is-scrollable-bottom';
  if (eltScrollHeight > offsetHeight) {
    if (eltScrollHeight - scrollTop === offsetHeight) {
      containerElt.classList.remove(classBottomScrollable);
    } else {
      containerElt.classList.add(classBottomScrollable);
    }
    if (scrollTop === 0) {
      containerElt.classList.remove(classTopScrollable);
    } else {
      containerElt.classList.add(classTopScrollable);
    }
  }
}

/**
 * Returns a color from the list of colors.
 * The same hash will return the same color.
 */
function generateColor(hash) {
  return SOLID_COLOR_LIST[hash % SOLID_COLOR_LIST.length];
}

/**
 * Returns a background color class from the list of colors.
 * The same hash will return the same color.
 */
function generatorBackgroundColorClass(id) {
  return "bg-color-".concat(id % SOLID_COLOR_LIST.length);
}

/**
 * Transforms an hexadecimal value in rgb css property
 */
function hexToRGB(hex, alpha) {
  if (!/^#[0-9A-F]{6}$/i.test(hex)) {
    throw new Error("The first parameter must be a valid hexadecimal value (like '#111111')");
  }
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  if (typeof alpha === 'number') {
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
  }
  return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}

/**
 * Keyboard Event utils
 */

var KEY_CODES = {
  enter: {
    keyCode: 13,
    code: 'Enter'
  },
  escape: {
    keyCode: 27,
    code: 'Escape'
  },
  up: {
    keyCode: 38,
    code: 'ArrowUp'
  },
  down: {
    keyCode: 40,
    code: 'ArrowDown'
  }
};
function matchKeyEvent(event, keycode) {
  return event.code === keycode.code || event.keyCode === keycode.keyCode;
}

/**
 * Generate a random ID
 */
function generateRandomID() {
  return Math.random().toString(36).substring(2, 12);
}

var BLOCK_ELEMENTS_SELECTOR = 'address, article, aside, audio, blockquote, canvas, dd, div, dl, dt, fieldset, figcaption, figure, footer, from, h1, h2, h3, h4, h5, h6, header, hgroup, hr, main, nav, noscript, ol, output, p, pre, section, table, tfoot, ul, video';
var TRANSLATIONS = {
  en: {
    showMore: 'Show more',
    showLess: 'Show less'
  },
  fr: {
    showMore: 'Afficher plus',
    showLess: 'Afficher moins'
  },
  pt: {
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos'
  }
};
var GLOBAL_TRANSLATION = TRANSLATIONS.en;
function dispatchToggleTextEvent() {
  document.dispatchEvent(new Event('mapado:shorten:toggle'));
}
function widthSmallerThan(breakpointName) {
  return window.innerWidth <= breakpoints["breakpoint-to-".concat(breakpointName)];
}
function makeElementOneLine(element) {
  element.style.whiteSpace = 'nowrap';
  element.style.display = 'inline';
  Array.prototype.forEach.call(element.querySelectorAll(BLOCK_ELEMENTS_SELECTOR), function (e) {
    e.style.display = 'inline';
  });
  Array.prototype.forEach.call(element.getElementsByTagName('br'), function (e) {
    e.style.display = 'none';
  });
}
function resetElementMultiline(element) {
  element.style.whiteSpace = '';
  element.style.display = 'block';
  Array.prototype.forEach.call(element.querySelectorAll(BLOCK_ELEMENTS_SELECTOR), function (e) {
    e.style.display = '';
  });
  Array.prototype.forEach.call(element.getElementsByTagName('br'), function (e) {
    e.style.display = '';
  });
}
function shortenElement(element) {
  var moretext = element.getAttribute('data-mpd-shorten-showMoreText') || GLOBAL_TRANSLATION.showMore;
  var lesstext = element.getAttribute('data-mpd-shorten-showLessText') || GLOBAL_TRANSLATION.showLess;
  if (element.classList.contains('js-shorten--loaded')) {
    // element is already shortened
    return;
  }

  // config
  var nbLines = parseInt(element.getAttribute('data-mpd-shorten-nblines'), 10) || 1;
  var inlineShowMore = parseInt(element.getAttribute('data-mpd-shorten-inline-showmore'), 10) || 0;
  var breakpoint = element.getAttribute('data-mpd-shorten-breakpoint') || 'all'; // all everywhere except on detail activity page so probably still usefull. Can be eventually replaced by a double `visible-xs / hidden-xs` div
  var hasIframe = !!element.getElementsByTagName('iframe')[0]; // probably if youtube embed or something like this

  var textContent = element.textContent.trim();
  var htmlContent = element.innerHTML;
  var moreSpan = '...';
  var wishedWidth = element.clientWidth * nbLines * (nbLines > 1 ? 0.9 : 0.95); // 0.9 is here to simulate word-breaking

  makeElementOneLine(element);
  var allWidth = element.offsetWidth;
  var ratio = wishedWidth / allWidth;
  var sizeShowMore = inlineShowMore ? moretext.length + 3 : 0;
  var showChar = Math.floor(textContent.length * ratio - (moreSpan.length + 1) - sizeShowMore);
  resetElementMultiline(element);

  // recreate the element
  var collapseText = function collapseText(innerDom, firstPart, ellipsestext, lastPart, showMoreLink, scrollToElement) {
    dispatchToggleTextEvent();
    var openedHeight = innerDom.offsetHeight;
    var beforeShowMoreLink = !inlineShowMore && document.createElement('br');
    innerDom.textContent = firstPart;
    innerDom.appendChild(ellipsestext);
    innerDom.appendChild(lastPart);
    if (beforeShowMoreLink) {
      innerDom.appendChild(beforeShowMoreLink);
    }
    innerDom.appendChild(showMoreLink);
    if (scrollToElement) {
      scrollToY(window.scrollY - openedHeight);
    }
  };
  var expandText = function expandText(innerDom, innerHtmlContent, showLessLink, scrollToElement) {
    innerDom.innerHTML = innerHtmlContent;
    innerDom.appendChild(showLessLink);
    dispatchToggleTextEvent();
    // TODO wait for SEO confirmation that we can use display: none;
    // innerDom.children('.hidden').removeClass('hidden');

    var openedHeight = innerDom.offsetHeight;
    {
      scrollToY(window.scrollY + Math.min(openedHeight, innerDom.getBoundingClientRect().top * 1 / 3));
    }
  };
  if ((breakpoint === 'all' || widthSmallerThan(breakpoint)) && (textContent.length > showChar || hasIframe)) {
    // cut on the previous space (to not cut in a middle of a word, or worse, of a <br>)
    var cutAt = textContent.length > showChar ? textContent.lastIndexOf(' ', showChar) // if text is small but contains an iframe, display all text + a show more button
    : textContent.length;

    // cutted parts
    var firstPart = textContent.substr(0, cutAt);
    var lastPart = document.createElement('span');
    lastPart.appendChild(document.createTextNode(textContent.substr(cutAt)));
    lastPart.style.display = 'none';

    // the ...
    var ellipsestext = document.createElement('span');
    ellipsestext.appendChild(document.createTextNode("".concat(moreSpan, " ")));

    // the link
    var createShowMoreLink = function createShowMoreLink() {
      var showMoreLink = document.createElement('button');
      showMoreLink.className = 'mpd-shorten__show-more-btn';
      showMoreLink.setAttribute('data-next-label', moretext);
      showMoreLink.appendChild(document.createTextNode(moretext));
      function handleShowMoreLinkClicked(e) {
        // eslint-disable-next-line no-use-before-define
        expandText(element, htmlContent, createShowLessLink());
        e.target.removeEventListener('click', handleShowMoreLinkClicked);
      }
      showMoreLink.addEventListener('click', handleShowMoreLinkClicked);
      return showMoreLink;
    };
    var createShowLessLink = function createShowLessLink() {
      var showLessLink = document.createElement('button');
      showLessLink.className = 'mbtn mbtn-small mbtn-lightgray';
      showLessLink.setAttribute('data-next-label', lesstext);
      showLessLink.appendChild(document.createTextNode(lesstext));
      function handleShowLessLinkClicked(e) {
        collapseText(element, firstPart, ellipsestext, lastPart, createShowMoreLink(), true);
        e.target.removeEventListener('click', handleShowLessLinkClicked);
      }
      showLessLink.addEventListener('click', handleShowLessLinkClicked);
      return showLessLink;
    };
    collapseText(element, firstPart, ellipsestext, lastPart, createShowMoreLink(), false);
  }
  element.style.height = '';
  element.classList.add('js-shorten--loaded');
}
function shortenInit(elements) {
  callOnElementOrList(elements, shortenElement);
}
var shorten = shortenInit;
shorten.locale = function locale(localeParam) {
  var customTranslations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (TRANSLATIONS[localeParam]) {
    GLOBAL_TRANSLATION = _objectSpread2(_objectSpread2({}, TRANSLATIONS[localeParam]), customTranslations);
  }
};

/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
// Options
var defaultOptions = {
  animationType: 'full',
  openBoxWaitingTime: 300,
  animationTime: 400,
  closeBoxWaitingTime: 300,
  classPrefix: 'mpd-slidebox',
  closeElementHtml: null,
  boxClassName: '',
  containerClass: '',
  fixedElementList: ['html'],
  container: 'body',
  onOpen: null,
  onClose: null,
  onLoadBefore: null,
  onLoad: null,
  onChange: null,
  isReactPortal: false,
  pushContent: false,
  // Will push the content instead of going on top of it
  withOverlay: true,
  manageHistory: true
};
var options = _objectSpread2({}, defaultOptions);
var isDisplayReady = false;
var isContentReady = false;
var contentFetched;
var htmlInitialScroll = 0;
var initialized = false;

// DOM
var openUrlList = [];
var containerElement;
var overlayElement;
var boxElement;
var scrollWrapperElement;
var closeElement = null;
var contentElement;

/**
 * @param {String} HTML representing a single element
 * @return {Element}
 */
function htmlToElement(html) {
  var template = document.createElement('template');
  template.innerHTML = html.trim(); // Never return a text node of whitespace as the result

  return template.content.firstChild;
}

/* PUBLIC METHODS
 ********************************************** */
function init(customOptions) {
  if (!isInitialized()) {
    // Options
    options = _objectSpread2(_objectSpread2({}, defaultOptions), customOptions);
    openUrlList.push("".concat(window.location));
    initialized = true;

    // DOM
    overlayElement = document.createElement('a');
    // eslint-disable-next-line no-script-url
    overlayElement.setAttribute('href', 'javascript:;');
    overlayElement.setAttribute('title', window.document.title);
    if (options.classPrefix) {
      overlayElement.classList.add("".concat(options.classPrefix, "__overlay"));
    }
    boxElement = document.createElement('div');
    if (options.classPrefix) {
      boxElement.classList.add("".concat(options.classPrefix, "__box"));
    }
    if (options.boxClassName) {
      boxElement.classList.add("".concat(options.boxClassName));
    }
    scrollWrapperElement = document.createElement('div');
    if (options.classPrefix) {
      scrollWrapperElement.classList.add("".concat(options.classPrefix, "__scrollWrapper"));
    }
    boxElement.appendChild(scrollWrapperElement);
    if (options.closeElementHtml !== null) {
      closeElement = htmlToElement(options.closeElementHtml);
    } else {
      closeElement = document.createElement('button');
      closeElement.innerHTML = '<span>✖</span>';
    }
    if (closeElement) {
      if (options.classPrefix) {
        closeElement.classList.add("".concat(options.classPrefix, "__close"));
      }
      scrollWrapperElement.appendChild(closeElement);
    }
    contentElement = document.createElement('div');
    if (options.classPrefix) {
      contentElement.classList.add("".concat(options.classPrefix, "__content"));
    }
    contentElement.innerHTML = _getLoadingHTML();
    scrollWrapperElement.appendChild(contentElement);
    containerElement = document.createElement('div');
    if (options.classPrefix) {
      containerElement.classList.add("".concat(options.classPrefix, "__container"));
    }
    if (options.containerClass) {
      containerElement.classList.add("".concat(options.containerClass));
    }
    containerElement.classList.add("".concat(options.classPrefix, "--").concat(options.animationType));
    if (options.withOverlay === true) {
      containerElement.append(overlayElement);
    }
    containerElement.append(boxElement);
    var containerElt = document.querySelector(options.container);
    containerElt.appendChild(containerElement);

    // Events
    ({
      manageHistory: options.manageHistory
    });
    overlayElement.addEventListener('click', function () {
      close();
    });
    if (closeElement) {
      closeElement.addEventListener('click', function () {
        close();
      });
    }

    // History
    if (options.manageHistory && _hasHistoryAPI()) {
      if (!_getOriginalUrlFromHistory(window.history)) {
        window.history.replaceState(_getStateToPush(), document.title);
      }
      window.addEventListener('popstate', function (event) {
        if (!event.target || !event.target.location) {
          return;
        }
        var url = "".concat(event.target.location);
        var requestedOriginalUrl = _getOriginalUrlFromHistory(event);
        if (!requestedOriginalUrl && _isCurrentUrl(url)) {
          // Anchor
          return;
        }
        if (requestedOriginalUrl && requestedOriginalUrl !== getOriginalUrl()) {
          // Wrong navigation context: We simulate classic navigation
          window.location.href = url;
          return;
        }
        if (isOpen() && _isParentUrl(url)) {
          _close();
          return;
        }
        if (!isOpen() && _isValidUrl(url)) {
          _open(url);
          return;
        }

        // Error case: We also simulate classic navigation
        window.location.href = url;
      });
    }
  }
}
function destroy() {
  if (!isInitialized()) {
    return;
  }

  // Remove context class
  var htmlElement = document.getElementsByTagName('html')[0];
  htmlElement.style.paddingRight = null;
  htmlElement.classList.remove("".concat(options.classPrefix, "--context"));
  var containerList = document.getElementsByClassName("".concat(options.classPrefix, "__container"));

  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (var i = 0; i < containerList.length; i++) {
    var container = containerList[i];
    container.parentNode.removeChild(container);
  }
  openUrlList = [];
  initialized = false;
}
function isInitialized() {
  return initialized;
}
function open(url) {
  var openOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!_isValidUrl(url)) {
    return false;
  }
  if (isInitialized) {
    destroy();
  }
  init(openOptions);
  _open(url);
  if (openOptions.manageHistory !== false && _hasHistoryAPI()) {
    window.history.pushState(_getStateToPush(), null, url);
  }
  return true;
}
function openSlideboxElement(openOptions) {
  if (isInitialized) {
    destroy();
  }
  init(openOptions);
  openUrlList.push(window.location);
  contentElement.innerHTML = '';
  _animateContainerOpen();
}
function isOpen() {
  return openUrlList.length > 1;
}
function getOriginalUrl() {
  if (!isInitialized()) {
    return false;
  }
  return openUrlList[0];
}
function getParentUrl() {
  if (!isInitialized() || !isOpen()) {
    return false;
  }
  return openUrlList[openUrlList.length - 2];
}
function getCurrentUrl() {
  if (!isInitialized()) {
    return false;
  }
  return openUrlList[openUrlList.length - 1];
}
function close() {
  if (!isInitialized() || !isOpen()) {
    return false;
  }
  _close();
  if (options.manageHistory !== false && _hasHistoryAPI()) {
    // No history.back() in case of navigation inside the slidebox (anchors)
    window.history.pushState(_getStateToPush(), null, getCurrentUrl());
  }
  return true;
}

/* PRIVATE METHODS
 ********************************************** */
function _open(url) {
  openUrlList.push(url);
  _animateContainerOpen();
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (rawContent) {
    var content = _callHandler('onLoadBefore', [rawContent]);
    _contentReady(content);
  }).catch(function (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    _contentReady('<div class="mpd-block mpd-block-title">' + '<div class="mpd-block-content">' + '<h1>Oops! An Error Occurred</h1>' + '</div>' + '</div>');
  });
  _callHandler('onOpen', [url, contentElement]);
}
function _displayReady() {
  isDisplayReady = true;
  if (options.isReactPortal) {
    _displayContent('');
    _callHandler('onOpen', [window.location, contentElement]);
  } else {
    contentElement.innerHTML = _getLoadingHTML();
    _displayContent(contentFetched);
  }
}
function _contentReady(content) {
  isContentReady = true;
  contentFetched = content;
  _displayContent(content);
}
function _displayContent(content) {
  if (isDisplayReady && isContentReady) {
    contentElement.innerHTML = content;
    _callHandler('onLoad', [getCurrentUrl(), contentElement]);
    _callHandler('onChange', [getCurrentUrl(), contentElement]);
    isDisplayReady = false;
    isContentReady = false;
    contentFetched = null;
  }
}
function _close() {
  var previousUrl = getCurrentUrl();
  openUrlList.pop();
  if (isOpen()) {
    var url = openUrlList.pop();
    _open(url);
  } else {
    _callHandler('beforeClose', [previousUrl, document]);
    if (!options.isReactPortal) {
      contentElement.innerHTML = '';
    }
    _callHandler('onClose', [previousUrl, document]);
    setTimeout(_animateBoxClose, options.closeBoxWaitingTime);
    _callHandler('onChange', [getCurrentUrl(), document]);
  }
}
function _hasHistoryAPI() {
  return window.history && window.history.pushState;
}
function _animateContainerOpen(parameters) {
  if (!containerElement.classList.contains("".concat(options.classPrefix, "--active"))) {
    if (options.pushContent) {
      var containerElt = document.querySelector(options.container);
      containerElt.style.marginRight = "".concat(containerElement.offsetWidth, "px");
      containerElt.style.transition = "margin-right ".concat(options.animationTime, "ms");
    }
    containerElement.classList.add("".concat(options.classPrefix, "--active"));
    _toggleBodyScroll();
    setTimeout(_animateBoxOpen, options.openBoxWaitingTime, parameters);
  } else {
    _displayReady();
  }
}
function _animateBoxOpen(parameters) {
  containerElement.classList.add("".concat(options.classPrefix, "--open"));
  _onTransitionEnd(boxElement, function () {
    _displayReady();
  });
}
function _animateBoxClose() {
  var containerElt = document.querySelector(options.container);
  if (options.pushContent) {
    containerElt.style.marginRight = '';
  }
  containerElement.classList.remove("".concat(options.classPrefix, "--open"));
  var previousUrl = getCurrentUrl();
  _onTransitionEnd(boxElement, function () {
    containerElement.classList.remove("".concat(options.classPrefix, "--active"));
    _toggleBodyScroll();
    destroy();
    _callHandler('onAfterClose', [previousUrl, document]);
    if (options.pushContent) {
      containerElt.style.transition = '';
    }
  });
}
function _toggleBodyScroll() {
  // Prevent from fixed element to move when removing the body scrollbar
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (var i = 0; i < options.fixedElementList.length; i++) {
    var fixedElement = document.querySelector(options.fixedElementList[i]);
    if (fixedElement) {
      fixedElement.style.paddingRight = isOpen() ? _getDeviceWidth() - fixedElement.offsetWidth : '0';
    }
  }
  if (isOpen()) {
    htmlInitialScroll = window.scrollY;
  } else {
    window.scrollTo(0, htmlInitialScroll);
  }
  var htmlElement = document.getElementsByTagName('html')[0];
  if (isOpen()) {
    htmlElement.classList.add("".concat(options.classPrefix, "--context"));
  } else {
    htmlElement.classList.remove("".concat(options.classPrefix, "--context"));
  }
}
function _callHandler(handler) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (typeof options[handler] === 'function') {
    return options[handler].apply(window, args);
  }
  return null;
}
function _urlParser(url) {
  var parser = document.createElement('a');
  parser.href = url;
  var copy = parser;
  copy.hash = '';
  parser.uri = "".concat(copy);
  return parser;
}
function _isValidUrl(rawNewUrl) {
  var newUrl = _urlParser(rawNewUrl);
  var currentUrl = _urlParser(getCurrentUrl());
  return newUrl.host === currentUrl.host && newUrl.uri !== currentUrl.uri;
}
function _isEquivalentUrl(rawNewUrl, referenceUrl) {
  var newUrl = _urlParser(rawNewUrl);
  var currentUrl = _urlParser(referenceUrl);
  return newUrl.host === currentUrl.host && newUrl.uri === currentUrl.uri;
}
function _isCurrentUrl(newUrl) {
  return _isEquivalentUrl(newUrl, getCurrentUrl());
}
function _isParentUrl(newUrl) {
  return _isEquivalentUrl(newUrl, getParentUrl());
}
function _getStateToPush() {
  return {
    slideboxOriginalUrl: getOriginalUrl()
  };
}
function _getOriginalUrlFromHistory(context) {
  if (!context || !context.state || !context.state.slideboxOriginalUrl) {
    return false;
  }
  return context.state.slideboxOriginalUrl;
}
function _getDeviceWidth() {
  return window.innerWidth > 0 ? window.innerWidth : window.screen.width;
}
function _getLoadingHTML() {
  var loadingClasses = "".concat(options.classPrefix, "__loading loading loading--size-xl loading--absolute");
  return "<div class=\"".concat(loadingClasses, "\"><div></div><div></div><div></div></div>");
}
function _onTransitionEnd(element, callback) {
  setTimeout(callback, options.animationTime);
}

/* EXPORT
 ********************************************** */
var Slidebox = {
  init: init,
  isInitialized: isInitialized,
  destroy: destroy,
  open: open,
  openSlideboxElement: openSlideboxElement,
  isOpen: isOpen,
  close: close,
  getParentUrl: getParentUrl,
  getOriginalUrl: getOriginalUrl,
  getCurrentUrl: getCurrentUrl
};

var _IMG_PATHS;
var IMAGE_NAME = /*#__PURE__*/function (IMAGE_NAME) {
  IMAGE_NAME["ABACUS"] = "abacus";
  IMAGE_NAME["BACKGROUND_1"] = "background-1";
  IMAGE_NAME["BACKGROUND_2"] = "background-2";
  IMAGE_NAME["BACKGROUND_3"] = "background-3";
  IMAGE_NAME["BACKGROUND_4"] = "background-4";
  IMAGE_NAME["BACKGROUND_5"] = "background-5";
  IMAGE_NAME["BIRD"] = "bird";
  IMAGE_NAME["BOOMBOX"] = "boombox";
  IMAGE_NAME["BOUQUET"] = "bouquet";
  IMAGE_NAME["BUS"] = "bus";
  IMAGE_NAME["CAMERA"] = "camera";
  IMAGE_NAME["CUP"] = "cup";
  IMAGE_NAME["DOLPHIN"] = "dolphins";
  IMAGE_NAME["EYE"] = "eye";
  IMAGE_NAME["FACE_PAINT"] = "face-paint";
  IMAGE_NAME["FACE_RECTANGLE"] = "face-rectangle";
  IMAGE_NAME["FACE_SHRED"] = "face-shred";
  IMAGE_NAME["FLOWER_POT"] = "flower-pot";
  IMAGE_NAME["FLOWER_TICKETS"] = "flower-tickets";
  IMAGE_NAME["GARDEN"] = "garden";
  IMAGE_NAME["HOLE"] = "hole";
  IMAGE_NAME["MASK_RACK"] = "mask-rack";
  IMAGE_NAME["MASK"] = "mask";
  IMAGE_NAME["MIC"] = "mic";
  IMAGE_NAME["OCTOPUS"] = "octopus";
  IMAGE_NAME["PLANET"] = "planet";
  IMAGE_NAME["PUZZLE"] = "puzzle";
  IMAGE_NAME["RIDERS"] = "riders";
  IMAGE_NAME["SWIMMERS"] = "swimmers";
  IMAGE_NAME["TOUCH"] = "touch";
  IMAGE_NAME["WATCHTOWER"] = "watchtower";
  IMAGE_NAME["WHALE"] = "whale";
  return IMAGE_NAME;
}({});
var IMG_PATHS = (_IMG_PATHS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_IMG_PATHS, IMAGE_NAME.ABACUS, '20XX/1/1/abacus.png'), IMAGE_NAME.BACKGROUND_1, '20XX/1/1/background-1.png'), IMAGE_NAME.BACKGROUND_2, '20XX/1/1/background-2.png'), IMAGE_NAME.BACKGROUND_3, '20XX/1/1/background-3.png'), IMAGE_NAME.BACKGROUND_4, '20XX/1/1/background-4.png'), IMAGE_NAME.BACKGROUND_5, '20XX/1/1/background-5.png'), IMAGE_NAME.BIRD, '20XX/1/1/bird.png'), IMAGE_NAME.BOOMBOX, '20XX/1/1/boombox.png'), IMAGE_NAME.BOUQUET, '20XX/1/1/bouquet.png'), IMAGE_NAME.BUS, '20XX/1/1/bus.png'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_IMG_PATHS, IMAGE_NAME.CAMERA, '20XX/1/1/camera.png'), IMAGE_NAME.CUP, '20XX/1/1/cup.png'), IMAGE_NAME.DOLPHIN, '20XX/1/1/dolphins.png'), IMAGE_NAME.EYE, '20XX/1/1/eye.png'), IMAGE_NAME.FACE_PAINT, '20XX/1/1/face-paint.png'), IMAGE_NAME.FACE_RECTANGLE, '20XX/1/1/face-rectangle.png'), IMAGE_NAME.FACE_SHRED, '20XX/1/1/face-shred.png'), IMAGE_NAME.FLOWER_POT, '20XX/1/1/flower-pot.png'), IMAGE_NAME.FLOWER_TICKETS, '20XX/1/1/flower-tickets.png'), IMAGE_NAME.GARDEN, '20XX/1/1/garden.png'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_IMG_PATHS, IMAGE_NAME.HOLE, '20XX/1/1/hole.png'), IMAGE_NAME.MASK_RACK, '20XX/1/1/mask-rack.png'), IMAGE_NAME.MASK, '20XX/1/1/mask.png'), IMAGE_NAME.MIC, '20XX/1/1/mic.png'), IMAGE_NAME.OCTOPUS, '20XX/1/1/octopus.png'), IMAGE_NAME.PLANET, '20XX/1/1/planet.png'), IMAGE_NAME.PUZZLE, '20XX/1/1/puzzle.png'), IMAGE_NAME.RIDERS, '20XX/1/1/riders.png'), IMAGE_NAME.SWIMMERS, '20XX/1/1/swimmers.png'), IMAGE_NAME.TOUCH, '20XX/1/1/touch.png'), _defineProperty(_defineProperty(_IMG_PATHS, IMAGE_NAME.WATCHTOWER, '20XX/1/1/watchtower.png'), IMAGE_NAME.WHALE, '20XX/1/1/whale.png'));

/**
 * Return the path of the img on img server
 */
function getImgPath(imageName) {
  return IMG_PATHS[imageName];
}

var _excluded$b = ["id", "className", "card", "cardWithoutShadow", "active", "children", "indeterminate", "leftBorderColor"];
function MpdCheckbox(_ref) {
  var id = _ref.id,
    className = _ref.className,
    card = _ref.card,
    cardWithoutShadow = _ref.cardWithoutShadow,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    children = _ref.children,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    leftBorderColor = _ref.leftBorderColor,
    input = _objectWithoutProperties(_ref, _excluded$b);
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  var _input = _objectSpread2({}, input),
    checked = _input.checked;
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-checkbox', className, {
      'mpd-card': card || cardWithoutShadow,
      active: active && card,
      'mpd-checkbox--shadow-less': cardWithoutShadow,
      'mpd-checkbox--no-children': !children,
      'mpd-checkbox--indeterminate': indeterminate
    }),
    children: [leftBorderColor && !((card || cardWithoutShadow) && checked) && /*#__PURE__*/jsx("div", {
      className: "left-border",
      style: {
        backgroundColor: leftBorderColor
      }
    }), /*#__PURE__*/jsx("input", _objectSpread2({
      type: "checkbox",
      id: inputId
    }, input)), /*#__PURE__*/jsxs("label", {
      htmlFor: inputId,
      children: [/*#__PURE__*/jsx("span", {
        className: "mpd-checkbox__check-render",
        children: /*#__PURE__*/jsx("svg", {
          viewBox: "0 0 14 14",
          children: /*#__PURE__*/jsx("polyline", {
            points: "0 5 4 8 11 1"
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-checkbox__children",
        children: children
      })]
    })]
  });
}

var _excluded$a = ["id", "className", "description", "small", "active", "image", "children", "withoutPadding"];
function MpdRadio(_ref) {
  var id = _ref.id,
    className = _ref.className,
    description = _ref.description,
    small = _ref.small,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    image = _ref.image,
    children = _ref.children,
    _ref$withoutPadding = _ref.withoutPadding,
    withoutPadding = _ref$withoutPadding === void 0 ? false : _ref$withoutPadding,
    input = _objectWithoutProperties(_ref, _excluded$a);
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-radio mpd-card', className, {
      'mpd-radio--has-description': !!description,
      'mpd-radio--small': small,
      'mpd-radio--has-image': !!image,
      'mpd-radio--without-padding': withoutPadding,
      active: active
    }),
    children: [/*#__PURE__*/jsx("input", _objectSpread2({
      type: "radio",
      id: inputId
    }, input)), /*#__PURE__*/jsxs("label", {
      htmlFor: inputId,
      children: [/*#__PURE__*/jsxs("div", {
        className: "mpd-radio__children",
        children: [image, /*#__PURE__*/jsx("div", {
          className: "content",
          children: children
        })]
      }), !!description && /*#__PURE__*/jsx("div", {
        className: "mpd-radio__description",
        children: description
      })]
    })]
  });
}

var SvgAccess = function SvgAccess(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12A9 9 0 0 0 4.203 7.501a1 1 0 0 1-1.73-1.002A11 11 0 0 1 12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11a10.99 10.99 0 0 1-9.345-5.194l-.182-.305-.047-.092a1 1 0 0 1 1.777-.91A9 9 0 0 0 21 12m-9.707-4.707a1 1 0 0 1 1.338-.068l.076.068 4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 1 1-1.414-1.414L13.586 13H2a1 1 0 1 1 0-2h11.586l-2.293-2.293-.068-.076a1 1 0 0 1 .068-1.338"
    })
  }));
};

var SvgAction = function SvgAction(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M10 19a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
    })
  }));
};

var SvgAgendaTime = function SvgAgendaTime(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M18 22v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0M11 6a1 1 0 1 1 2 0v5.382l3.186 1.593a1 1 0 0 1-.801 1.83l-.094-.041-3.738-1.87A1 1 0 0 1 11 12zm11.913 7.39a1 1 0 0 1-1.984-.25zM21 12a9 9 0 1 0-7.842 8.927l.102-.009a1 1 0 0 1 .152 1.992l-.349.04Q12.539 23 12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11q0 .706-.087 1.39l-1.984-.25q.07-.56.071-1.14"
    })
  }));
};

var SvgAgenda = function SvgAgenda(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M20 11H4v6.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C6.361 21 6.942 21 7.8 21h8.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zm-5-5V5H9v1a1 1 0 1 1-2 0v-.997c-.445.003-.795.01-1.089.034-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C4 7.361 4 7.942 4 8.8V9h16v-.2c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18A15 15 0 0 0 17 5.002V6a1 1 0 1 1-2 0m7 11.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H7.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C1.999 18.702 2 18.024 2 17.2V8.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392.36-.03.777-.038 1.252-.041V2a1 1 0 0 1 2 0v1h6V2a1 1 0 1 1 2 0v1.003c.476.003.891.011 1.252.041.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19.5 2c.416 0 .77-.005 1.085.058a3 3 0 0 1 2.357 2.357c.063.314.058.668.058 1.085s.005.77-.058 1.085A3 3 0 0 1 21 8.828V16.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H8.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C2.999 17.702 3 17.024 3 16.2V8.828a3 3 0 0 1-1.942-2.243C.995 6.271 1 5.917 1 5.5s-.005-.77.058-1.085a3 3 0 0 1 2.357-2.357C3.729 1.995 4.083 2 4.5 2zM5 16.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82.192.375.499.681.875.873.156.08.38.145.82.18C7.361 20 7.942 20 8.8 20h6.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.032.038-1.888V9H5zm7-5.2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 1-1M4.5 4c-.513 0-.623.005-.695.02a1 1 0 0 0-.785.785c-.015.072-.02.183-.02.695s.005.623.02.695a1 1 0 0 0 .785.785l.22.017.038.003h15.874q.018-.001.038-.003l.22-.017a1 1 0 0 0 .785-.785c.015-.072.02-.183.02-.695s-.005-.623-.02-.695a1 1 0 0 0-.785-.785c-.072-.015-.183-.02-.695-.02z"
    })
  }));
};

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.94 7.94a1.5 1.5 0 1 1 2.12 2.12l-6 6a1.5 1.5 0 0 1-2.12 0l-6-6a1.5 1.5 0 1 1 2.12-2.12L12 12.879z"
    })
  }));
};

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M13.94 4.94a1.5 1.5 0 1 1 2.12 2.12L11.122 12l4.94 4.94.018.02.069.075.015.018a1.5 1.5 0 0 1-2.11 2.11l-.018-.015-.076-.069-.02-.018-6-6a1.5 1.5 0 0 1 0-2.121z"
    })
  }));
};

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M7.94 4.94a1.5 1.5 0 0 1 2.12 0l6 6a1.5 1.5 0 0 1 0 2.12l-6 6a1.5 1.5 0 1 1-2.12-2.12L12.878 12l-4.94-4.94a1.5 1.5 0 0 1 0-2.12"
    })
  }));
};

var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M11.053 7.837a1.5 1.5 0 0 1 2.008.103l6 6 .018.02.069.075.015.018a1.5 1.5 0 0 1-2.11 2.11l-.018-.015-.076-.069-.02-.018L12 11.12l-4.94 4.94a1.5 1.5 0 0 1-2.12-2.121l6-6 .02-.019.075-.068z"
    })
  }));
};

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M17 11.2c0-1.064-.486-2.12-1.412-2.922C14.658 7.472 13.368 7 12 7s-2.658.472-3.588 1.278C7.486 9.081 7 10.136 7 11.2c0 2.456-.612 4.301-1.411 5.654-.274.463-.496.84-.67 1.142.259.002.569.004.938.004h12.285c.37 0 .68-.002.938-.004q-.26-.45-.669-1.142C17.611 15.5 17 13.656 17 11.2M10.27 20a1.998 1.998 0 0 0 3.46 0zM13.5 4.5a1.5 1.5 0 1 0-2.866.62 7.9 7.9 0 0 1 2.73 0c.086-.19.136-.399.136-.62m2 0c0 .43-.08.84-.22 1.22a7 7 0 0 1 1.618 1.048C18.222 7.916 19 9.506 19 11.2c0 2.108.52 3.6 1.133 4.636.398.674.709 1.2.917 1.576.103.187.195.36.26.508.033.073.07.162.097.256.021.07.072.25.051.47-.012.12-.038.36-.178.604a1.5 1.5 0 0 1-.43.46 1.2 1.2 0 0 1-.397.19c-.093.025-.185.04-.26.05-.152.02-.327.031-.51.037-.37.013-.888.013-1.541.013h-2.268a4.002 4.002 0 0 1-7.748 0H5.857c-.653 0-1.171 0-1.54-.013a5 5 0 0 1-.51-.037 2 2 0 0 1-.26-.05 1.2 1.2 0 0 1-.399-.19 1.5 1.5 0 0 1-.428-.46 1.5 1.5 0 0 1-.179-.605c-.021-.219.03-.4.052-.47.028-.093.064-.182.096-.255.066-.148.157-.321.26-.508.208-.377.52-.902.918-1.576C4.48 14.8 5 13.308 5 11.2c0-1.694.778-3.284 2.103-4.432A7 7 0 0 1 8.72 5.722 3.5 3.5 0 1 1 15.5 4.5"
    })
  }));
};

var SvgBookmarkCheck = function SvgBookmarkCheck(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 7.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C16.639 4 16.058 4 15.2 4H8.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C5 6.361 5 6.942 5 7.8v11.236l1.162-.845.142-.086a1 1 0 0 1 1.071.114l1.904 1.523 2.133-1.55.137-.085a1 1 0 0 1 1.039.084l2.132 1.551 1.905-1.523a1 1 0 0 1 1.213-.028l1.162.845zm-4.207-.507a1 1 0 1 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2-.068-.076A1 1 0 0 1 9.63 9.725l.076.068L11 11.086zM21 21a1 1 0 0 1-1.588.809l-2.133-1.552-1.904 1.524a1 1 0 0 1-1.213.028L12 20.235 9.838 21.81a1 1 0 0 1-1.213-.028L6.72 20.257l-2.132 1.552A1 1 0 0 1 3 21V7.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C7.298 1.999 7.976 2 8.8 2h6.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M20 12.6c0-.297-.001-.459-.01-.576l-.003-.012-.011-.001A8 8 0 0 0 19.4 12h-1.9v8H20zM13 14a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm0-4a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm0-4a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zM4 20h2.5v-8H4.6c-.297 0-.459.001-.576.01l-.012.002-.001.012C4 12.141 4 12.304 4 12.6zM15.5 6.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 13.3 4h-2.6c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422-.023.283-.024.656-.024 1.232V20h7zm2 3.8h1.9c.264 0 .522-.001.739.017.228.018.498.063.77.2.328.169.604.424.796.737l.077.138.087.203c.072.2.1.395.114.566.018.217.017.475.017.739V20a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2v-7.4c0-.264-.001-.522.017-.739.018-.228.063-.498.2-.77a2 2 0 0 1 .875-.873c.271-.138.54-.183.77-.201.216-.018.474-.017.738-.017h1.9V6.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C9.688 2 10.157 2 10.7 2h2.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M8 5.043h8V2h2.019v3.043h5.866L19.863 22H4.046L0 5.043h5.988V2H8zM5.625 20h12.657l3.073-12.957H2.534zm3.398-4H7.076v-5h1.947zM13 16h-2v-5h2zm3.924 0H15v-5h1.923z"
    })
  }));
};

var SvgCashDrawer = function SvgCashDrawer(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 14h3v7H0v-7h3V2h18zM2 19h20v-3H2zm11-1h-2v-1h2zm-8-4h14V4H5zm7-1h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-6-3h-2V8h2zm3 0h-2V8h2zm3 0h-2V8h2zm-6-3h-2V5h2zm3 0h-2V5h2zm3 0h-2V5h2z"
    })
  }));
};

var SvgCashIn = function SvgCashIn(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M4.4 12c.264 0 .522-.001.739.017.228.018.498.063.77.2a2 2 0 0 1 .796.737l.077.138.087.203q.044.129.069.253l1.608-.672.06-.026.228-.098c.19-.08.455-.187.754-.294.553-.198 1.38-.458 2.056-.458.479 0 .955.057 1.42.17l2.386.58.208.06a2.54 2.54 0 0 1 1.744 2.276l1.486-1.083v-.001a2.61 2.61 0 0 1 3.347.234 2.5 2.5 0 0 1 0 3.602l-2.158 2.1a5.2 5.2 0 0 1-2.633 1.372l-3.05.593a5.3 5.3 0 0 1-1.975.007l-.278-.06-2.758-.67H9.38a3.2 3.2 0 0 0-.77-.093H6.984q0 .026-.002.052a2 2 0 0 1-.2.77 2 2 0 0 1-.875.873 2 2 0 0 1-.77.201c-.216.018-.474.017-.738.017h-.8c-.264 0-.522.001-.739-.017a2 2 0 0 1-.77-.2 2 2 0 0 1-.873-.875 2 2 0 0 1-.201-.77C.999 20.923 1 20.665 1 20.4v-5.8c0-.264-.001-.522.017-.739.018-.228.063-.498.2-.77a2 2 0 0 1 .875-.873c.271-.138.54-.183.77-.201.216-.018.474-.017.738-.017zm7.244 2c-.29 0-.82.14-1.381.34a14 14 0 0 0-.852.34l-.05.022-.011.005-.002.001-.03.014L7 15.69v3.397h1.61c.42 0 .839.05 1.247.15l2.756.67.173.037c.405.076.82.074 1.227-.005l3.048-.592a3.2 3.2 0 0 0 1.622-.843l2.158-2.099a.503.503 0 0 0 0-.735.61.61 0 0 0-.682-.107l-.093.055-2.514 1.835a3.1 3.1 0 0 1-1.838.597h-2.429a1 1 0 0 1 0-2h1.546c.345 0 .577-.265.577-.534v-.307c0-.226-.16-.45-.43-.516l-2.385-.58a4 4 0 0 0-.95-.113M19 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M3 20.4c0 .297.001.46.01.576l.002.011.012.002c.117.01.28.011.576.011h.8c.297 0 .46-.001.576-.01l.011-.003.002-.011C5 20.859 5 20.696 5 20.4v-5.8c0-.297-.001-.46-.01-.576l-.003-.012-.011-.001A8 8 0 0 0 4.4 14h-.8c-.297 0-.459.001-.576.01l-.012.002-.001.012A8 8 0 0 0 3 14.6zM21 6.5a4.5 4.5 0 0 1-7.727 3.134 4.5 4.5 0 1 1 1.451-7.27A4.5 4.5 0 0 1 21 6.5m-12-1a2.5 2.5 0 0 0 3.22 2.393 4.5 4.5 0 0 1 .867-4.325A2.5 2.5 0 0 0 9 5.5"
    })
  }));
};

var SvgCashOut = function SvgCashOut(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19.6 12c-.264 0-.522.001-.739-.017a2 2 0 0 1-.77-.2 2 2 0 0 1-.796-.737l-.078-.138-.086-.203a2 2 0 0 1-.069-.253l-1.608.672-.06.026-.228.098c-.19.08-.455.187-.754.294-.553.198-1.38.458-2.056.458-.479 0-.956-.057-1.42-.17l-2.386-.58-.208-.06a2.54 2.54 0 0 1-1.745-2.276L5.112 9.997v.001a2.61 2.61 0 0 1-3.348-.234 2.5 2.5 0 0 1 .001-3.602l2.158-2.1A5.2 5.2 0 0 1 6.555 2.69l3.05-.593a5.3 5.3 0 0 1 1.976-.007l.278.06 2.758.67h.002c.25.062.51.093.77.093h1.625q.002-.026.002-.052c.019-.228.063-.498.202-.77a2 2 0 0 1 .874-.873c.27-.138.54-.183.77-.201.216-.018.474-.017.737-.017h.801c.264 0 .522-.001.738.017.229.018.499.063.77.2a2 2 0 0 1 .874.875c.138.271.182.54.201.77.018.216.017.474.017.738v5.8c0 .264 0 .522-.017.739a2 2 0 0 1-.201.77 2 2 0 0 1-.874.873 2 2 0 0 1-.77.201c-.216.018-.475.017-.738.017zm-7.244-2c.29 0 .82-.14 1.381-.34a14 14 0 0 0 .852-.34l.05-.022.011-.005.002-.001.03-.014L17 8.31V4.913h-1.61c-.42 0-.839-.05-1.248-.15h.001l-2.757-.67-.172-.037a3.3 3.3 0 0 0-1.227.005l-3.049.592a3.2 3.2 0 0 0-1.62.843l-2.16 2.099a.503.503 0 0 0 0 .735.61.61 0 0 0 .683.107l.092-.055 2.515-1.835a3.1 3.1 0 0 1 1.838-.597h2.429a1 1 0 0 1 0 2H9.169c-.345 0-.577.265-.577.534v.307c0 .225.16.45.43.516l2.385.58c.31.075.63.113.95.113M5 17.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M21 3.6a8 8 0 0 0-.012-.587l-.013-.002A8 8 0 0 0 20.4 3h-.8a8 8 0 0 0-.576.01l-.012.003-.002.011c-.009.117-.01.28-.01.576v5.8c0 .297.001.459.01.576l.002.012.012.001c.117.01.28.011.575.011h.801c.296 0 .459-.001.575-.01l.013-.002.001-.012c.01-.117.01-.28.01-.576zM3 17.5a4.5 4.5 0 0 1 7.727-3.134 4.5 4.5 0 1 1-1.451 7.27A4.5 4.5 0 0 1 3 17.5m12 1a2.5 2.5 0 0 0-3.221-2.393 4.49 4.49 0 0 1-.866 4.325A2.5 2.5 0 0 0 15 18.5"
    })
  }));
};

var SvgCheckFilled = function SvgCheckFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m5.207 7.293a1 1 0 0 0-1.414 0L10.5 13.586l-2.293-2.293-.076-.068a1 1 0 0 0-1.406 1.406l.068.076 3 3a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0 0-1.414"
    })
  }));
};

var SvgCheckStroke = function SvgCheckStroke(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5.207-3.707a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-3-3-.068-.076a1 1 0 0 1 1.406-1.406l.076.068 2.293 2.293zM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.94 6.94a1.5 1.5 0 1 1 2.12 2.12l-8 8a1.5 1.5 0 0 1-2.12 0l-4-4a1.5 1.5 0 1 1 2.12-2.12L10 13.88z"
    })
  }));
};

var SvgClockFastForward = function SvgClockFastForward(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 20",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "m20.7 9.5-2 2-2-2m2.245 1.5q.055-.492.055-1a9 9 0 1 0-2 5.657M10 5v5l3 2",
      style: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })
  }));
};

var SvgClockStroke = function SvgClockStroke(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0M11 6a1 1 0 1 1 2 0v5.382l3.447 1.723a1 1 0 0 1-.894 1.79l-4-2A1 1 0 0 1 11 12zm12 6c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgCoinsSwap = function SvgCoinsSwap(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M13 16a5 5 0 1 0-10 0 5 5 0 0 0 10 0m8 0a1 1 0 1 1 2 0 5 5 0 0 1-4.603 4.982l.31.311.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 1 1 1.414 1.414l-.26.26A3 3 0 0 0 21 16m0-8a5 5 0 0 0-9.843-1.251l-1.936-.498a7 7 0 1 1 8.528 8.528 1 1 0 1 1-.498-1.936A5 5 0 0 0 21 8M1 8a5 5 0 0 1 4.603-4.983l-.31-.31-.068-.076a1 1 0 0 1 1.482-1.338l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 1 1-1.414-1.414l.26-.26A3 3 0 0 0 3 8a1 1 0 0 1-2 0m10.157-1.251a1 1 0 0 1-1.936-.498zM15 16a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
    })
  }));
};

var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 19 19",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12.615 12.615a5.835 5.835 0 1 0-6.563-6.563m-.469 4.115 1.25-.834v4.584m-1.25 0h2.5m4.584-2.084a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0",
      style: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })
  }));
};

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 5.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 18.8 3h-7.6c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C9.001 4.25 9 4.624 9 5.2v7.6c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h7.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232zM3 18.8c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h7.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232V17h-3.8c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C7 13.812 7 13.343 7 12.8V9H5.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 10.25 3 10.624 3 11.2zm20-6c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H17v1.8c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H5.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C1 19.812 1 19.343 1 18.8v-7.6c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 7 4.657 7 5.2 7H7V5.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C10.188 1 10.657 1 11.2 1h7.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgCreditCardRefresh = function SvgCreditCardRefresh(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 15.8V11H3v4.8c0 .576.001.949.024 1.232.023.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.062.422.085.283.023.656.024 1.232.024H7a1 1 0 0 1 0 2H5.2c-.543 0-1.012.001-1.395-.03-.396-.032-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C1 16.812 1 16.343 1 15.8V8.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 4 4.657 4 5.2 4h5.386l-.293-.293-.068-.076a1 1 0 0 1 1.482-1.338l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 1 1-1.414-1.414L10.586 6H5.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 7.25 3 7.624 3 8.2V9h18v-.8c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 18.8 6H17a1 1 0 1 1 0-2h1.8c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395v7.6c0 .543.001 1.012-.03 1.395-.033.396-.104.79-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03h-5.386l.293.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 1 1 1.414 1.414l-.293.293H18.8c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232"
    })
  }));
};

var SvgCrm = function SvgCrm(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15 16c.881 0 1.468-.005 1.976.096a5 5 0 0 1 3.866 3.669c.052-.15.095-.355.12-.676.038-.45.038-1.032.038-1.889V6.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C18.639 3 18.058 3 17.2 3H6.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C3 5.361 3 5.942 3 6.8v10.4c0 .857 0 1.439.037 1.889.026.32.068.527.12.676a5 5 0 0 1 3.867-3.67C7.532 15.996 8.12 16 9 16zm-6 2c-.977 0-1.32.005-1.585.058a3 3 0 0 0-2.357 2.357 3.4 3.4 0 0 0-.05.554c.408.026.967.031 1.792.031h10.4c.825 0 1.383-.005 1.79-.031a3.4 3.4 0 0 0-.048-.554 3 3 0 0 0-2.357-2.357C16.32 18.005 15.977 18 15 18zm6-8.5a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0m6 7.7c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749q-.255.127-.526.21c-.78.236-1.78.225-3.09.225H6.8c-1.31 0-2.31.01-3.09-.226a3 3 0 0 1-.526-.21 4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C.999 18.702 1 18.024 1 17.2V6.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C5.298.999 5.976 1 6.8 1h10.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgCrossFilled = function SvgCrossFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m3.707 7.293a1 1 0 0 0-1.414 0L12 10.586 9.707 8.293l-.076-.068A1 1 0 0 0 8.225 9.63l.068.076L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293.076.068a1 1 0 0 0 1.406-1.406l-.068-.076L13.414 12l2.293-2.293a1 1 0 0 0 0-1.414"
    })
  }));
};

var SvgCrossStroke = function SvgCrossStroke(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-6.707-3.707a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068L12 13.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L10.586 12 8.293 9.707l-.068-.076A1 1 0 0 1 9.63 8.225l.076.068L12 10.586zM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.94 4.94a1.5 1.5 0 1 1 2.12 2.12L14.122 12l4.94 4.94.018.02.069.075.015.018a1.5 1.5 0 0 1-2.11 2.11l-.018-.015-.076-.069-.02-.018L12 14.12l-4.94 4.94a1.5 1.5 0 1 1-2.12-2.121L9.88 12 4.94 7.06a1.5 1.5 0 1 1 2.12-2.12L12 9.88z"
    })
  }));
};

var SvgCut = function SvgCut(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M8 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0m9.51-7a1 1 0 1 1 0 2h-.01a1 1 0 1 1 0-2zm4.5 0a1 1 0 0 1 0 2H22a1 1 0 1 1 0-2zM8 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 0 1-1.82 3.352l2.998 1.525 9.368-4.769a1.001 1.001 0 0 1 .908 1.784L13.383 12l8.071 4.108a1.001 1.001 0 0 1-.908 1.784l-9.368-4.77-2.997 1.526a4 4 0 1 1-4.135-.139l.017-.01q.12-.066.243-.123L8.974 12 4.306 9.623a4 4 0 0 1-.356-.188A4 4 0 1 1 10 6"
    })
  }));
};

var SvgDisallow = function SvgDisallow(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12A9 9 0 0 0 6.383 4.969L19.03 17.616A8.96 8.96 0 0 0 21 12M3 12a9 9 0 0 0 14.616 7.03L4.97 6.383A8.96 8.96 0 0 0 3 12m20 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0M11 8a1 1 0 1 1 2 0v5.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L11 13.586zm12 4c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M3 19a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
    })
  }));
};

var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 11.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 18.8 9h-7.6c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C9.001 10.25 9 10.624 9 11.2v7.6c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h7.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232zm-3.207.593a1 1 0 1 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L14 15.586zM15 5.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 12.8 3H5.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 4.25 3 4.624 3 5.2v7.6c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024H7v-3.8c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C10.188 7 10.657 7 11.2 7H15zM17 7h1.8c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395v7.6c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03h-7.6c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C7 19.812 7 19.343 7 18.8V17H5.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C1 13.812 1 13.343 1 12.8V5.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 1 4.657 1 5.2 1h7.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 0 0-5.771-8.401l-.199 2.986c-.007.105-.014.39-.123.654-.083.202-.21.383-.37.53-.21.194-.476.299-.572.341l-3.822 1.698-.874 1.167c-.073.096-.162.217-.25.316a1.5 1.5 0 0 1-.456.36c-.279.14-.595.188-.903.14a1.5 1.5 0 0 1-.544-.206c-.113-.068-.235-.155-.333-.226L3.507 9.02A9 9 0 1 0 21 12m-8.75.112c.15.002.278.027.375.051.118.03.247.073.35.107l.841.282.078.03 2.616 1.12c.135.058.296.126.43.197.105.057.248.143.383.277l.131.151.074.11a1.5 1.5 0 0 1 .22.878c-.017.28-.12.5-.197.64-.073.132-.17.277-.252.4l-1.23 1.843c-.052.079-.185.297-.384.461q-.232.19-.517.277c-.246.074-.501.064-.596.064h-1.996c-.122 0-.458.016-.764-.105a1.5 1.5 0 0 1-.602-.433c-.212-.253-.302-.576-.34-.692l-.714-2.14c-.023-.07-.093-.259-.111-.463a1.5 1.5 0 0 1 .034-.468l.042-.143c.048-.137.108-.249.133-.3l.54-1.082c.05-.097.11-.22.173-.323a1.5 1.5 0 0 1 .345-.408 1.5 1.5 0 0 1 .78-.323zm-.17 2.964L12.72 17h1.745l1.036-1.555-2.357-1.01-.638-.212zM12 3a8.99 8.99 0 0 0-7.608 4.193l3.394 2.424.79-1.05c.028-.04.102-.143.196-.235l.116-.102a2 2 0 0 1 .124-.088l.16-.09.112-.05 3.758-1.671.216-3.242A9 9 0 0 0 12 3m11 9c0 6.075-4.925 11-11 11S1 18.075 1 12a10.95 10.95 0 0 1 1.22-5.035 10.996 10.996 0 0 1 12.387-5.65C19.424 2.484 23 6.823 23 12"
    })
  }));
};

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-8.99 3a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zM11 12V8a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0m12 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgExternalProviderFilled = function SvgExternalProviderFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.257 13.007A5 5 0 0 1 21 18v6H3v-6a5 5 0 0 1 5-5h8zM12 14a1 1 0 0 0-1 1v2.586l-.293-.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 1 0-1.414-1.414l-.293.293V15a1 1 0 0 0-1-1m0-13a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
    })
  }));
};

var SvgExternalProvider = function SvgExternalProvider(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.257 13.007A5 5 0 0 1 21 18v6H3v-6a5 5 0 0 1 5-5h8zM8 15a3 3 0 0 0-3 3v4h14v-4a3 3 0 0 0-3-3h-3v2.586l.293-.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l.293.293V15zm4-14a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
    })
  }));
};

var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M2.293 2.293a1 1 0 0 1 1.339-.068l.076.068 3.64 3.64a1 1 0 0 1 .151.151l10.402 10.401q.094.074.17.171l3.637 3.637a1 1 0 0 1-1.415 1.414l-3.155-3.155C15.693 19.397 13.97 20 12 20c-2.861 0-5.194-1.265-6.923-2.707-1.726-1.44-2.91-3.107-3.503-4.046-.12-.19-.288-.44-.37-.8a2.2 2.2 0 0 1 0-.894c.082-.36.251-.612.371-.802.603-.954 1.828-2.674 3.622-4.14L2.293 3.707a1 1 0 0 1 0-1.414m4.325 5.74C4.98 9.325 3.834 10.92 3.267 11.818l-.11.18q.007.016.028.05c.02.035.045.075.08.13.533.844 1.588 2.32 3.093 3.578C7.862 17.012 9.757 18 12 18c1.353 0 2.578-.359 3.667-.919l-1.636-1.636a4 4 0 0 1-5.477-5.477zm14.365 7.19a1 1 0 0 1-1.533-1.285zM12 4c2.862 0 5.195 1.264 6.924 2.707 1.726 1.44 2.91 3.107 3.502 4.046.105.166.247.378.337.67l.035.13.035.216a2.2 2.2 0 0 1-.035.678c-.083.36-.253.612-.373.803a18.5 18.5 0 0 1-1.442 1.973l-1.533-1.285a16.5 16.5 0 0 0 1.284-1.756l.081-.131.03-.051-.028-.05-.082-.13c-.532-.843-1.586-2.32-3.092-3.577C16.139 6.988 14.243 6 12 6q-.572.001-1.11.082a1 1 0 0 1-.293-1.979A9.6 9.6 0 0 1 12 4m-8.843 8.024v-.004zM10 12a2 2 0 0 0 2 2c.179 0 .351-.027.516-.07l-2.447-2.447q-.068.248-.069.517"
    })
  }));
};

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 4c2.862 0 5.195 1.264 6.924 2.707 1.726 1.44 2.909 3.107 3.502 4.046.105.166.247.378.337.67l.035.13.035.216a2.2 2.2 0 0 1-.035.678c-.083.36-.252.61-.372.8-.593.939-1.776 2.605-3.502 4.046C17.195 18.736 14.862 20 12 20s-5.194-1.265-6.923-2.707c-1.726-1.44-2.91-3.107-3.503-4.046-.12-.19-.288-.44-.37-.8a2.2 2.2 0 0 1 0-.894c.082-.36.25-.61.37-.8.593-.939 1.777-2.605 3.503-4.046C6.806 5.264 9.14 4 12 4m0 2c-2.243 0-4.138.988-5.642 2.243-1.506 1.257-2.56 2.734-3.092 3.577l-.11.179V12l.029.05.08.13c.533.843 1.587 2.32 3.093 3.577C7.862 17.012 9.757 18 12 18s4.139-.988 5.643-2.243c1.505-1.257 2.56-2.734 3.092-3.577.036-.056.06-.096.08-.13l.029-.05-.029-.05c-.02-.034-.044-.074-.08-.13-.532-.843-1.587-2.32-3.092-3.577C16.139 6.988 14.243 6 12 6m2 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-10.843.024v-.003zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    })
  }));
};

var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M20 7.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C17.639 4 17.058 4 16.2 4H7.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C4 6.361 4 6.942 4 7.8v12.119l2.06-1.649c.456-.364.79-.637 1.172-.832.321-.164.663-.284 1.016-.356.42-.086.852-.082 1.436-.082H16.2c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zM15 11a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm-3-3.5a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm10 5.7c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H9.684c-.664 0-.858.005-1.034.041a2 2 0 0 0-.507.178c-.16.081-.315.2-.833.614l-2.385 1.908c-.193.154-.39.314-.564.428-.157.104-.462.29-.859.291a1.5 1.5 0 0 1-1.174-.565c-.247-.31-.293-.664-.31-.852-.02-.206-.018-.46-.018-.707V7.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C6.298 1.999 6.976 2 7.8 2h8.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M3.505 3.55c2.687-2.296 6.147-1.877 8.487.169 2.337-2.047 5.761-2.437 8.479-.178 2.973 2.471 3.33 6.686 1.04 9.633-.872 1.123-2.575 2.81-4.211 4.354a185 185 0 0 1-4.123 3.761c-.08.07-.181.162-.279.235a1.5 1.5 0 0 1-.476.247 1.5 1.5 0 0 1-.858 0 1.5 1.5 0 0 1-.476-.247c-.098-.073-.2-.165-.278-.235a185 185 0 0 1-4.124-3.76c-1.636-1.545-3.339-3.232-4.211-4.355C.176 10.216.598 6.034 3.505 3.55m7.728 2.236C9.528 3.793 6.818 3.35 4.805 5.07 2.7 6.867 2.418 9.842 4.054 11.947c.763.982 2.353 2.567 4.006 4.127a181 181 0 0 0 3.933 3.591c.847-.752 2.391-2.135 3.934-3.59 1.652-1.56 3.242-3.146 4.006-4.128 1.644-2.116 1.382-5.104-.74-6.868-2.068-1.718-4.743-1.277-6.44.707a1 1 0 0 1-1.52 0"
    })
  }));
};

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M13.5 13.111c0-.182-.005-.424.048-.664q.064-.286.207-.543c.12-.214.285-.39.407-.526L19.868 5c.392-.437.639-.715.796-.927q.014-.023.026-.042-.021-.003-.047-.007C20.38 4.001 20.008 4 19.42 4H4.578c-.587 0-.958 0-1.22.024q-.027.004-.05.007.012.02.027.042c.157.212.404.49.796.927l5.706 6.378c.121.136.287.312.407.526q.108.193.171.403l.037.14.03.18c.02.178.018.348.018.484v6.412l3-1.2zm2 5.347c0 .116.015.433-.095.728-.083.224-.22.425-.396.585-.233.212-.533.316-.64.359l-3.401 1.36c-.166.066-.353.142-.517.19a1.5 1.5 0 0 1-.757.05 1.5 1.5 0 0 1-.945-.64 1.5 1.5 0 0 1-.234-.72c-.016-.17-.015-.373-.015-.552v-6.707c0-.12 0-.181-.002-.225v-.002l-.003-.003a6 6 0 0 0-.148-.17L2.64 6.334c-.365-.408-.685-.765-.91-1.065-.209-.281-.473-.687-.493-1.19a2 2 0 0 1 .725-1.621c.388-.32.866-.394 1.215-.426C3.55 2 4.03 2 4.578 2h14.843c.547 0 1.027-.001 1.4.032.349.032.827.106 1.215.426a2 2 0 0 1 .726 1.621c-.02.503-.284.909-.494 1.19-.224.3-.545.657-.91 1.065l-5.706 6.377c-.08.09-.12.136-.148.17l-.002.002v.003l-.002.225z"
    })
  }));
};

var SvgFolderFilled = function SvgFolderFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 11.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C18.639 8 18.058 8 17.2 8H3v8.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C5.361 20 5.942 20 6.8 20h10.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zm-6.207-1.007a1 1 0 1 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L11 14.586zM5.2 4c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422-.02.249-.023.567-.023 1.032h8.38l-.39-.784c-.354-.707-.436-.842-.527-.93a1 1 0 0 0-.374-.231C9.97 4.013 9.812 4 9.022 4zM23 16.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.748c-.485.248-1.002.346-1.564.392-.55.045-1.228.044-2.052.044H6.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C.999 17.702 1 17.024 1 16.2v-10c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 2 4.657 2 5.2 2h3.822c.646 0 1.207-.013 1.72.164a3 3 0 0 1 1.121.692c.388.38.628.888.916 1.465L13.62 6H17.2c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 11.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C18.639 8 18.058 8 17.2 8H3v8.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C5.361 20 5.942 20 6.8 20h10.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zM5.2 4c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422-.02.249-.023.567-.023 1.032h8.38l-.39-.784c-.354-.707-.436-.842-.527-.93a1 1 0 0 0-.374-.231C9.97 4.013 9.812 4 9.022 4zM23 16.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H6.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C.999 17.702 1 17.024 1 16.2v-10c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 2 4.657 2 5.2 2h3.822c.646 0 1.207-.013 1.72.164a3 3 0 0 1 1.121.692c.388.38.628.888.916 1.465L13.62 6H17.2c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgGeopoint = function SvgGeopoint(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 10a7 7 0 1 0-14 0c0 2.74 1.44 4.232 3.268 5.766C9.478 16.78 10.99 17.88 12 19.433c1.01-1.552 2.521-2.652 3.732-3.667C17.561 14.232 19 12.74 19 10m-5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m5 0c0 3.678-2.06 5.686-3.982 7.298-2 1.678-3.623 2.825-4.038 4.898a1 1 0 0 1-1.96 0c-.415-2.073-2.038-3.22-4.038-4.898C5.061 15.686 3 13.678 3 10a9 9 0 0 1 18 0"
    })
  }));
};

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 12h-6v9h3.8c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232zM5 18.8c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024H11v-9H5zM21 7.6c0-.297-.001-.459-.01-.576l-.003-.012-.011-.001A8 8 0 0 0 20.4 7H13v3h7.4c.297 0 .46-.001.576-.01l.011-.003.002-.011C21 9.859 21 9.696 21 9.4zM3 9.4c0 .297.001.459.01.576l.002.011.012.002c.117.01.28.011.576.011H11V7H3.6c-.297 0-.459.001-.576.01l-.012.002-.001.012A8 8 0 0 0 3 7.6zM16.5 4a1.02 1.02 0 0 0-.289-.714.95.95 0 0 0-.675-.286c-.81 0-1.434.576-1.92 1.476a6 6 0 0 0-.249.524h2.17c.249 0 .492-.1.674-.286A1.02 1.02 0 0 0 16.5 4m-9 0c0 .271.106.528.29.714A.95.95 0 0 0 8.463 5h2.169a6 6 0 0 0-.25-.524C9.899 3.576 9.274 3 8.464 3c-.249 0-.492.1-.674.286A1.02 1.02 0 0 0 7.5 4m11 0c0 .344-.062.68-.174 1H20.4c.264 0 .522-.001.739.017.228.018.498.063.77.2a2 2 0 0 1 .796.737l.077.138.087.203c.072.2.1.395.114.566.018.217.017.475.017.739v1.8c0 .264.001.522-.017.739a2 2 0 0 1-.2.77 2 2 0 0 1-.875.873 2 2 0 0 1-.77.201q-.066.004-.138.005V18.8c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H7.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C3 19.812 3 19.343 3 18.8v-6.812c-.048-.002-.094-.001-.139-.005a2 2 0 0 1-.77-.2 2 2 0 0 1-.873-.875 2 2 0 0 1-.201-.77C.999 9.923 1 9.665 1 9.4V7.6c0-.264-.001-.522.017-.739.018-.228.063-.498.2-.77a2 2 0 0 1 .875-.873c.271-.138.54-.183.77-.201C3.077 4.999 3.335 5 3.6 5h2.074a3.02 3.02 0 0 1 .688-3.115A2.95 2.95 0 0 1 8.464 1C10.259 1 11.373 2.22 12 3.273 12.627 2.22 13.74 1 15.536 1c.792 0 1.547.32 2.102.885A3.02 3.02 0 0 1 18.5 4"
    })
  }));
};

var SvgGraduationHat = function SvgGraduationHat(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M17 14.5v-3.006c0-.18 0-.269-.027-.348a.5.5 0 0 0-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 0 0 .244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19q.171.03.342 0c.128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 0 0 .245-.38c.058-.163.058-.35.058-.721V9.5m-18-1 9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.012.135.045.266.11L22 8.5l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0c-.069-.013-.135-.045-.266-.11z",
      style: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })
  }));
};

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M14 13.6c0-.296-.001-.459-.01-.575l-.003-.014h-.011A8 8 0 0 0 13.4 13h-2.8a8 8 0 0 0-.588.01l-.001.014c-.01.116-.011.278-.011.575V20h4zm2 6.4h1.8c.576 0 .949-.001 1.232-.024.272-.022.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.049.062-.15.085-.422.023-.283.024-.655.024-1.232v-7.235c0-.63-.009-.755-.037-.857a1 1 0 0 0-.16-.325c-.062-.084-.155-.168-.653-.555l-6.782-5.275a7 7 0 0 0-.361-.271L12 3.277l-.007.005c-.075.05-.174.126-.361.271L4.85 8.828c-.498.387-.591.47-.654.555a1 1 0 0 0-.159.325C4.01 9.81 4 9.934 4 10.565V17.8c0 .577.001.95.024 1.232.023.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085.283.023.656.024 1.232.024H8v-6.4c0-.264-.001-.521.017-.738.018-.229.063-.499.2-.77a2 2 0 0 1 .875-.874c.271-.138.54-.182.77-.201.216-.018.474-.017.738-.017h2.8c.264 0 .522 0 .739.017.228.019.498.063.77.201a2 2 0 0 1 .796.736l.077.138.087.202c.072.201.1.396.114.568.018.216.017.474.017.738zm6-2.2c0 .543.001 1.011-.03 1.395-.033.395-.104.788-.297 1.167a3 3 0 0 1-1.31 1.311c-.379.193-.772.264-1.168.296-.383.031-.852.031-1.395.031H6.2c-.543 0-1.012 0-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.311c-.194-.379-.265-.772-.298-1.167C2 18.81 2 18.343 2 17.8v-7.235c0-.518-.008-.968.111-1.396a3 3 0 0 1 .477-.974c.264-.357.625-.627 1.033-.945l6.782-5.275c.279-.217.64-.52 1.074-.639a2 2 0 0 1 .917-.03l.129.03.16.053c.364.14.67.397.914.586l6.782 5.275c.408.318.77.588 1.033.945.217.293.378.623.477.974.12.428.111.878.111 1.396z"
    })
  }));
};

var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M17 19.248c0-.88-.008-1.137-.068-1.362a2 2 0 0 0-.296-.632c-.135-.19-.327-.361-1.003-.925L12 13.302l-3.633 3.027c-.676.564-.868.734-1.003.925a2 2 0 0 0-.296.632c-.06.225-.068.482-.068 1.362V21h10zM17 3H7v1.752c0 .88.008 1.137.068 1.362s.161.44.296.632c.135.19.327.361 1.003.925L12 10.697l3.633-3.026c.676-.564.868-.734 1.003-.925s.235-.406.296-.632c.06-.225.068-.482.068-1.362zm2 1.752c0 .772.008 1.341-.138 1.882a4 4 0 0 1-.59 1.262c-.322.458-.766.817-1.359 1.311L13.563 12l3.35 2.793c.593.494 1.037.853 1.358 1.31.27.383.47.811.591 1.263.146.54.138 1.11.138 1.882V21h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1v-1.752c0-.772-.008-1.341.138-1.882.121-.452.321-.88.59-1.262.323-.458.766-.817 1.359-1.311L10.437 12l-3.35-2.793c-.593-.494-1.036-.853-1.358-1.31a4 4 0 0 1-.591-1.263C4.992 6.094 5 5.524 5 4.752V3H4a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2h-1z"
    })
  }));
};

var SvgId = function SvgId(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1 6.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C5.298.999 5.976 1 6.8 1H12a1 1 0 1 1 0 2H6.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C3 5.361 3 5.942 3 6.8V17c.835-.628 1.874-1 3-1h7c.881 0 1.468-.005 1.976.096a5 5 0 0 1 3.928 3.928c.056.279.077.582.087.944q.05-.003.098-.005c.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888V12a1 1 0 1 1 2 0v5.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.34.028-.73.036-1.173.04L18 23q-.034 0-.067-.004-.345.003-.733.004H6.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748 3 3 0 0 1-.18-.437 1 1 0 0 1-.109-.4 6 6 0 0 1-.103-.727C.999 18.702 1 18.024 1 17.2zM6 18a3 3 0 0 0-2.788 1.895l.006.013a2 2 0 0 0 .874.874c.156.08.38.145.82.18C5.361 21 5.942 21 6.8 21h10.192a3.5 3.5 0 0 0-.05-.585 3 3 0 0 0-2.357-2.357C14.32 18.005 13.977 18 13 18zm7-8.5a3 3 0 1 0-6 0 3 3 0 0 0 6 0M18 8V6h-2a1 1 0 1 1 0-2h2V2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0m-3 1.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
    })
  }));
};

var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m4.272 20.728 6.597-6.597c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668l6.553 6.553M14 15l2.869-2.869c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L22 15M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21"
    })
  }));
};

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 12",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M0 6a6 6 0 0 1 6-6h.5l.103.005A1 1 0 0 1 6.5 2H6a4 4 0 1 0 0 8h2a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6H6a6 6 0 0 1-6-6m20 0a4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4 1 1 0 1 1-2 0 6 6 0 0 1 6-6h2a6 6 0 0 1 0 12h-.5a1 1 0 1 1 0-2h.5a4 4 0 0 0 4-4"
    })
  }));
};

var SvgList = function SvgList(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M2 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zM2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zM2 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2z"
    })
  }));
};

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 20 19",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M11.136 14.849c.498-1.838.555-6.177.533-8.79a13 13 0 0 0-.03-.792c.74-1.194 1.997-2.578 2.417-2.765 1.333-.593 1.425 1.155 1.509 3.334.11 2.867-.225 6.622-.18 8.106.029.981.126 2.998 1.112 4.127C17.533 19.255 20 17.6 20 17.6c-.735-1.239-2.206-1.334-1.928-6.687.32-6.181.423-8.684-.593-10.078-.523-.716-2.286-1.493-4.058.097a13.6 13.6 0 0 0-2.102 2.397c-.191-.685-.43-1.164-.638-1.433-.544-.702-1.887-1.44-3.658.15-.776.697-1.382 1.704-1.818 2.616l-.048-.32C4.73 1.725 3.537.535 2.25 1.203 1.484 1.601.668 2.433.112 3.027c-.328.354.155.698.277.763s.258-.033.377-.198c.264-.364.68-.714.955-.79.617-.173 1.096.618 1.179 6.323.061 4.351-.494 7.282-.87 8.272-.376.988-.954 1.656.199 1.457 1.154-.202 2.143-1.273 2.409-1.555s.387-.628.65-2.784c.188-1.544.258-4.753.126-7.41.698-1.248 1.71-2.934 2.176-3.113.75-.287 1.441 1.158 1.525 3.336.11 2.867-.322 7.717-.233 8.485.09.768 1.584-.117 2.254-.964",
      clipRule: "evenodd"
    })
  }));
};

var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M11.293 7.293a1 1 0 0 1 1.338-.07l.076.07 4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 1 1-1.414-1.414L13.586 13H3a1 1 0 0 1 0-2h10.586l-2.293-2.293-.068-.076a1 1 0 0 1 .068-1.338M5 7c0-.327-.002-.566.02-.782a4 4 0 0 1 3.05-3.482c.21-.05.447-.08.772-.124l6.592-.878c.92-.123 1.674-.225 2.287-.253.622-.03 1.202.008 1.756.228.853.339 1.564.96 2.012 1.76.292.521.406 1.092.46 1.713.052.611.051 1.372.051 2.3v9.036c0 .929 0 1.69-.052 2.3-.053.621-.167 1.191-.459 1.711a4 4 0 0 1-2.012 1.761c-.554.22-1.134.259-1.756.23-.613-.03-1.367-.13-2.287-.253l-6.592-.88c-.325-.043-.561-.073-.773-.123a4 4 0 0 1-3.048-3.483c-.023-.216-.021-.454-.021-.78a1 1 0 1 1 2 0c0 .374.002.487.01.576a2 2 0 0 0 1.525 1.741c.087.021.2.038.57.087l6.593.88c.956.127 1.61.213 2.116.237.498.023.751-.021.925-.09a2 2 0 0 0 1.005-.88c.092-.163.17-.409.212-.904.043-.506.044-1.166.044-2.13V7.483c0-.965 0-1.624-.044-2.13-.043-.496-.12-.741-.212-.905a2 2 0 0 0-1.005-.88c-.174-.069-.427-.113-.925-.09-.507.025-1.16.11-2.116.238l-6.593.879c-.37.05-.483.066-.57.087a2 2 0 0 0-1.524 1.74C7 6.512 7 6.625 7 7a1 1 0 0 1-2 0"
    })
  }));
};

var SvgLongArrowDown = function SvgLongArrowDown(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M13 4v13.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-6 6-.076.068a1 1 0 0 1-1.338-.068l-6-6-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L11 17.586V4a1 1 0 1 1 2 0"
    })
  }));
};

var SvgLongArrowLeft = function SvgLongArrowLeft(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M9.293 5.293a1 1 0 1 1 1.414 1.414L6.414 11H20a1 1 0 0 1 0 2H6.414l4.293 4.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-6-6a1 1 0 0 1 0-1.414z"
    })
  }));
};

var SvgLongArrowRight = function SvgLongArrowRight(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M13.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1-1.414-1.414L17.586 13H4a1 1 0 1 1 0-2h13.586l-4.293-4.293-.068-.076a1 1 0 0 1 .068-1.338"
    })
  }));
};

var SvgLongArrowTop = function SvgLongArrowTop(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M11 20V6.414l-4.293 4.293a1 1 0 1 1-1.414-1.414l6-6 .076-.068a1 1 0 0 1 1.338.068l6 6 .068.076a1 1 0 0 1-1.406 1.406l-.076-.068L13 6.414V20a1 1 0 1 1-2 0"
    })
  }));
};

var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M18 11a7 7 0 1 0-2.137 5.032 1 1 0 0 1 .17-.169A6.98 6.98 0 0 0 18 11m-3 0a4 4 0 0 0-4-4 1 1 0 1 1 0-2 6 6 0 0 1 6 6 1 1 0 1 1-2 0m5 0a8.96 8.96 0 0 1-1.97 5.616l3.677 3.677.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-3.677-3.677A9 9 0 1 1 20 11"
    })
  }));
};

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "m21 8.92-6.592 4.615c-.593.415-1.1.79-1.682.935a3 3 0 0 1-1.452 0c-.582-.146-1.089-.52-1.682-.935L3 8.92v6.28c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C5.361 19 5.942 19 6.8 19h10.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zM6.8 5c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875 1.5 1.5 0 0 0-.134.446l7.654 5.358c.729.51.883.6 1.02.633.159.04.325.04.484 0 .136-.034.291-.123 1.02-.633l7.653-5.358a1.5 1.5 0 0 0-.133-.446 2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.82-.18C18.639 5 18.058 5 17.2 5zM23 15.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H6.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C.999 16.702 1 16.024 1 15.2V8.8c0-.618 0-1.153.019-1.614a1 1 0 0 1 .033-.5c.048-.538.145-1.035.384-1.502a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C5.298 2.999 5.976 3 6.8 3h10.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.237.467.335.964.383 1.502a1 1 0 0 1 .033.5c.02.46.019.996.019 1.614z"
    })
  }));
};

var SvgMinusStroke = function SvgMinusStroke(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5-1a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm7 1c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-4 9a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
    })
  }));
};

var SvgOption = function SvgOption(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M18.66 20a1 1 0 0 1 0 2h-.01a1 1 0 1 1 0-2zm-.358-2.948.01-.003a3 3 0 0 0 .254-.104 4.3 4.3 0 0 0 .624-.34c.502-.334.679-.635.68-.853v-.002a1.249 1.249 0 0 0-2.427-.416 1 1 0 0 1-1.886-.664 3.249 3.249 0 0 1 6.312 1.082l-.01.234c-.107 1.147-.976 1.894-1.56 2.284a6.3 6.3 0 0 1-1.318.664l-.028.01-.01.002-.004.002h-.002a1 1 0 0 1-.728-1.86zM10 14a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm4-4a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm5-.5V6.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C16.639 3 16.058 3 15.2 3H8.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C5 5.361 5 5.942 5 6.8v10.4c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C7.361 21 7.942 21 8.8 21H14a1 1 0 1 1 0 2H8.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C2.999 18.702 3 18.024 3 17.2V6.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C7.298.999 7.976 1 8.8 1h6.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052v2.7a1 1 0 1 1-2 0M16 6a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z"
    })
  }));
};

var SvgParameter = function SvgParameter(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12.818 3.818a.82.82 0 0 0-1.396-.579.82.82 0 0 0-.24.58v.158a2.5 2.5 0 0 1-1.515 2.288 1 1 0 0 1-.251.068 2.5 2.5 0 0 1-2.57-.572l-.008-.008-.054-.055a.82.82 0 0 0-1.158 0h-.001a.82.82 0 0 0-.054 1.099l.054.06.063.062a2.5 2.5 0 0 1 .5 2.758l-.001-.001a2.5 2.5 0 0 1-2.263 1.578h-.106a.82.82 0 0 0-.579 1.397.82.82 0 0 0 .58.24h.158a2.5 2.5 0 0 1 2.283 1.505 2.5 2.5 0 0 1-.5 2.758l-.007.008-.055.054a.82.82 0 0 0 0 1.158v.001a.817.817 0 0 0 1.158 0l.063-.062a2.5 2.5 0 0 1 2.758-.5h-.001a2.5 2.5 0 0 1 1.578 2.263v.106a.82.82 0 0 0 1.397.579.82.82 0 0 0 .24-.58v-.158a2.5 2.5 0 0 1 1.505-2.284l.173-.068a2.5 2.5 0 0 1 2.447.443l.138.125.008.008.054.055a.82.82 0 0 0 .892.178q.151-.063.266-.177l.001-.001a.82.82 0 0 0 .054-1.099l-.054-.06-.062-.062a2.5 2.5 0 0 1-.57-2.584l.07-.174a2.5 2.5 0 0 1 2.283-1.505h.086a.82.82 0 0 0 .579-1.396.82.82 0 0 0-.58-.24h-.158a2.5 2.5 0 0 1-2.288-1.515 1 1 0 0 1-.069-.251 2.5 2.5 0 0 1 .573-2.57l.008-.008.055-.054a.82.82 0 0 0 .178-.892.8.8 0 0 0-.177-.266l-.001-.001a.82.82 0 0 0-1.099-.054l-.06.054-.062.063a2.5 2.5 0 0 1-2.758.5v-.001a2.5 2.5 0 0 1-1.505-2.283zM14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.182-8.104.006.073a.5.5 0 0 0 .297.385l.01.003a.5.5 0 0 0 .552-.1l.046-.046a2.82 2.82 0 0 1 3.987 0l.186.205a2.82 2.82 0 0 1 .425 2.868q-.16.386-.425.71l-.186.204-.054.055a.5.5 0 0 0-.093.543q.037.085.057.174a.5.5 0 0 0 .405.212h.15a2.82 2.82 0 1 1 0 5.636h-.078l-.072.006a.5.5 0 0 0-.384.297l-.004.01a.5.5 0 0 0 .1.552l.045.046a2.82 2.82 0 0 1 .612 3.073c-.141.342-.35.651-.612.913h.001a2.816 2.816 0 0 1-3.782.187l-.205-.186-.055-.054a.5.5 0 0 0-.543-.093l-.01.005a.5.5 0 0 0-.303.457v.15a2.819 2.819 0 1 1-5.636 0v-.058l-.008-.074a.5.5 0 0 0-.32-.383l-.058-.023a.5.5 0 0 0-.552.1l-.046.046a2.82 2.82 0 0 1-3.988 0v-.002a2.817 2.817 0 0 1 .001-3.985l.054-.055a.5.5 0 0 0 .093-.543l-.005-.01a.5.5 0 0 0-.385-.298l-.072-.005h-.15a2.819 2.819 0 1 1 0-5.636h.058a.5.5 0 0 0 .457-.327l.023-.059a.5.5 0 0 0-.1-.552l-.046-.046V8.27a2.818 2.818 0 1 1 3.987-3.986l.053.052a.5.5 0 0 0 .545.095l.098-.037q.037-.013.076-.021a.5.5 0 0 0 .129-.13.5.5 0 0 0 .083-.27v-.155a2.82 2.82 0 1 1 5.636 0z"
    })
  }));
};

var SvgParticipantFilled = function SvgParticipantFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.257 13.007A5 5 0 0 1 21 18v6H3v-6a5 5 0 0 1 5-5h8zM12 1a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
    })
  }));
};

var SvgParticipant = function SvgParticipant(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.257 13.007A5 5 0 0 1 21 18v6H3v-6a5 5 0 0 1 5-5h8zM8 15a3 3 0 0 0-3 3v4h14v-4a3 3 0 0 0-3-3zm4-14a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
    })
  }));
};

var SvgPaymentCard = function SvgPaymentCard(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 11H3v4.8c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h13.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.086-.422C21 16.75 21 16.376 21 15.8zm-10 2a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm10-4.8c0-.576 0-.949-.023-1.232-.023-.272-.061-.373-.086-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 18.8 6H5.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 7.25 3 7.624 3 8.2V9h18zm2 7.6c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H5.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C1 16.812 1 16.343 1 15.8V8.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 4 4.657 4 5.2 4h13.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgPenSquare = function SvgPenSquare(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1 17.2V8.8c0-.824-.001-1.502.044-2.052.046-.562.144-1.079.392-1.564a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.298 2.999 5.976 3 6.8 3H11a1 1 0 0 1 0 2H6.8C5.943 5 5.36 5 4.91 5.038c-.438.036-.663.1-.82.18a2 2 0 0 0-.873.874c-.08.156-.145.38-.18.819C3 7.36 3 7.943 3 8.8v8.4c0 .856 0 1.439.037 1.889.036.438.101.663.18.819a2 2 0 0 0 .875.874c.156.08.38.145.82.18C5.361 21 5.942 21 6.8 21h8.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.181a2 2 0 0 0 .873-.874c.08-.156.145-.381.18-.82.038-.45.038-1.032.038-1.888V13a1 1 0 0 1 2 0v4.2c0 .823.001 1.501-.044 2.052-.046.562-.144 1.079-.392 1.564a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.55.045-1.228.044-2.052.044H6.8c-.824 0-1.502 0-2.052-.044-.562-.046-1.08-.145-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C.999 18.702 1 18.023 1 17.2M17.793 1.793a3.121 3.121 0 0 1 4.414 4.414l-9.562 9.563c-.313.313-.58.588-.906.788a3 3 0 0 1-.867.359c-.372.09-.756.083-1.197.083H8a1 1 0 0 1-1-1v-1.674c0-.442-.006-.826.083-1.198.074-.306.195-.6.36-.867.2-.326.475-.594.787-.906zM9 15h.675c.536 0 .642-.006.73-.028q.154-.037.29-.12c.077-.047.156-.118.535-.497l9.563-9.562a1.122 1.122 0 0 0-1.586-1.586L9.645 12.77c-.38.38-.45.459-.498.536a1 1 0 0 0-.12.289c-.02.088-.027.194-.027.731z"
    })
  }));
};

var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M14.536 4.28c.264-.085.546-.096.814-.032l.114.032.162.066c.15.071.266.16.35.23.102.087.21.195.296.282l2.87 2.87c.087.087.195.194.282.296.07.084.159.2.23.35l.066.162.032.114a1.5 1.5 0 0 1-.032.814c-.076.232-.202.4-.296.512-.087.102-.195.21-.282.297L8.808 20.607c-.203.202-.377.38-.58.528a3 3 0 0 1-.538.312c-.23.104-.47.166-.747.242l-4.68 1.276a1 1 0 0 1-1.228-1.228l1.277-4.68c.075-.277.138-.517.24-.747a3 3 0 0 1 .313-.537c.149-.204.326-.378.529-.58L13.727 4.857c.088-.087.195-.195.297-.282.111-.094.28-.22.512-.296M4.808 16.607c-.245.244-.291.295-.327.343q-.06.084-.103.179c-.025.055-.046.12-.137.454l-.816 2.991 2.992-.815c.334-.091.4-.112.454-.137q.095-.042.179-.103c.048-.036.099-.082.344-.327L17.586 9 15 6.414zM17.293 1.293a1 1 0 0 1 1.414 0l4 4 .068.076a1 1 0 0 1-1.406 1.406l-.076-.068-4-4-.068-.076a1 1 0 0 1 .068-1.338"
    })
  }));
};

var SvgPercentFilled = function SvgPercentFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m4.707 6.293a1 1 0 0 0-1.414 0l-8 8a1 1 0 1 0 1.414 1.414l8-8a1 1 0 0 0 0-1.414M15 13.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-6-6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
    })
  }));
};

var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5.707-4.707a1 1 0 1 1 1.414 1.414l-8 8a1 1 0 1 1-1.414-1.414zM15 13.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-6-6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M4.1 2.878a3 3 0 0 1 2.708 0c.464.235.863.65 1.338 1.126l.195.195c.313.314.584.577.77.863a3 3 0 0 1 0 3.27c-.186.286-.457.549-.77.862l-.108.109-.002.011.014.03.037.076a13.6 13.6 0 0 0 2.652 3.736 13.6 13.6 0 0 0 3.735 2.652l.076.037q.019.009.03.012h.006l.005-.002.11-.106c.313-.313.576-.585.862-.77a3 3 0 0 1 3.27 0c.286.185.55.457.863.77l.539.54c.328.334.606.645.782.993a3 3 0 0 1 0 2.708c-.235.464-.651.862-1.127 1.338l-.157.158c-.5.5-.867.878-1.372 1.162-.55.308-1.34.514-1.971.512-.572-.002-.983-.124-1.53-.28a20.04 20.04 0 0 1-8.717-5.128 20.04 20.04 0 0 1-5.129-8.718c-.155-.546-.278-.958-.28-1.53-.001-.63.205-1.42.513-1.97.284-.505.663-.873 1.162-1.372l.501-.502c.335-.329.647-.606.995-.782m1.805 1.784a1 1 0 0 0-.903 0c-.107.054-.24.17-.826.757l-.158.157c-.56.56-.712.723-.832.938-.14.249-.257.7-.256.985 0 .254.038.407.203.99a18.04 18.04 0 0 0 4.619 7.849 18.04 18.04 0 0 0 7.85 4.618c.582.165.735.203.989.204.285.001.736-.117.985-.257.215-.12.378-.27.938-.83l.157-.159c.587-.587.703-.72.757-.827a1 1 0 0 0 0-.902c-.054-.107-.17-.24-.757-.827l-.194-.195c-.386-.386-.473-.465-.538-.508a1 1 0 0 0-1.091 0c-.066.043-.153.123-.538.508-.093.093-.215.219-.364.325a2.05 2.05 0 0 1-1.723.294c-.173-.05-.314-.12-.42-.17A15.6 15.6 0 0 1 9.52 14.57a15.6 15.6 0 0 1-3.041-4.284c-.051-.106-.12-.246-.171-.419a2.04 2.04 0 0 1 .294-1.723c.106-.149.232-.27.325-.364.385-.385.465-.472.508-.538.215-.331.215-.76 0-1.09-.043-.066-.123-.153-.508-.539L6.73 5.42c-.586-.587-.719-.703-.826-.757m8.235.342.101.015.219.046a6 6 0 0 1 4.475 4.475l.046.219.015.1a1 1 0 0 1-1.953.382l-.024-.1-.069-.29a4 4 0 0 0-2.802-2.801l-.29-.069-.1-.024a1 1 0 0 1 .382-1.953m.02-3.998.421.056a10 10 0 0 1 8.412 8.766 1 1 0 0 1-1.97.324l-.017-.1-.045-.337a8 8 0 0 0-6.685-6.677l-.337-.044-.101-.016A1 1 0 0 1 14.058 1z"
    })
  }));
};

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15 7.309c0-.094 0-.218.014-.344q.016-.152.057-.299c.034-.123.08-.237.116-.323l1.007-2.52c.155-.385.244-.612.293-.779l.006-.024-.024-.003A11 11 0 0 0 15.637 3H8.363c-.414 0-.657 0-.83.017q-.015 0-.025.003l.006.024c.05.167.139.394.293.78l1.007 2.519c.035.086.082.2.116.323q.02.074.034.148l.023.15.012.184.001.16v2.13c0 .168.006.392-.04.614a2 2 0 0 1-.179.508c-.103.201-.245.371-.35.502l-1.57 1.963c-.345.432-.56.702-.696.907q-.013.02-.022.038.02.003.044.007c.244.022.59.023 1.142.023h9.343c.552 0 .898-.001 1.142-.023q.024-.004.043-.007-.009-.018-.021-.038c-.135-.205-.351-.475-.696-.907l-1.57-1.963c-.104-.13-.247-.301-.35-.502a2 2 0 0 1-.179-.508C14.995 9.83 15 9.606 15 9.438zm2 2.13c0 .11 0 .166.002.207v.002l.002.003c.024.033.058.076.128.162l1.57 1.962c.32.4.604.755.802 1.054.187.283.415.685.416 1.169a2 2 0 0 1-.752 1.566c-.379.302-.835.374-1.173.405-.357.032-.81.031-1.323.031H13v6a1 1 0 1 1-2 0v-6H7.33c-.514 0-.968.001-1.324-.031-.338-.031-.794-.103-1.173-.405a2 2 0 0 1-.752-1.566c0-.484.229-.886.416-1.169.198-.299.481-.653.802-1.054l1.57-1.962c.07-.086.104-.13.128-.162L7 9.646c.002-.04.001-.096.001-.208V7.194h-.001V7.19l-.042-.106-1.008-2.52c-.14-.35-.27-.674-.352-.949-.083-.277-.158-.634-.077-1.023a2 2 0 0 1 .852-1.26c.332-.22.692-.281.98-.308C7.637 1 7.987 1 8.363 1h7.274c.376 0 .727 0 1.012.025.288.027.648.088.98.308a2 2 0 0 1 .852 1.26c.081.39.006.746-.077 1.023-.082.275-.213.6-.353.95l-1.008 2.519-.041.106-.001.002L17 7.31z"
    })
  }));
};

var SvgPlusStroke = function SvgPlusStroke(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m.005 4.005a1 1 0 0 1 1 1V11H16a1 1 0 1 1 0 2h-2.995v3.005a1 1 0 1 1-2 0V13H8a1 1 0 1 1 0-2h3.005V8.005a1 1 0 0 1 1-1"
    })
  }));
};

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.005 5.005a1 1 0 0 0-1 1V11H8a1 1 0 1 0 0 2h3.005v3.005l.005.102a1 1 0 0 0 1.99 0l.005-.102V13H16l.102-.005a1 1 0 0 0 0-1.99L16 11h-2.995V8.005a1 1 0 0 0-1-1"
    })
  }));
};

var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M14.8 13c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.027.333.028.73.028 1.184.259-.009.4-.025.52-.057a2 2 0 0 0 1.414-1.414c.06-.223.068-.524.068-1.518v-2.2c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C18.639 8 18.058 8 17.2 8H6.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C3 10.361 3 10.942 3 11.8V14c0 .994.009 1.295.068 1.518a2 2 0 0 0 1.414 1.414c.12.032.26.048.519.057 0-.454.002-.851.03-1.184.032-.396.103-.789.296-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C8.188 13 8.657 13 9.2 13zm-5.6 2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C7.001 16.25 7 16.624 7 17.2v1.6c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h5.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232v-1.6c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 14.8 15zM18 9.5a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2zm-1-4.3c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 14.8 3H9.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C7.001 4.25 7 4.624 7 5.2V6h10zm2 .83q.13.005.252.014c.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052V14c0 .866.008 1.494-.137 2.035a4 4 0 0 1-2.828 2.828c-.308.083-.644.113-1.037.126 0 .464 0 .868-.028 1.206-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H9.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168-.027-.338-.029-.742-.029-1.206-.392-.013-.728-.043-1.036-.126a4 4 0 0 1-2.828-2.828C.992 15.495 1 14.865 1 14v-2.2c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392q.121-.009.252-.015V5.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C8.188 1 8.657 1 9.2 1h5.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-8.99 4a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zM9.894 6.547A4.001 4.001 0 0 1 15.92 10c0 1.53-1.135 2.542-1.945 3.082a8 8 0 0 1-1.686.849l-.035.011-.01.004-.005.001-.002.001L11.92 13l.316.948a1 1 0 1 1-.633-1.896l.016-.006.074-.027a6.05 6.05 0 0 0 1.172-.6c.69-.46 1.055-.95 1.055-1.419v-.002a2 2 0 0 0-3.887-.666 1 1 0 0 1-1.887-.664 4 4 0 0 1 1.748-2.121M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    })
  }));
};

var SvgReducedMobilityObstructedView = function SvgReducedMobilityObstructedView(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 20 20",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm-2.533 19H19v-2.936zm.223-4.66.104.151-.621.449L12.669 19h3.302L19 15.488v-3.823zm-3.917.137.174.117-.214.32a4.5 4.5 0 0 1-1.591 1.455L8.872 19h3.302l3.125-3.622-1.461-2.133zM5.074 19h3.302l1.979-2.293q-.083.027-.168.05a4.5 4.5 0 0 1-2.999-.207zm-3.799 0h3.303l2.26-2.62a4.5 4.5 0 0 1-1.786-1.756zM1 14.919v3.824l3.868-4.481-.01-.02a4.51 4.51 0 0 1 .15-3.968zm7.259.39a2.99 2.99 0 0 0 3.21-1.239l.214-.32.776.518 1.16-1.344-.549-.801h-2.06zm-2.114-1.952q.045.136.103.267c.29.655.808 1.184 1.456 1.49q.083.037.167.07l2.642-3.061h-1.89v-1.636zM1 10.52v3.824L8.357 5.82a1.3 1.3 0 0 1-.096-.484c0-.678.538-1.248 1.226-1.248q.17.001.325.046L12.52 1H9.218zm14.01 1.367 1.46 2.133L19 11.09V7.265zm-4.842-7.59c.33.227.545.611.545 1.039 0 .678-.538 1.247-1.226 1.247-.372 0-.7-.167-.923-.428L6.287 8.794a4.5 4.5 0 0 1 1.054-.585l.525-.205v1.622l-.214.106a3 3 0 0 0-1.532 1.812 3 3 0 0 0-.085 1.365l2.588-2.997v-2.78h1.729v.416h.312L16.315 1h-3.3zm2.355 6.073h1.45l.818 1.195L19 6.69V2.866zm-1.362-2.822h.884V9.3h-1.693v1.07h1.674L19 2.288V1h-2.187zM1 6.12v3.824L8.72 1h-3.3zm0-4.4v3.824L4.923 1h-3.3zm0-.575L1.125 1H1z"
    })
  }));
};

var SvgReducedMobility = function SvgReducedMobility(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 20 20",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zM7.34 8.209a4.51 4.51 0 1 0 5.393 6.705l.214-.32-1.264-.844-.214.32a2.992 2.992 0 0 1-5.22-.446 2.99 2.99 0 0 1 1.403-3.892l.214-.106V8.004zm1.283-1.077v4.99h4.447l2.318 3.385 1.406-1.016-2.821-4.122h-3.621V9.301h1.693V7.548h-1.693v-.416zm.864-3.044c-.688 0-1.226.57-1.226 1.247s.538 1.248 1.226 1.248 1.226-.57 1.226-1.248-.538-1.247-1.226-1.247"
    })
  }));
};

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M20.559 11.899a1 1 0 0 1 .888 1.1 9.49 9.49 0 0 1-4.698 7.229c-4.129 2.383-9.303 1.315-12.182-2.309l-.108.406a1 1 0 1 1-1.932-.518l.733-2.731.031-.098a1 1 0 0 1 1.193-.61l2.732.732a1 1 0 0 1-.518 1.932l-.343-.092a7.501 7.501 0 0 0 13.104-4.153 1 1 0 0 1 1.1-.888M4.54 11.213a1 1 0 0 1-1.988-.212zm2.71-7.44c4.129-2.384 9.303-1.316 12.182 2.307l.109-.405a1 1 0 0 1 1.932.518l-.733 2.732a1 1 0 0 1-1.224.707L16.783 8.9a1 1 0 0 1 .418-1.953l.1.021.343.092A7.502 7.502 0 0 0 4.54 11.213l-1.988-.212A9.49 9.49 0 0 1 7.25 3.773"
    })
  }));
};

var SvgRemoveInput = function SvgRemoveInput(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 8.8c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C18.639 5 18.058 5 17.2 5H9.6c-.644 0-.772.009-.874.038q-.181.052-.33.165c-.086.065-.17.161-.556.677l-4.32 5.76c-.138.183-.21.28-.256.353L3.259 12l.005.007c.047.073.118.17.256.353l4.32 5.76c.387.516.47.612.555.677q.15.112.33.165c.103.03.23.038.875.038h7.6c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zm-4.707-.507a1 1 0 1 1 1.414 1.414L15.414 12l2.293 2.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068L14 13.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L12.586 12l-2.293-2.293-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L14 10.586zM23 15.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H9.6c-.529 0-.989.01-1.424-.115a3 3 0 0 1-.99-.495c-.36-.274-.629-.647-.946-1.07l-4.32-5.76c-.205-.273-.493-.627-.605-1.051a2 2 0 0 1 0-1.018c.112-.424.4-.777.605-1.05L6.24 4.68c.317-.423.586-.796.946-1.07.297-.224.632-.393.99-.495C8.61 2.991 9.07 3 9.6 3h7.6c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.748 1.748c.248.485.346 1.002.392 1.564.045.55.044 1.228.044 2.052z"
    })
  }));
};

var SvgReporting = function SvgReporting(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M2 17.8V3a1 1 0 0 1 2 0v14.8c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024H21a1 1 0 1 1 0 2H6.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C2 18.812 2 18.343 2 17.8m4-.3v-12a1 1 0 0 1 2 0v12a1 1 0 1 1-2 0m4.5 0v-9a1 1 0 1 1 2 0v9a1 1 0 1 1-2 0m4.5 0v-6a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0m4.5 0v-3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0"
    })
  }));
};

var SvgScanQr = function SvgScanQr(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M2 16.2V16a1 1 0 1 1 2 0v.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C6.361 20 6.942 20 7.8 20H8a1 1 0 1 1 0 2h-.2c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C1.999 17.702 2 17.024 2 16.2m18 0V16a1 1 0 1 1 2 0v.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H16a1 1 0 1 1 0-2h.2c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888M3.01 11a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm4.5 0a1 1 0 1 1 0 2H7.5a1 1 0 1 1 0-2zm4.5 0a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zm4.5 0a1 1 0 1 1 0 2h-.01a1 1 0 1 1 0-2zm4.5 0a1 1 0 1 1 0 2H21a1 1 0 1 1 0-2zM2 8v-.2c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.748c.485-.248 1.002-.346 1.564-.392C6.298 1.999 6.976 2 7.8 2H8a1 1 0 1 1 0 2h-.2c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C4 6.361 4 6.942 4 7.8V8a1 1 0 1 1-2 0m18 0v-.2c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C17.639 4 17.058 4 16.2 4H16a1 1 0 1 1 0-2h.2c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.392a4 4 0 0 1 1.749 1.748c.247.485.345 1.002.391 1.564.045.55.044 1.228.044 2.052V8a1 1 0 1 1-2 0"
    })
  }));
};

var SvgSeatFilled = function SvgSeatFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16 0a3 3 0 0 1 3 3v7.362c1.195.692 2 1.984 2 3.464v5.566h-.026A3 3 0 0 1 18 22H3a3 3 0 0 1-2.974-2.608H0v-5.566c0-1.48.805-2.772 2-3.464V3a3 3 0 0 1 3-3zm1 9.81c-2.011.151-3.575 1.97-3.575 4.159v1.044h-5.85v-1.044C7.575 11.78 6.011 9.962 4 9.81v1.54c1.188.148 2.133 1.25 2.133 2.618V17.2h8.733V13.97c0-1.369.946-2.47 2.134-2.617zm-9.74 3.167-.024-.092z"
    })
  }));
};

var SvgSeatFoldableFilled = function SvgSeatFoldableFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zM17 0a2 2 0 0 1 2 2v11H2V2a2 2 0 0 1 2-2z"
    })
  }));
};

var SvgSeatFoldableObstructedView = function SvgSeatFoldableObstructedView(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zM2 20h1v-3H2zm2 0h1v-3H4zm2 0h1v-3H6zm2 0h1v-3H8zm2 0h1v-3h-1zm2 0h1v-3h-1zm2 0h1v-3h-1zm2 0h1v-3h-1zm2 0h1v-3h-1zM17 0a2 2 0 0 1 2 2v11H2V2a2 2 0 0 1 2-2zm-1 11h1V2h-1zm-2 0h1V2h-1zm-2 0h1V2h-1zm-2 0h1V2h-1zm-2 0h1V2H8zm-2 0h1V2H6zm-2 0h1V2H4z"
    })
  }));
};

var SvgSeatFoldableProviderFilled = function SvgSeatFoldableProviderFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19 15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zM17 0a2 2 0 0 1 2 2v11H2V2a2 2 0 0 1 2-2zm-6.5 3c-.527 0-.954.392-.954.875v3.138l-.916-.84a1.02 1.02 0 0 0-1.35 0 .825.825 0 0 0 0 1.237l2.545 2.334A1 1 0 0 0 10.5 10a1 1 0 0 0 .675-.256L13.72 7.41a.825.825 0 0 0 0-1.237 1.02 1.02 0 0 0-1.35 0l-.917.84V3.875c0-.483-.427-.875-.954-.875"
    })
  }));
};

var SvgSeatFoldable = function SvgSeatFoldable(props) {
  return /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("mask", {
      id: "path-1-inside-1_900_824",
      children: /*#__PURE__*/jsx("path", {
        d: "M19 15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zM17 0a2 2 0 0 1 2 2v11H2V2a2 2 0 0 1 2-2z"
      })
    }), /*#__PURE__*/jsx("path", {
      d: "M21 17h2zm-2 5v2zM0 20h-2zm2-5v-2zM19 2h2zm0 11v2h2v-2zM2 13H0v2h2zM2 2H0zm2-2v-2zm15 15v2h4a4 4 0 0 0-4-4zm2 2h-2v3h4v-3zm0 3h-2v4a4 4 0 0 0 4-4zm-2 2v-2H2v4h17zM2 22v-2h-4a4 4 0 0 0 4 4zm-2-2h2v-3h-4v3zm0-3h2v-4a4 4 0 0 0-4 4zm2-2v2h17v-4H2zM17 0v2h4a4 4 0 0 0-4-4zm2 2h-2v11h4V2zm0 11v-2H2v4h17zM2 13h2V2H0v11zM2 2h2v-4a4 4 0 0 0-4 4zm2-2v2h13v-4H4z",
      mask: "url(#path-1-inside-1_900_824)"
    })]
  }));
};

var SvgSeatObstructedView = function SvgSeatObstructedView(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "m3 11.238 1 .102v.012c1.188.147 2.133 1.248 2.133 2.617V17.2h8.733V13.97c0-1.369.946-2.47 2.134-2.617v-.004l1-.114V.768c.613.549 1 1.344 1 2.232v7.362c1.195.692 2 1.984 2 3.464v5.566h-.026A3 3 0 0 1 18 22H3a3 3 0 0 1-2.974-2.608H0v-5.566c0-1.48.805-2.772 2-3.464V3A3 3 0 0 1 3 .768zm6 3.775H8V0h1zm2 0h-1V0h1zm2 0h-1V0h1zm-6-3.237c-.26-.456-.6-.854-1-1.171V0h1zm8-1.172c-.4.317-.74.716-1 1.172V0h1zm-10-.57a3.6 3.6 0 0 0-1-.223V.174A3 3 0 0 1 5 0zM16 0c.351 0 .687.063 1 .174V9.81a3.6 3.6 0 0 0-1 .222z"
    })
  }));
};

var SvgSeatProviderFilled = function SvgSeatProviderFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16 0a3 3 0 0 1 3 3v7.362c1.195.692 2 1.984 2 3.464v5.566h-.026A3 3 0 0 1 18 22H3a3 3 0 0 1-2.974-2.608H0v-5.566c0-1.48.805-2.772 2-3.464V3a3 3 0 0 1 3-3zm1 9.81c-2.011.151-3.575 1.97-3.575 4.159v1.044h-5.85v-1.044C7.575 11.78 6.011 9.962 4 9.81v1.54c1.188.148 2.133 1.25 2.133 2.618V17.2h8.733V13.97c0-1.369.946-2.47 2.134-2.617zm-9.74 3.167-.024-.092zM10.75 4a.75.75 0 0 0-.75.75v2.69l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l2-2a.75.75 0 0 0-1.06-1.06l-.72.72V4.75a.75.75 0 0 0-.75-.75"
    })
  }));
};

var SvgSeatStandingFilled = function SvgSeatStandingFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11"
    })
  }));
};

var SvgSeatStandingObstructedView = function SvgSeatStandingObstructedView(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15.628 1.02c5.512 2.555 7.91 9.094 5.355 14.606s-9.094 7.91-14.606 5.355-7.91-9.094-5.355-14.606C3.052 1.997 7.595-.415 12.141.06h.162v.018c1.122.133 2.244.442 3.325.943M7.302 2.798q-.515.232-1 .526v15.35c.293.178.598.345.916.492l.084.036zm2.006-.635q-.51.097-1.006.252v17.168q.5.16 1.005.257zm-4.005 1.87q-.535.436-1.003.957V17.01q.46.514 1.003.959zm6-2.03a9 9 0 0 0-.996.024l.001 17.948q.498.037.994.02zm1.996.296a9 9 0 0 0-.996-.205v17.811q.505-.075.996-.203zM3.301 6.346a8.99 8.99 0 0 0 0 9.311zm11.486-3.51a9 9 0 0 0-.488-.209v16.745a9 9 0 0 0 1.007-.468V3.098a9 9 0 0 0-.519-.263m1.519 15.436q.526-.383.997-.844V4.572a9 9 0 0 0-.997-.843zm1.996-2.009a8.996 8.996 0 0 0 0-10.526z"
    })
  }));
};

var SvgSeatStandingProviderFilled = function SvgSeatStandingProviderFilled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 6c-.753 0-1.363.56-1.363 1.25v4.482l-1.309-1.199a1.453 1.453 0 0 0-1.929 0 1.178 1.178 0 0 0 0 1.768l3.637 3.333c.256.234.602.366.964.366s.708-.132.964-.366L15.6 12.3a1.178 1.178 0 0 0 0-1.768 1.453 1.453 0 0 0-1.93 0l-1.308 1.2V7.25c0-.69-.61-1.25-1.363-1.25"
    })
  }));
};

var SvgSeatStanding = function SvgSeatStanding(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    pointerEvents: "bounding-box",
    viewBox: "0 0 22 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0m2 0c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11"
    })
  }));
};

var SvgSeat = function SvgSeat(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 21 22",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16 0a3 3 0 0 1 3 3v7.362c1.195.692 2 1.984 2 3.464v5.566h-.026A3 3 0 0 1 18 22H3a3 3 0 0 1-2.974-2.608H0v-5.566c0-1.48.805-2.772 2-3.464V3a3 3 0 0 1 3-3zm1 11.826a2 2 0 0 0-2 2v3.218H6v-3.218a2 2 0 1 0-4 0v5.232l.01.075A1 1 0 0 0 3 20h15a1 1 0 0 0 .99-.867l.01-.075v-5.232a2 2 0 0 0-2-2M5 2a1 1 0 0 0-1 1v6.826a4 4 0 0 1 4 4V15h5v-1.174a4 4 0 0 1 4-4V3a1 1 0 0 0-1-1z"
    })
  }));
};

var SvgSelection = function SvgSelection(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 20 20",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1.56.424c.34-.069.644.012.804.059.21.062.462.162.714.26l13.455 5.301c.2.079.415.163.585.249.144.072.377.202.562.44l.075.11.078.14a1.5 1.5 0 0 1 .088 1.084 1.55 1.55 0 0 1-.47.7c-.141.127-.326.264-.497.393l-1.771 1.327 3.648 2.654c.116.084.255.184.367.281.09.078.207.192.308.349l.094.173.048.121c.1.286.111.597.03.892a1.5 1.5 0 0 1-.315.577c-.095.113-.217.234-.318.336l-3.176 3.175c-.101.102-.222.223-.336.319a1.5 1.5 0 0 1-.577.315 1.5 1.5 0 0 1-1.013-.079 1.5 1.5 0 0 1-.521-.401c-.097-.112-.197-.252-.281-.367l-2.655-3.649-1.327 1.772c-.128.17-.265.355-.393.497-.124.136-.35.365-.7.47a1.5 1.5 0 0 1-1.224-.167 1.55 1.55 0 0 1-.55-.636c-.086-.17-.17-.386-.248-.585L.744 3.079c-.1-.252-.2-.504-.262-.714-.053-.183-.151-.554-.02-.951l.066-.164a1.5 1.5 0 0 1 .885-.787z"
    })
  }));
};

var SvgSendMail = function SvgSendMail(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M2.58 2.447c.34-.053.638.042.796.096.206.071.452.183.696.293L20.79 10.36c.239.107.48.216.668.32.145.083.409.24.595.526l.074.13.067.16a1.5 1.5 0 0 1-.067 1.17c-.183.37-.503.562-.67.656-.186.105-.428.213-.667.32l-16.712 7.52c-.245.11-.491.223-.697.294-.18.063-.544.177-.947.065a1.5 1.5 0 0 1-.995-.9c-.151-.389-.073-.762-.029-.948.05-.212.137-.469.223-.724l2.313-6.912-2.321-6.992c-.085-.254-.17-.51-.22-.722-.044-.185-.12-.559.032-.947l.074-.159c.192-.36.523-.628.92-.738zM5.709 11h4.79l.103.005a1 1 0 0 1 0 1.99L10.5 13H5.733l-2.06 6.15L19.564 12 3.665 4.845z"
    })
  }));
};

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M12.002 1a3.21 3.21 0 0 1 2.935 1.905l.588 1.315.002.005a1.425 1.425 0 0 0 1.45.838l1.43-.152.233-.015A3.21 3.21 0 0 1 21.528 6.5a3.21 3.21 0 0 1-.184 3.496l-.847 1.163a1.43 1.43 0 0 0-.273.841v.005a1.43 1.43 0 0 0 .268.84l.846 1.164a3.21 3.21 0 0 1 .185 3.497v-.001a3.21 3.21 0 0 1-3.12 1.59l-1.43-.153c-.3-.032-.603.033-.864.184l-.002-.001c-.258.15-.463.378-.585.651v.001l-.584 1.315a3.213 3.213 0 0 1-5.77.209l-.103-.21-.583-1.314a1.43 1.43 0 0 0-1.457-.841h.001l-1.43.153h-.001a3.22 3.22 0 0 1-3.12-1.589 3.21 3.21 0 0 1 .185-3.496l.846-1.163.063-.094a1.4 1.4 0 0 0 .206-.634L3.78 12a1.43 1.43 0 0 0-.273-.84L2.66 9.995A3.21 3.21 0 0 1 2.476 6.5l.123-.196a3.21 3.21 0 0 1 2.765-1.408l.232.015 1.434.152c.3.032.604-.033.866-.184.258-.151.463-.38.585-.654v-.002l.584-1.315.103-.209A3.21 3.21 0 0 1 12.002 1M14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-8.231.27a3.43 3.43 0 0 1-.645 1.747l-.847 1.164a1.21 1.21 0 0 0-.07 1.319h.001a1.22 1.22 0 0 0 1.177.6l1.43-.152h.001a3.43 3.43 0 0 1 1.834.315l.24.126.23.144c.519.358.931.852 1.189 1.432l.585 1.314.082.156a1.213 1.213 0 0 0 2.134-.156l.584-1.314.001-.001a3.43 3.43 0 0 1 1.412-1.57h.002a3.43 3.43 0 0 1 2.074-.44h.002l1.43.151h-.002a1.214 1.214 0 0 0 1.34-1.27 1.2 1.2 0 0 0-.231-.649l-.847-1.163-.002-.002a3.43 3.43 0 0 1-.65-2.026c.002-.723.232-1.427.657-2.012l.847-1.164a1.21 1.21 0 0 0 .145-1.16l-.076-.159a1.21 1.21 0 0 0-1.178-.6l-1.43.152a3.43 3.43 0 0 1-2.075-.44l-.003-.002a3.43 3.43 0 0 1-1.41-1.572l-.589-1.314V3.72a1.214 1.214 0 0 0-2.135-.156l-.082.156-.585 1.311v.001A3.43 3.43 0 0 1 8.899 6.61l-.003.001a3.43 3.43 0 0 1-2.075.442v-.001L5.384 6.9a1.21 1.21 0 0 0-1.177.6 1.21 1.21 0 0 0 .07 1.32l.846 1.162v.001c.426.586.655 1.292.655 2.017zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    })
  }));
};

var SvgSwitchHorizontal = function SvgSwitchHorizontal(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 18 20",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1 15h16m0 0-4-4m4 4-4 4m4-14H1m0 0 4-4M1 5l4 4",
      style: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })
  }));
};

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M4.6 2.9 2.9 4.6c-.3.3-.5.5-.6.7s-.2.4-.2.6c-.1.2-.1.4-.1.9v2.8c0 .5 0 .7.1 1 0 .2.1.4.2.6s.3.4.7.7l7.7 7.7c1.2 1.2 1.8 1.8 2.5 2 .6.2 1.2.2 1.9 0s1.3-.8 2.5-2l2.2-2.2c1.2-1.2 1.8-1.8 2-2.5.2-.6.2-1.2 0-1.9s-.8-1.3-2-2.5l-7.7-7.7c-.4-.3-.5-.5-.7-.7-.2-.1-.4-.2-.6-.2-.4.1-.6.1-1.1.1H6.8c-.5 0-.7 0-1 .1-.2 0-.4.1-.6.2zM8.5 8c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5M8 8",
      style: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })
  }));
};

var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15 21v-1.2c0-.857 0-1.439-.037-1.889-.036-.438-.101-.663-.18-.82a2 2 0 0 0-.875-.873c-.156-.08-.38-.145-.82-.18C12.639 16 12.058 16 11.2 16H6.8c-.857 0-1.439 0-1.889.037-.438.036-.663.101-.82.18a2 2 0 0 0-.873.875c-.08.156-.145.38-.18.82C3 18.361 3 18.942 3 19.8V21a1 1 0 1 1-2 0v-1.2c0-.824-.001-1.502.044-2.052.046-.562.144-1.08.392-1.564a4 4 0 0 1 1.748-1.749c.485-.247 1.002-.345 1.564-.391C5.298 13.999 5.976 14 6.8 14h4.4c.824 0 1.502-.001 2.052.044.562.046 1.08.144 1.564.391a4 4 0 0 1 1.748 1.749c.248.485.346 1.002.392 1.564.045.55.044 1.228.044 2.052V21a1 1 0 1 1-2 0M11.5 7.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M18 10V8h-2a1 1 0 1 1 0-2h2V4a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0m-4.5-2.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
    })
  }));
};

var SvgTicketCancelled = function SvgTicketCancelled(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M16.106 1.553a1 1 0 0 1 1.788.894L17.619 3H18.8l.758.004c.232.004.445.01.637.026.395.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.773.298 1.168.031.383.03.852.03 1.395v1.3a1 1 0 0 1-1 1 2.5 2.5 0 0 0 0 5 1 1 0 0 1 1 1v1.3c0 .543.001 1.012-.03 1.395-.033.395-.104.79-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H8.618l-.723 1.447a1 1 0 0 1-1.79-.894L6.382 21H5.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.773-.298-1.168C1 17.812 1 17.343 1 16.8v-1.3a1 1 0 0 1 1-1 2.5 2.5 0 0 0 0-5 1 1 0 0 1-1-1V7.2c0-.543-.001-1.012.03-1.395.033-.395.104-.79.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 3 4.657 3 5.2 3h10.182zM9.618 19H18.8c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232v-.413a4.5 4.5 0 0 1 0-8.775V7.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085a8 8 0 0 0-.506-.021L18.8 5h-2.182zM5.2 5c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 6.25 3 6.624 3 7.2v.412a4.5 4.5 0 0 1 0 8.774v.414c0 .576.001.949.024 1.232.023.271.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.062.422.085.283.023.656.024 1.232.024h2.182l7-14z"
    })
  }));
};

var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M21 7.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 18.8 5H5.2c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422C3.001 6.25 3 6.624 3 7.2v.412a4.501 4.501 0 0 1 0 8.775v.413c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h13.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232v-.413a4.5 4.5 0 0 1 0-8.775zM9 17v-1a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0m0-4.5v-1a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0M9 8V7a1 1 0 0 1 2 0v1a1 1 0 1 1-2 0m14 .5a1 1 0 0 1-1 1 2.5 2.5 0 0 0 0 5 1 1 0 0 1 1 1v1.3c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H5.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C1 17.812 1 17.343 1 16.8v-1.3a1 1 0 0 1 1-1 2.5 2.5 0 0 0 0-5 1 1 0 0 1-1-1V7.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C4.188 3 4.657 3 5.2 3h13.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z"
    })
  }));
};

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M18 7H6v10.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C8.361 21 8.942 21 9.8 21h4.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.031.038-1.888zm-9 9.5v-5a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0m4 0v-5a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0M11.2 3c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422-.02.249-.023.567-.023 1.032h5.998c0-.465-.003-.783-.023-1.032-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 12.8 3zM20 17.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.749c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H9.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C3.999 18.702 4 18.024 4 17.2V7H3a1 1 0 1 1 0-2h4.001c0-.459.002-.86.03-1.195.032-.396.103-.789.296-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C10.188 1 10.657 1 11.2 1h1.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.027.335.029.736.029 1.195H21a1 1 0 1 1 0 2h-1z"
    })
  }));
};

var SvgUnarchive = function SvgUnarchive(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M19.5 2c.417 0 .77-.005 1.085.058a3 3 0 0 1 2.357 2.357c.063.314.058.668.058 1.085s.005.77-.058 1.085A3 3 0 0 1 21 8.828V16.2c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.564a4 4 0 0 1-1.748 1.748c-.485.248-1.002.346-1.564.392-.55.045-1.228.044-2.052.044H8.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564C2.999 17.702 3 17.024 3 16.2V8.828a3 3 0 0 1-1.942-2.243C.995 6.27 1 5.917 1 5.5s-.005-.771.058-1.085a3 3 0 0 1 2.357-2.357C3.73 1.995 4.083 2 4.5 2zM5 16.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18C7.361 20 7.942 20 8.8 20h6.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.032.038-1.888V9H5zm9-3.2a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2zM4.5 4c-.512 0-.623.005-.695.02a1 1 0 0 0-.785.785c-.015.072-.02.182-.02.695s.005.623.02.695a1 1 0 0 0 .785.785l.22.017.038.003h15.873l.039-.003.22-.017a1 1 0 0 0 .785-.785c.015-.072.02-.183.02-.695 0-.513-.005-.623-.02-.695a1 1 0 0 0-.785-.786C20.123 4.005 20.012 4 19.5 4z"
    })
  }));
};

var SvgUnlink = function SvgUnlink(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 12",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M0 6a6 6 0 0 1 6-6h2a1 1 0 0 1 0 2H6a4 4 0 1 0 0 8h2a1 1 0 1 1 0 2H6a6 6 0 0 1-6-6m20 0a4 4 0 0 0-4-4h-1v3h2a1 1 0 1 1 0 2h-2v3h1a4 4 0 0 0 4-4m2 0a6 6 0 0 1-6 6h-1.223A1.78 1.78 0 0 1 13 10.223V7H7a1 1 0 0 1 0-2h6V1.777C13 .796 13.796 0 14.777 0H16a6 6 0 0 1 6 6"
    })
  }));
};

var SvgUnpin = function SvgUnpin(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15.637 1c.376 0 .727 0 1.012.025.288.027.648.088.98.308a2 2 0 0 1 .852 1.26c.081.39.006.746-.077 1.023-.082.275-.213.6-.353.95l-1.008 2.519-.041.106-.001.002L17 7.31v2.13c0 .11 0 .166.002.207v.002l.002.003c.024.033.058.076.128.162l1.57 1.962c.32.4.604.755.802 1.054.187.283.415.685.416 1.169a2 2 0 0 1-.752 1.566c-.379.302-.835.374-1.173.405q-.207.017-.454.022l5.114 4.871a1 1 0 0 1-1.379 1.449L14.65 16H13v6a1 1 0 1 1-2 0v-6H7.329c-.513 0-.967.001-1.323-.031-.339-.031-.794-.103-1.173-.405a2 2 0 0 1-.752-1.566c0-.484.229-.886.416-1.169.197-.299.481-.653.802-1.054l1.57-1.962c.07-.086.104-.13.128-.162l.002-.005v-.933L1.725 3.689a1 1 0 1 1 1.38-1.448l3.094 2.947-.249-.623c-.14-.35-.27-.674-.352-.949-.083-.277-.159-.634-.078-1.023a2 2 0 0 1 .853-1.26c.332-.22.692-.281.98-.308C7.635 1 7.986 1 8.362 1zM8.363 3c-.414 0-.658 0-.83.017q-.015 0-.025.003l.006.024c.05.167.138.394.293.78l1.007 2.519c.035.086.082.2.116.323q.02.074.034.148l.023.15.012.184v.708L15.45 14h1.222c.552 0 .898-.001 1.142-.023q.024-.004.043-.007l-.021-.038c-.136-.205-.351-.475-.696-.907l-1.57-1.963c-.105-.13-.247-.301-.35-.502a2 2 0 0 1-.18-.508c-.045-.222-.04-.446-.04-.614v-2.13c0-.093 0-.217.014-.343q.016-.152.057-.299c.034-.123.08-.237.115-.323l1.008-2.52a11 11 0 0 0 .293-.779l.006-.024-.024-.003A11 11 0 0 0 15.637 3zm.418 7.56c-.103.201-.246.371-.35.502l-1.57 1.963c-.345.432-.56.702-.696.907l-.023.038q.021.003.044.007c.245.022.59.023 1.143.023h5.222l-3.722-3.544q-.022.053-.048.104"
    })
  }));
};

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 22 21",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M15.218 3a1.02 1.02 0 0 0-.29-.714.95.95 0 0 0-.675-.286c-.81 0-1.433.576-1.919 1.476a6 6 0 0 0-.249.524h2.168c.25 0 .493-.1.676-.286A1.02 1.02 0 0 0 15.218 3M2.71 12.121c-.445.742-.568.963-.632 1.184a2 2 0 0 0-.075.681c.014.23.087.472.36 1.292l.208.623c.42 1.262.56 1.627.774 1.882a2 2 0 0 0 .802.578c.31.122.7.139 2.03.139h9.08c1.329 0 1.72-.017 2.03-.139a2 2 0 0 0 .802-.578c.214-.255.353-.62.773-1.882l.208-.623c.274-.82.346-1.062.36-1.292a2 2 0 0 0-.075-.681c-.063-.22-.186-.442-.631-1.184L17.15 9.5H4.284zM4.839 6a10 10 0 0 0-.773.017q.002.01.003.021c.03.153.089.363.193.727l.21.735h12.492l.21-.735c.104-.364.162-.574.191-.727l.003-.021-.02-.002A10 10 0 0 0 16.597 6zm1.384-2.9c.022.234.124.45.284.614A.95.95 0 0 0 7.182 4H9.35a6 6 0 0 0-.248-.524C8.616 2.576 7.992 2 7.182 2c-.25 0-.493.1-.675.286a1.02 1.02 0 0 0-.29.714zM17.218 3c0 .345-.063.682-.175 1.002q.263.002.483.02c.271.025.604.082.92.278a2 2 0 0 1 .81.977l.06.177.032.133c.06.307.027.594-.018.828-.05.261-.14.571-.233.9l-.3 1.041 1.642 2.737c.39.65.685 1.126.838 1.655a4 4 0 0 1 .15 1.364c-.034.55-.22 1.078-.46 1.798l-.206.624c-.367 1.1-.621 1.916-1.137 2.532a4 4 0 0 1-1.604 1.157c-.749.294-1.603.277-2.762.277h-9.08c-1.159 0-2.014.017-2.762-.277a4 4 0 0 1-1.604-1.157c-.516-.616-.77-1.432-1.137-2.532l-.208-.624c-.24-.72-.424-1.248-.46-1.798-.028-.46.023-.921.151-1.364.153-.529.448-1.005.838-1.655l1.64-2.736-.297-1.043c-.094-.328-.183-.638-.233-.899-.052-.268-.088-.604.013-.96A2 2 0 0 1 2.99 4.3c.316-.195.648-.253.92-.278q.22-.018.482-.02a3 3 0 0 1-.16-.707L4.219 3c0-.79.307-1.551.861-2.115A2.95 2.95 0 0 1 7.182 0c1.795 0 2.907 1.22 3.535 2.273C11.344 1.22 12.457 0 14.253 0c.792 0 1.548.32 2.102.885A3.02 3.02 0 0 1 17.219 3"
    })
  }));
};

var SvgXCards = function SvgXCards(props) {
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    viewBox: "0 0 55 41",
    className: "mpd-icon"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M45.12 0H2.88C2.116.001 1.384.339.844.938.304 1.538.001 2.351 0 3.2v25.6c0 .848.305 1.662.844 2.262.54.6 1.272.937 2.036.938H4v-2.133H2.88c-.53 0-.96-.478-.96-1.067V3.2c0-.59.43-1.066.96-1.067h42.24c.53 0 .96.478.96 1.067V5H48V3.2c0-.849-.305-1.662-.844-2.262-.54-.6-1.272-.937-2.036-.938M29.416 29.128l1.031 1.128-1.128 1.032 1.032 1.128-1.128 1.031-1.032-1.128-1.128 1.032-1.031-1.128 1.128-1.032-1.032-1.128 1.128-1.031 1.032 1.128zm-6.186-.648-2.505-2.74-2.74 2.505-2.505-2.74-2.74 2.505 2.505 2.74-2.74 2.505 2.505 2.74 2.74-2.505 2.505 2.74 2.74-2.505-2.505-2.74zM9.88 9h42.24c.764 0 1.496.339 2.036.938.54.6.843 1.413.844 2.262v25.6c0 .849-.305 1.662-.844 2.262-.54.6-1.272.937-2.036.938H9.88c-.764 0-1.496-.339-2.036-.938A3.4 3.4 0 0 1 7 37.8V12.2c0-.848.305-1.662.844-2.262.54-.6 1.272-.937 2.036-.938m42.24 29.867c.53 0 .96-.478.96-1.067V12.2c0-.589-.43-1.066-.96-1.067H9.88c-.53 0-.96.478-.96 1.067v25.6c0 .589.43 1.066.96 1.067zm-11.615-11.96a4.8 4.8 0 0 1 2.81-.906c1.506-.001 2.92.694 3.8 1.867a4.35 4.35 0 0 1 .644 4.053c-.476 1.372-1.61 2.44-3.048 2.87a4.84 4.84 0 0 1-4.207-.697 4.83 4.83 0 0 1-3.255.887 4.76 4.76 0 0 1-3.028-1.45A4.4 4.4 0 0 1 33 30.5c0-1.121.436-2.202 1.222-3.03a4.76 4.76 0 0 1 3.028-1.45 4.83 4.83 0 0 1 3.255.887m-1.77 4.49a3.815 3.815 0 0 1 0-1.795l.006-.025q.06-.272.156-.536l.022-.063q.018-.056.04-.11.125-.315.298-.608a2.9 2.9 0 0 0-1.93-.437c-.677.084-1.3.402-1.75.895s-.7 1.126-.7 1.782.25 1.29.7 1.782c.45.493 1.073.812 1.75.895a2.9 2.9 0 0 0 1.93-.437 4.5 4.5 0 0 1-.299-.608q-.022-.056-.04-.112l-.02-.06a4 4 0 0 1-.157-.537zm2.595 1.01c.527.506 1.24.79 1.985.793a2.84 2.84 0 0 0 2.361-1.234c.518-.77.594-1.74.201-2.575s-1.2-1.422-2.144-1.558a2.87 2.87 0 0 0-2.525.886 3 3 0 0 0-.3.396 2.7 2.7 0 0 0-.357.903 2.5 2.5 0 0 0-.047.482c.002.716.3 1.401.826 1.907M27.364 16H14.636c-.351 0-.636.672-.636 1.5s.285 1.5.636 1.5h12.728c.351 0 .636-.672.636-1.5s-.285-1.5-.636-1.5",
      clipRule: "evenodd"
    })
  }));
};

// generated file, do not edit

function getIconTag(icon) {
  /* eslint-disable no-nested-ternary */
  // prettier-ignore
  var iconTag = icon === 'access' ? SvgAccess : icon === 'action' ? SvgAction : icon === 'agenda-time' ? SvgAgendaTime : icon === 'agenda' ? SvgAgenda : icon === 'archive' ? SvgArchive : icon === 'arrow-down' ? SvgArrowDown : icon === 'arrow-left' ? SvgArrowLeft : icon === 'arrow-right' ? SvgArrowRight : icon === 'arrow-top' ? SvgArrowTop : icon === 'bell' ? SvgBell : icon === 'bookmark-check' ? SvgBookmarkCheck : icon === 'building' ? SvgBuilding : icon === 'cart' ? SvgCart : icon === 'cash-drawer' ? SvgCashDrawer : icon === 'cash-in' ? SvgCashIn : icon === 'cash-out' ? SvgCashOut : icon === 'check-filled' ? SvgCheckFilled : icon === 'check-stroke' ? SvgCheckStroke : icon === 'check' ? SvgCheck : icon === 'clock-fast-forward' ? SvgClockFastForward : icon === 'clock-stroke' ? SvgClockStroke : icon === 'coins-swap' ? SvgCoinsSwap : icon === 'coins' ? SvgCoins : icon === 'copy' ? SvgCopy : icon === 'credit-card-refresh' ? SvgCreditCardRefresh : icon === 'crm' ? SvgCrm : icon === 'cross-filled' ? SvgCrossFilled : icon === 'cross-stroke' ? SvgCrossStroke : icon === 'cross' ? SvgCross : icon === 'cut' ? SvgCut : icon === 'disallow' ? SvgDisallow : icon === 'download' ? SvgDownload : icon === 'drag' ? SvgDrag : icon === 'duplicate' ? SvgDuplicate : icon === 'earth' ? SvgEarth : icon === 'exclamation' ? SvgExclamation : icon === 'external-provider-filled' ? SvgExternalProviderFilled : icon === 'external-provider' ? SvgExternalProvider : icon === 'eye-closed' ? SvgEyeClosed : icon === 'eye' ? SvgEye : icon === 'faq' ? SvgFaq : icon === 'favorite' ? SvgFavorite : icon === 'filter' ? SvgFilter : icon === 'folder-filled' ? SvgFolderFilled : icon === 'folder' ? SvgFolder : icon === 'geopoint' ? SvgGeopoint : icon === 'gift' ? SvgGift : icon === 'graduation-hat' ? SvgGraduationHat : icon === 'home' ? SvgHome : icon === 'hourglass' ? SvgHourglass : icon === 'id' ? SvgId : icon === 'image' ? SvgImage : icon === 'link' ? SvgLink : icon === 'list' ? SvgList : icon === 'logo' ? SvgLogo : icon === 'logout' ? SvgLogout : icon === 'long-arrow-down' ? SvgLongArrowDown : icon === 'long-arrow-left' ? SvgLongArrowLeft : icon === 'long-arrow-right' ? SvgLongArrowRight : icon === 'long-arrow-top' ? SvgLongArrowTop : icon === 'magnifying-glass' ? SvgMagnifyingGlass : icon === 'mail' ? SvgMail : icon === 'minus-stroke' ? SvgMinusStroke : icon === 'minus' ? SvgMinus : icon === 'option' ? SvgOption : icon === 'parameter' ? SvgParameter : icon === 'participant-filled' ? SvgParticipantFilled : icon === 'participant' ? SvgParticipant : icon === 'payment-card' ? SvgPaymentCard : icon === 'pen-square' ? SvgPenSquare : icon === 'pen' ? SvgPen : icon === 'percent-filled' ? SvgPercentFilled : icon === 'percent' ? SvgPercent : icon === 'phone' ? SvgPhone : icon === 'pin' ? SvgPin : icon === 'plus-stroke' ? SvgPlusStroke : icon === 'plus' ? SvgPlus : icon === 'printer' ? SvgPrinter : icon === 'question-mark' ? SvgQuestionMark : icon === 'reduced-mobility-obstructed-view' ? SvgReducedMobilityObstructedView : icon === 'reduced-mobility' ? SvgReducedMobility : icon === 'refresh' ? SvgRefresh : icon === 'remove-input' ? SvgRemoveInput : icon === 'reporting' ? SvgReporting : icon === 'scan-qr' ? SvgScanQr : icon === 'seat-filled' ? SvgSeatFilled : icon === 'seat-foldable-filled' ? SvgSeatFoldableFilled : icon === 'seat-foldable-obstructed-view' ? SvgSeatFoldableObstructedView : icon === 'seat-foldable-provider-filled' ? SvgSeatFoldableProviderFilled : icon === 'seat-foldable' ? SvgSeatFoldable : icon === 'seat-obstructed-view' ? SvgSeatObstructedView : icon === 'seat-provider-filled' ? SvgSeatProviderFilled : icon === 'seat-standing-filled' ? SvgSeatStandingFilled : icon === 'seat-standing-obstructed-view' ? SvgSeatStandingObstructedView : icon === 'seat-standing-provider-filled' ? SvgSeatStandingProviderFilled : icon === 'seat-standing' ? SvgSeatStanding : icon === 'seat' ? SvgSeat : icon === 'selection' ? SvgSelection : icon === 'send-mail' ? SvgSendMail : icon === 'settings' ? SvgSettings : icon === 'switch-horizontal' ? SvgSwitchHorizontal : icon === 'tag' ? SvgTag : icon === 'team' ? SvgTeam : icon === 'ticket-cancelled' ? SvgTicketCancelled : icon === 'ticket' ? SvgTicket : icon === 'trash' ? SvgTrash : icon === 'unarchive' ? SvgUnarchive : icon === 'unlink' ? SvgUnlink : icon === 'unpin' ? SvgUnpin : icon === 'wallet' ? SvgWallet : icon === 'x-cards' ? SvgXCards : null;
  /* eslint-enable no-nested-ternary */

  return iconTag;
}

var _excluded$9 = ["icon", "width", "height", "className"];
function MpdIcon(_ref) {
  var icon = _ref.icon,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '16' : _ref$width,
    height = _ref.height,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var mpdIconClassName = "mpd-icon mpd-icon--".concat(icon);
  var allClassName = className ? "".concat(mpdIconClassName, " ").concat(className) : mpdIconClassName;
  var IconTag = getIconTag(icon);
  if (!IconTag) {
    return null;
  }
  return /*#__PURE__*/jsx(IconTag, _objectSpread2({
    width: width,
    height: height || width,
    className: allClassName,
    style: {
      minWidth: width
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest));
}

var _excluded$8 = ["className", "children", "active", "selected", "leftBorderColor"];
var MpdCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    leftBorderColor = _ref.leftBorderColor,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var classnames = cn('mpd-card', className, {
    active: active,
    selected: selected
  });
  var leftBorderSelectedStyle = leftBorderColor && selected ? {
    borderColor: leftBorderColor
  } : {};
  return /*#__PURE__*/jsxs("div", _objectSpread2(_objectSpread2({
    ref: ref,
    className: classnames,
    style: leftBorderSelectedStyle
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), {}, {
    children: [leftBorderColor && /*#__PURE__*/jsx("div", {
      className: "left-border",
      style: {
        backgroundColor: leftBorderColor
      }
    }), children]
  }));
});

var _excluded$7 = ["external", "children", "className"];
function MpdLinkCard(_ref) {
  var _ref$external = _ref.external,
    external = _ref$external === void 0 ? false : _ref$external,
    children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var classnames = cn('mpd-card mpd-card--link active', className, {
    external: external
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx("div", _objectSpread2(_objectSpread2({
      className: classnames
    }, props), {}, {
      children: children
    }))
  );
}

function MpdLoader(_ref) {
  var className = _ref.className,
    align = _ref.align,
    size = _ref.size;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var loaderClassNames = cn('mpd-loader', !isVisible && 'mpd-loader--hidden', size && "mpd-loader--size-".concat(size));
  var hasContainerClassName = !!className;
  useEffect(function () {
    var currentTimeout = window.setTimeout(function () {
      setIsVisible(true);
    }, 100);
    return function () {
      window.clearTimeout(currentTimeout || 0);
    };
  }, []);
  if (align || hasContainerClassName) {
    var containerClassNames = cn('mpd-loader-container', className, align && "mpd-loader-container--".concat(align));
    return /*#__PURE__*/jsx("div", {
      className: containerClassNames,
      children: /*#__PURE__*/jsx("div", {
        className: loaderClassNames
      })
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: loaderClassNames
  });
}

// declare your configuration
var projectName = 'makeup';
var namespaceList = ['messages'];
var defaultNamespace = 'messages';
var languageList = ['fr', 'en', 'de'];
var defaultLanguage = 'fr';

// This function load the local JSON files in case the translation server is down
// We need to keep the full path name and do not use template strings as rollup wont resolve path
function backendLoader(language, namespace) {
  if (namespace !== 'messages') {
    throw new Error('Namespace must be "messages"');
  }
  switch (language) {
    case 'fr':
      return import('./messages-bRiqwTyI.js');
    case 'en':
      return import('./messages-D6qt2enF.js');
    case 'de':
      return import('./messages-DuPsmqs4.js');
    default:
      return Promise.reject(new Error("Do not handle locale ".concat(language)));
  }
}
var _createI18nPack = createI18nPack(projectName, namespaceList, defaultNamespace, languageList, defaultLanguage, backendLoader, {
    useHttpBackend: false
  }),
  useTranslation = _createI18nPack.useTranslation;

function MpdBadge(_ref) {
  var value = _ref.value,
    children = _ref.children,
    color = _ref.color;
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-badge",
    children: [children, value > 0 && /*#__PURE__*/jsx("sup", {
      className: "mpd-badge__count",
      style: {
        backgroundColor: color
      },
      children: value
    })]
  });
}

function MpdFilters(_ref) {
  var inputElement = _ref.inputElement,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    className = _ref.className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? null : _ref$onOpen,
    _ref$sortElement = _ref.sortElement,
    sortElement = _ref$sortElement === void 0 ? null : _ref$sortElement,
    _ref$activeFilterCoun = _ref.activeFilterCount,
    activeFilterCount = _ref$activeFilterCoun === void 0 ? 0 : _ref$activeFilterCoun,
    _ref$triggerModal = _ref.triggerModal,
    triggerModal = _ref$triggerModal === void 0 ? false : _ref$triggerModal,
    onButtonClick = _ref.onButtonClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    moreFiltersOpened = _useState2[0],
    setMoreFiltersOpened = _useState2[1];
  var hasMoreFilters = triggerModal || !!children;
  var filtersRef = useRef(null);
  var btnRef = useRef(null);
  var handleSearch = function handleSearch(event) {
    var value = event.target.value;
    if (onChange) {
      onChange(value);
    }
  };
  var toggleMoreFilters = function toggleMoreFilters() {
    if (onOpen) {
      onOpen(!moreFiltersOpened);
    }
    setMoreFiltersOpened(!moreFiltersOpened);
  };
  var renderInput = function renderInput() {
    if (inputElement) {
      return inputElement;
    }
    if (!inputElement && !onChange) {
      throw new Error("`onChange` prop supplied to MpdFilters component should be a function, or you need to pass a custom `inputElement`.");
    }
    return /*#__PURE__*/jsx("input", {
      type: "text",
      placeholder: placeholder,
      onChange: handleSearch
    });
  };
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var _filtersRef$current, _btnRef$current;
      if (!(event.target instanceof Node) || document.contains(event.target) && !((_filtersRef$current = filtersRef.current) !== null && _filtersRef$current !== void 0 && _filtersRef$current.contains(event.target)) && !((_btnRef$current = btnRef.current) !== null && _btnRef$current !== void 0 && _btnRef$current.contains(event.target))) {
        if (onOpen) {
          onOpen(false);
        }
        setMoreFiltersOpened(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [onOpen]);
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-filters', {
      'mpd-filters--with-more-filters': hasMoreFilters || !!sortElement
    }, className),
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    "aria-hidden": "true",
    children: [/*#__PURE__*/jsxs("div", {
      className: "mpd-filters__container",
      children: [/*#__PURE__*/jsxs("div", {
        className: "mpd-filters__search",
        children: [/*#__PURE__*/jsx(MpdIcon, {
          icon: "magnifying-glass",
          height: "24",
          width: "24",
          className: "mpd-filters__search-icon"
        }), renderInput()]
      }), hasMoreFilters && /*#__PURE__*/jsx("button", {
        type: "button",
        className: "mpd-btn mpd-btn--link mpd-btn--icon-only mpd-filters__more",
        onClick: triggerModal ? onButtonClick : toggleMoreFilters,
        title: t('filters.see_more_filters'),
        ref: btnRef,
        children: /*#__PURE__*/jsx(MpdBadge, {
          value: activeFilterCount,
          children: /*#__PURE__*/jsx(MpdIcon, {
            icon: moreFiltersOpened ? 'cross' : 'filter',
            height: "24",
            width: "24"
          })
        })
      }), sortElement]
    }), hasMoreFilters && /*#__PURE__*/jsx("div", {
      ref: filtersRef,
      className: cn('sub-filters', moreFiltersOpened && 'sub-filters--open'),
      children: children
    })]
  });
}

function MpdFiltersActiveItem(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/jsxs(MpdCard, {
    active: true,
    className: "mpd-filters-active-item",
    onClick: onClick,
    children: [children, /*#__PURE__*/jsx(MpdIcon, {
      icon: "cross",
      width: "12",
      className: "mpd-color-blue ml1"
    })]
  });
}

var _excluded$6 = ["buttonCustom", "children", "hover", "displayOnLeft", "className", "icon", "noIcon", "iconClassName", "iconSize", "label", "labelClassName", "action", "keepOpen", "disabled"];
var TIMEOUT_DELAY = 500;
var MAX_POPOVER_SIZE = 250;
function MpdPopover(_ref) {
  var buttonCustom = _ref.buttonCustom,
    children = _ref.children,
    _ref$hover = _ref.hover,
    hover = _ref$hover === void 0 ? false : _ref$hover,
    _ref$displayOnLeft = _ref.displayOnLeft,
    displayOnLeft = _ref$displayOnLeft === void 0 ? false : _ref$displayOnLeft,
    className = _ref.className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'action' : _ref$icon,
    _ref$noIcon = _ref.noIcon,
    noIcon = _ref$noIcon === void 0 ? false : _ref$noIcon,
    iconClassName = _ref.iconClassName,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? '20' : _ref$iconSize,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    action = _ref.action,
    _ref$keepOpen = _ref.keepOpen,
    keepOpen = _ref$keepOpen === void 0 ? false : _ref$keepOpen,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var timeout;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayAbove = _useState4[0],
    setDisplayAbove = _useState4[1];
  var containerRef = useRef(null);
  var classnames = cn('mpd-popover', buttonCustom ? 'h100 w100' : 'p2', className, {
    'mpd-popover--above': displayAbove,
    'mpd-popover--left': displayOnLeft,
    'mpd-popover--disabled': disabled
  });
  var handleClose = function handleClose(event) {
    event === null || event === void 0 || event.stopPropagation();
    if (disabled) {
      return;
    }
    timeout = window.setTimeout(function () {
      return setOpened(false);
    }, TIMEOUT_DELAY);
  };
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    if (keepOpen) {
      return;
    }
    setOpened(false);
  };
  var handleOpen = function handleOpen(event) {
    var _containerRef$current;
    event.stopPropagation();
    event.preventDefault();
    if (disabled) {
      return;
    }
    var topPosition = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect().top;
    setOpened(true);
    setDisplayAbove(topPosition ? window.innerHeight - topPosition < MAX_POPOVER_SIZE : false);
  };
  var handleEnter = function handleEnter(event) {
    if (disabled) {
      return;
    }
    if (opened) {
      clearTimeout(timeout);
    }
    if (hover) {
      handleOpen(event);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (disabled) {
      return;
    }
    if (matchKeyEvent(event.nativeEvent, KEY_CODES.enter) || matchKeyEvent(event.nativeEvent, KEY_CODES.up) || matchKeyEvent(event.nativeEvent, KEY_CODES.down)) {
      setOpened(true);
    }
  };
  return /*#__PURE__*/jsxs("div", _objectSpread2(_objectSpread2({
    ref: containerRef,
    className: classnames,
    onClick: handleOpen,
    onKeyDown: handleKeyDown,
    onMouseEnter: handleEnter,
    onMouseLeave: handleClose,
    role: "button",
    tabIndex: 0
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), {}, {
    children: [label && !buttonCustom && /*#__PURE__*/jsx("span", {
      className: cn('mpd-popover__label', labelClassName),
      children: label
    }), buttonCustom, !noIcon && !buttonCustom && /*#__PURE__*/jsx(MpdIcon, {
      icon: icon,
      width: iconSize,
      className: cn('mpd-popover__action-trigger', iconClassName)
    }), opened && /*#__PURE__*/jsx("div", {
      className: "mpd-popover__content ".concat(buttonCustom && 'mpd-popover__content--large'),
      children: /*#__PURE__*/jsxs(MpdCard, {
        onClick: handleClick,
        className: "actived",
        children: [/*#__PURE__*/jsx("div", {
          className: "list",
          children: children
        }), action && /*#__PURE__*/jsx("div", {
          className: "mpd-popover__action",
          children: action
        })]
      })
    })]
  }));
}

var MENU_ACTION = /*#__PURE__*/function (MENU_ACTION) {
  MENU_ACTION["OPEN"] = "OPEN";
  MENU_ACTION["FOCUS"] = "FOCUS";
  MENU_ACTION["SELECT"] = "SELECT";
  MENU_ACTION["CLOSE"] = "CLOSE";
  return MENU_ACTION;
}({});
var initialState = {
  position: {
    top: 0,
    bottom: 0,
    left: 0
  },
  width: undefined,
  navigationStack: []
};
var BASE_INDEX = 0;
function reducer$1(state, action) {
  switch (action.type) {
    case MENU_ACTION.OPEN:
      {
        // Set default navigation state when the menu is opened
        return _objectSpread2(_objectSpread2({}, state), {}, {
          position: action.position ? {
            top: action.position.top,
            bottom: action.position.bottom,
            left: action.position.left
          } : state.position,
          width: action.width || state.width,
          // Reset the stack and focus the first item
          navigationStack: [{
            focusIndex: BASE_INDEX
          }]
        });
      }
    case MENU_ACTION.FOCUS:
      {
        var level = action.level,
          index = action.index;

        // Create a new stack to preserve immutability
        var updatedStack = _toConsumableArray(state.navigationStack);

        // Define the focused item index at the current level
        updatedStack[level] = {
          focusIndex: index
        };

        // Remove all the next levels (after the current sub-level)
        var trimmedStack = updatedStack.slice(0, level + 1);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          navigationStack: trimmedStack
        });
      }
    case MENU_ACTION.SELECT:
      {
        var _level = action.level,
          _index = action.index,
          setDefaultFocus = action.setDefaultFocus;
        var subLevel = _level + 1;

        // Create a new stack to preserve immutability
        var _updatedStack = _toConsumableArray(state.navigationStack);

        // Define the selected item current index at the current level
        _updatedStack[_level] = {
          focusIndex: _index,
          activeIndex: _index
        };

        // Create a new level to display the sub-menu
        _updatedStack[subLevel] = setDefaultFocus ? {
          focusIndex: BASE_INDEX
        } : {};

        // Remove all the next levels (after the current sub-level)
        var _trimmedStack = _updatedStack.slice(0, subLevel + 1);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          navigationStack: _trimmedStack
        });
      }
    case MENU_ACTION.CLOSE:
      // Reset the navigation stack
      return _objectSpread2(_objectSpread2({}, state), {}, {
        navigationStack: []
      });
    default:
      // @ts-expect-error -- let the runtime fail in this case
      throw new Error("action type ".concat(action.type, " is not authorized"));
  }
}
function useMenuReducer() {
  var _useReducer = useReducer(reducer$1, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return [state, dispatch];
}

function ItemCheckbox(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/jsx(MpdCheckbox, {
    checked: item.checked,
    onChange: item.onChange,
    className: "item-label",
    children: item.label
  });
}

var MENU_ITEM_TYPE = /*#__PURE__*/function (MENU_ITEM_TYPE) {
  MENU_ITEM_TYPE["CHECKBOX"] = "checkbox";
  MENU_ITEM_TYPE["LINK"] = "link";
  MENU_ITEM_TYPE["BUTTON"] = "button";
  MENU_ITEM_TYPE["SUBMENU"] = "submenu";
  return MENU_ITEM_TYPE;
}({});

function ItemSubMenu(_ref) {
  var _state$navigationStac;
  var item = _ref.item,
    level = _ref.level,
    index = _ref.index,
    state = _ref.state,
    dispatch = _ref.dispatch,
    isBottomDisplayed = _ref.isBottomDisplayed,
    itemOffsetTop = _ref.itemOffsetTop;
  var subLevel = level + 1;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "item-label",
      children: item.label
    }), /*#__PURE__*/jsx(MpdIcon, {
      icon: "arrow-right",
      className: "mpd-color-blue mr2",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      focusable: "false"
    }), /*#__PURE__*/jsx("ul", {
      role: "menu",
      className: cn('mpd-card actived mpd-menu mpd-menu--children', {
        'mpd-menu--children-overflow': !item.items.some(function (child) {
          return child.type === MENU_ITEM_TYPE.SUBMENU;
        }),
        'mpd-menu--visible': ((_state$navigationStac = state.navigationStack[level]) === null || _state$navigationStac === void 0 ? void 0 : _state$navigationStac.activeIndex) === index && !!state.navigationStack[subLevel],
        'mpd-menu--bottom': isBottomDisplayed
      }),
      style: {
        transform: !isBottomDisplayed ? "translateY(".concat(itemOffsetTop, "px)") : undefined,
        bottom: isBottomDisplayed ? "calc(100% - ".concat(itemOffsetTop, "px)") : undefined
      },
      children: item.items.map(function (child, subIndex) {
        var _state$navigationStac2, _state$navigationStac3, _state$navigationStac4;
        return /*#__PURE__*/jsx(MpdMenuItem, {
          item: child,
          level: subLevel,
          index: subIndex,
          state: state,
          dispatch: dispatch,
          isFocused: ((_state$navigationStac2 = state.navigationStack[level]) === null || _state$navigationStac2 === void 0 ? void 0 : _state$navigationStac2.activeIndex) === index && ((_state$navigationStac3 = state.navigationStack[subLevel]) === null || _state$navigationStac3 === void 0 ? void 0 : _state$navigationStac3.focusIndex) === subIndex && ((_state$navigationStac4 = state.navigationStack[subLevel]) === null || _state$navigationStac4 === void 0 ? void 0 : _state$navigationStac4.activeIndex) === undefined
        }, child.label);
      })
    })]
  });
}

function ItemLink(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/jsx("a", {
    href: item.href,
    className: "item-label",
    "aria-label": item.label,
    children: item.label
  });
}

function ItemButton(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/jsx("button", {
    type: "button",
    onClick: item.onClick,
    className: "item-label",
    "aria-label": item.label,
    children: item.label
  });
}

var MENU_ITEM_MAX_HEIGHT = 280; // Value from menu.scss

function MpdMenuItem(_ref) {
  var _state$navigationStac;
  var item = _ref.item,
    level = _ref.level,
    index = _ref.index,
    state = _ref.state,
    dispatch = _ref.dispatch,
    isFocused = _ref.isFocused;
  var itemRef = useRef(null);
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    if (item.type === MENU_ITEM_TYPE.SUBMENU) {
      dispatch({
        type: MENU_ACTION.SELECT,
        level: level,
        index: index
      });
    }
    if (item.type === MENU_ITEM_TYPE.LINK) {
      dispatch({
        type: MENU_ACTION.CLOSE
      });
    }
  };
  var handleFocus = function handleFocus() {
    if (!state.navigationStack.length && level === 0 && index === 0) {
      // If the menu is already opened by `popup` prop
      // we need to set the focus on the first item after a key Tab press
      dispatch({
        type: MENU_ACTION.OPEN
      });
    }
  };
  useEffect(function () {
    if (!itemRef.current) {
      return;
    }
    if (isFocused) {
      itemRef.current.focus();
    }
  }, [isFocused]);
  var renderChildren = function renderChildren() {
    var type = item.type;
    switch (type) {
      case MENU_ITEM_TYPE.SUBMENU:
        {
          var _itemRef$current$getB, _itemRef$current, _itemRef$current$offs, _itemRef$current2, _itemRef$current$offs2, _itemRef$current3;
          var isBottomDisplayed = window.innerHeight - ((_itemRef$current$getB = (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 ? void 0 : _itemRef$current.getBoundingClientRect().bottom) !== null && _itemRef$current$getB !== void 0 ? _itemRef$current$getB : 0) < MENU_ITEM_MAX_HEIGHT;
          var offsetTop = (_itemRef$current$offs = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.offsetTop) !== null && _itemRef$current$offs !== void 0 ? _itemRef$current$offs : 0;
          var offsetHeight = (_itemRef$current$offs2 = (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 ? void 0 : _itemRef$current3.offsetHeight) !== null && _itemRef$current$offs2 !== void 0 ? _itemRef$current$offs2 : 0;
          return /*#__PURE__*/jsx(ItemSubMenu, {
            item: item,
            level: level,
            index: index,
            state: state,
            dispatch: dispatch,
            isBottomDisplayed: isBottomDisplayed,
            itemOffsetTop: isBottomDisplayed ? offsetTop + offsetHeight : offsetTop
          });
        }
      case MENU_ITEM_TYPE.CHECKBOX:
        return /*#__PURE__*/jsx(ItemCheckbox, {
          item: item
        });
      case MENU_ITEM_TYPE.LINK:
        return /*#__PURE__*/jsx(ItemLink, {
          item: item
        });
      case MENU_ITEM_TYPE.BUTTON:
        return /*#__PURE__*/jsx(ItemButton, {
          item: item
        });
      default:
        throw new Error("Unknown item type ".concat(type, ". This should not happen."));
    }
  };
  return /*#__PURE__*/jsx("li", {
    ref: itemRef,
    className: cn('mpd-menu__item flex-row', {
      'mpd-menu__item--actived': ((_state$navigationStac = state.navigationStack[level]) === null || _state$navigationStac === void 0 ? void 0 : _state$navigationStac.activeIndex) === index,
      'mpd-menu__item--has-children': !!item.items
    }),
    onClick: handleClick
    // onKeyDown is required for accessibility but not used because
    // the event is listened to on MpdMenu
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ,
    onKeyDown: function onKeyDown() {},
    onFocus: handleFocus,
    role: "menuitem",
    tabIndex: 0,
    children: renderChildren()
  });
}

function useMpdMenuAccessibility(items, state, dispatch) {
  var lastStackWithFocus = state.navigationStack.findLast(function (stack) {
    return stack.focusIndex !== undefined;
  });
  var currentLevel = state.navigationStack.findLastIndex(function (stack) {
    return stack.focusIndex !== undefined;
  });
  var previousStack = state.navigationStack[currentLevel - 1];
  var onArrowDown = useCallback(function (event) {
    event.preventDefault();
    if ((lastStackWithFocus === null || lastStackWithFocus === void 0 ? void 0 : lastStackWithFocus.focusIndex) === undefined) {
      return;
    }
    var currentItem = previousStack !== null && previousStack !== void 0 && previousStack.focusIndex ? items[previousStack.focusIndex] : undefined;
    dispatch({
      type: MENU_ACTION.FOCUS,
      level: currentLevel,
      index: Math.min(lastStackWithFocus.focusIndex + 1, (currentItem !== null && currentItem !== void 0 && currentItem.items ? currentItem.items : items).length - 1)
    });
  }, [currentLevel, dispatch, items, lastStackWithFocus, previousStack]);
  var onArrowUp = useCallback(function (event) {
    event.preventDefault();
    if ((lastStackWithFocus === null || lastStackWithFocus === void 0 ? void 0 : lastStackWithFocus.focusIndex) === undefined) {
      return;
    }
    dispatch({
      type: MENU_ACTION.FOCUS,
      level: currentLevel,
      index: Math.max(lastStackWithFocus.focusIndex - 1, 0)
    });
  }, [currentLevel, dispatch, lastStackWithFocus]);
  var onArrowLeft = useCallback(function (event) {
    if (!previousStack) {
      return;
    }
    event.preventDefault();
    if (typeof previousStack.activeIndex === 'undefined') {
      throw new Error('Always have an active index. This should not happen.');
    }
    dispatch({
      type: MENU_ACTION.FOCUS,
      level: Math.max(currentLevel - 1, 0),
      index: previousStack.activeIndex
    });
  }, [currentLevel, dispatch, previousStack]);
  var onEnter = useCallback(function (event) {
    event.preventDefault();
    if ((lastStackWithFocus === null || lastStackWithFocus === void 0 ? void 0 : lastStackWithFocus.focusIndex) === undefined) {
      return;
    }
    var itemHasChildren = hasChildren(items, state.navigationStack);
    if (!itemHasChildren) {
      if (event.target instanceof Element) {
        var interactiveElement = event.target.querySelector('input, button, select, a, textarea');
        if (interactiveElement instanceof HTMLInputElement) {
          interactiveElement.click();
        }
      }
      return;
    }
    dispatch({
      type: MENU_ACTION.SELECT,
      level: currentLevel,
      index: lastStackWithFocus.focusIndex,
      setDefaultFocus: true
    });
  }, [currentLevel, dispatch, items, lastStackWithFocus, state]);
  var onEscape = useCallback(function () {
    dispatch({
      type: MENU_ACTION.CLOSE
    });
  }, [dispatch]);
  var handleKeyDown = useCallback(function (event) {
    var currentEvent = event.nativeEvent || event;
    switch (currentEvent.code) {
      case 'ArrowDown':
      case 'Tab':
        onArrowDown(event);
        break;
      case 'ArrowUp':
        onArrowUp(event);
        break;
      case 'ArrowLeft':
        {
          onArrowLeft(event);
          break;
        }
      case 'ArrowRight':
      case 'Enter':
        onEnter(event);
        break;
      case 'Escape':
        onEscape();
        break;
    }
  }, [onArrowDown, onArrowLeft, onArrowUp, onEnter, onEscape]);
  return handleKeyDown;
}
function hasChildren(items, navigationStack) {
  var _navigationStack$inde;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var currentStackIndex = navigationStack.findLastIndex(function (stack) {
    return stack.focusIndex !== undefined;
  });
  var itemIndex = (_navigationStack$inde = navigationStack[index]) === null || _navigationStack$inde === void 0 ? void 0 : _navigationStack$inde.focusIndex;
  if (typeof itemIndex === 'undefined') {
    return false;
  }
  var currentItem = items[itemIndex];
  if (currentItem.items && currentStackIndex > index) {
    return hasChildren(currentItem.items, navigationStack, index + 1);
  }
  return !!currentItem.items;
}

var MENU_MIN_HEIGHT = 42; // Value from menu.scss
var DEFAULT_LEVEL = 0;
var MpdMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$popup = _ref.popup,
    popup = _ref$popup === void 0 ? false : _ref$popup,
    items = _ref.items;
  var _useMenuReducer = useMenuReducer(),
    _useMenuReducer2 = _slicedToArray(_useMenuReducer, 2),
    state = _useMenuReducer2[0],
    dispatch = _useMenuReducer2[1];
  var isOpened = state.navigationStack.some(function (stack) {
    return stack.focusIndex !== undefined;
  }) || !popup;

  // Hook to enable the accessibility of the menu
  var handleKeyDown = useMpdMenuAccessibility(items, state, dispatch);

  // Expose some methods
  useImperativeHandle(ref, function () {
    return {
      open: function open(event) {
        dispatch({
          type: MENU_ACTION.OPEN,
          position: event.currentTarget.getBoundingClientRect(),
          width: event.currentTarget.clientWidth
        });
      }
    };
  }, [dispatch]);
  var handleClick = useCallback(function (event) {
    if (!isOpened) {
      return;
    }
    var target = event.target;
    if (!target.closest('.mpd-menu')) {
      // Close if the click is outside the menu
      dispatch({
        type: MENU_ACTION.CLOSE
      });
    }
  }, [dispatch, isOpened]);
  useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick, ref]);
  if (!isOpened) {
    return null;
  }
  var bottomPosition = window.innerHeight - state.position.bottom;
  var isBottomDisplayed = bottomPosition < items.length * MENU_MIN_HEIGHT; // estimate the menu height with the number of items and its min height

  return /*#__PURE__*/jsx(MpdCard, {
    onKeyDown: handleKeyDown,
    className: cn('mpd-menu actived', {
      'mpd-menu--bottom': isBottomDisplayed
    }),
    style: {
      minWidth: state.width,
      left: state.position.left,
      /** @todo: improve bottom display by using transition/animation css (like the top render) */
      bottom: isBottomDisplayed ? bottomPosition : undefined,
      transform: !isBottomDisplayed ? "translateY(".concat(state.position.top, "px)") : undefined
    },
    children: /*#__PURE__*/jsx("ul", {
      role: "menu",
      children: items.map(function (item, index) {
        var _state$navigationStac, _state$navigationStac2;
        return /*#__PURE__*/jsx(MpdMenuItem, {
          item: item,
          level: DEFAULT_LEVEL,
          index: index,
          state: state,
          dispatch: dispatch,
          isFocused: ((_state$navigationStac = state.navigationStack[DEFAULT_LEVEL]) === null || _state$navigationStac === void 0 ? void 0 : _state$navigationStac.focusIndex) === index && ((_state$navigationStac2 = state.navigationStack[DEFAULT_LEVEL]) === null || _state$navigationStac2 === void 0 ? void 0 : _state$navigationStac2.activeIndex) === undefined
        }, item.label);
      })
    })
  });
});

var _excluded$5 = ["suffix"];
var _requestID = /*#__PURE__*/new WeakMap();
var CountUp = /*#__PURE__*/function (_PureComponent) {
  function CountUp(props) {
    var _this;
    _classCallCheck(this, CountUp);
    _this = _callSuper(this, CountUp, [props]);
    _classPrivateFieldInitSpec(_this, _requestID, void 0);
    _this.state = {
      count: 0
    };
    _classPrivateFieldSet2(_requestID, _this, null);
    return _this;
  }
  _inherits(CountUp, _PureComponent);
  return _createClass(CountUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.progress();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var final = this.props.final;
      if (prevProps.final !== final) {
        this.progress();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_classPrivateFieldGet2(_requestID, this)) {
        window.cancelAnimationFrame(_classPrivateFieldGet2(_requestID, this));
      }
    }
  }, {
    key: "progress",
    value: function progress() {
      var _this2 = this;
      var _this$props = this.props,
        duration = _this$props.duration,
        final = _this$props.final;
      var startCount = this.state.count;
      var startTimestamp;
      var _step = function step(timestamp) {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }
        var progress = Math.min((timestamp - startTimestamp) / duration, 1);
        var newCount = startCount + (final - startCount) * progress;
        _this2.setState({
          count: Math.round(newCount)
        });
        if (progress < 1) {
          _classPrivateFieldSet2(_requestID, _this2, window.requestAnimationFrame(_step));
        }
      };
      _classPrivateFieldSet2(_requestID, this, window.requestAnimationFrame(_step));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        suffix = _this$props2.suffix,
        props = _objectWithoutProperties(_this$props2, _excluded$5);
      var count = this.state.count;

      // prettier-ignore
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        jsxs("span", _objectSpread2(_objectSpread2({}, props), {}, {
          children: [count, suffix]
        }))
      );
      // prettier-ignore-end
    }
  }]);
}(PureComponent);
_defineProperty(CountUp, "defaultProps", {
  // eslint-disable-next-line react/default-props-match-prop-types
  duration: 2000,
  // eslint-disable-next-line react/default-props-match-prop-types
  suffix: ''
});

var SIZE_THRESHOLD = 80;
var MpdCircleProgress = /*#__PURE__*/function (_PureComponent) {
  function MpdCircleProgress(props) {
    var _this;
    _classCallCheck(this, MpdCircleProgress);
    _this = _callSuper(this, MpdCircleProgress, [props]);
    _this.state = {
      progress: 0
    };
    return _this;
  }
  _inherits(MpdCircleProgress, _PureComponent);
  return _createClass(MpdCircleProgress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Set a timeout to display the animation
      setTimeout(function () {
        // eslint-disable-next-line react/destructuring-assignment
        _this2.setState({
          progress: _this2.props.current
        });
      }, 10);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var current = this.props.current;
      if (prevProps.current !== current) {
        // Set a timeout to display the animation
        setTimeout(function () {
          _this3.setState({
            progress: current
          });
        }, 10);
      }
    }
  }, {
    key: "percentage",
    get: function get() {
      var max = this.props.max;
      if (max === 0) {
        return 0;
      }
      if (!max) {
        throw new Error('"max" props can not be null or undefined.');
      }

      // eslint-disable-next-line react/destructuring-assignment
      return this.state.progress / max * 100;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props = this.props,
        current = _this$props.current,
        max = _this$props.max,
        maxLabel = _this$props.maxLabel,
        currentLabel = _this$props.currentLabel,
        stroke = _this$props.stroke;
      if (maxLabel && currentLabel) {
        var labelStyle = {
          padding: "0 ".concat(stroke * 2, "px")
        };
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("p", {
            style: labelStyle,
            children: [/*#__PURE__*/jsx(CountUp, {
              className: "value",
              final: current
            }), /*#__PURE__*/jsx("span", {
              className: "content",
              children: currentLabel
            })]
          }), max !== null && /*#__PURE__*/jsxs("p", {
            className: "max",
            style: labelStyle,
            children: [/*#__PURE__*/jsx("span", {
              className: "value",
              children: max
            }), /*#__PURE__*/jsx("span", {
              className: "content",
              children: maxLabel
            })]
          })]
        });
      }
      return /*#__PURE__*/jsx(CountUp, {
        className: "percent",
        final: Math.round(this.percentage),
        suffix: " %"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        size = _this$props2.size,
        stroke = _this$props2.stroke,
        style = _this$props2.style,
        className = _this$props2.className,
        strokeColor = _this$props2.strokeColor;
      var radius = (size - stroke) / 2;
      var viewBox = "0 0 ".concat(size, " ").concat(size);
      var dashArray = radius * Math.PI * 2;
      var dashOffset = dashArray - dashArray * (Math.max(Math.min(this.percentage, 100), 0) / 100);
      return /*#__PURE__*/jsxs("div", {
        className: "progress progress--circle ".concat(className),
        style: _objectSpread2({
          width: size,
          height: size
        }, style),
        children: [/*#__PURE__*/jsxs("svg", {
          width: size,
          height: size,
          viewBox: viewBox,
          children: [/*#__PURE__*/jsx("circle", {
            className: "progress__background",
            cx: size / 2,
            cy: size / 2,
            r: radius,
            strokeWidth: "".concat(stroke, "px")
          }), /*#__PURE__*/jsx("circle", {
            className: "progress__active",
            cx: size / 2,
            cy: size / 2,
            r: radius,
            strokeWidth: "".concat(stroke, "px"),
            transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"),
            style: {
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset,
              stroke: strokeColor
            }
          })]
        }), size >= SIZE_THRESHOLD && /*#__PURE__*/jsx("div", {
          className: "progress__label",
          style: {
            width: size,
            height: size
          },
          children: this.renderLabel()
        })]
      });
    }
  }]);
}(PureComponent);
_defineProperty(MpdCircleProgress, "defaultProps", {
  // eslint-disable-next-line react/default-props-match-prop-types
  size: 90,
  // eslint-disable-next-line react/default-props-match-prop-types
  stroke: 4,
  // eslint-disable-next-line react/default-props-match-prop-types
  style: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  className: ''
});

var MpdAside = /*#__PURE__*/function (_PureComponent) {
  function MpdAside(props) {
    var _this;
    _classCallCheck(this, MpdAside);
    _this = _callSuper(this, MpdAside, [props]);
    _this.state = {
      selected: _this.getSelectedTab()
    };
    return _this;
  }
  _inherits(MpdAside, _PureComponent);
  return _createClass(MpdAside, [{
    key: "onClick",
    value: function onClick(event, tab) {
      event.preventDefault();
      this.setState({
        selected: tab.id
      });

      // eslint-disable-next-line react/destructuring-assignment
      this.props.onChange(tab);
    }
  }, {
    key: "getSelectedTab",
    value: function getSelectedTab() {
      // eslint-disable-next-line react/destructuring-assignment
      var selectedTab = this.props.tabs.find(function (tab) {
        return tab.selected;
      });

      // eslint-disable-next-line react/destructuring-assignment
      return selectedTab ? selectedTab.id : this.props.tabs[0].id;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tabs = _this$props.tabs,
        children = _this$props.children;
      var selected = this.state.selected;
      return /*#__PURE__*/jsxs("div", {
        className: "aside",
        children: [/*#__PURE__*/jsx("nav", {
          className: "aside__navigation",
          children: /*#__PURE__*/jsx("ul", {
            children: tabs.map(function (tab) {
              var progressionClasses = cn('aside__progression', tab.progression !== undefined && {
                'aside__progression--zero': tab.progression === 0,
                'aside__progression--complete': tab.progression === 100
              });
              return /*#__PURE__*/jsxs("li", {
                className: cn({
                  selected: selected === tab.id
                }),
                children: [/*#__PURE__*/jsx("div", {
                  className: "selector"
                }), /*#__PURE__*/jsxs("a", {
                  href: tab.path,
                  onClick: function onClick(event) {
                    return _this2.onClick(event, tab);
                  },
                  children: [tab.progression !== undefined && /*#__PURE__*/jsxs("span", {
                    className: progressionClasses,
                    children: [tab.progression, "%"]
                  }), /*#__PURE__*/jsx("span", {
                    className: "h3-like mt1 mb1",
                    children: tab.title
                  }), /*#__PURE__*/jsx("span", {
                    className: "smaller",
                    children: tab.content
                  })]
                })]
              }, tab.id);
            })
          })
        }), /*#__PURE__*/jsx("div", {
          className: "aside__content",
          children: children
        })]
      });
    }
  }]);
}(PureComponent);

function MpdInputMessages(_ref) {
  var helpMessage = _ref.helpMessage,
    errorMessage = _ref.errorMessage,
    successMessage = _ref.successMessage;
  if (!errorMessage && !successMessage && !helpMessage) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!errorMessage && !successMessage && helpMessage && /*#__PURE__*/jsx("span", {
      className: "help",
      children: helpMessage
    }), !!errorMessage && /*#__PURE__*/jsx("span", {
      className: "help help--error",
      children: errorMessage
    }), !!successMessage && !errorMessage && /*#__PURE__*/jsx("span", {
      className: "help help--success",
      children: successMessage
    })]
  });
}

function MpdInputLabel(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  var labelId = id !== null && id !== void 0 ? id : generateRandomID();
  if (!label) {
    return null;
  }
  return /*#__PURE__*/jsx("label", {
    htmlFor: labelId,
    className: cn(required && 'required'),
    children: label
  });
}

var _input = /*#__PURE__*/new WeakMap();
var MpdInputByCharacter = /*#__PURE__*/function (_PureComponent) {
  function MpdInputByCharacter(props) {
    var _this;
    _classCallCheck(this, MpdInputByCharacter);
    _this = _callSuper(this, MpdInputByCharacter, [props]);
    _classPrivateFieldInitSpec(_this, _input, void 0);
    _classPrivateFieldSet2(_input, _this, /*#__PURE__*/createRef());
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handlePaste = _this.handlePaste.bind(_this);
    return _this;
  }

  // eslint-disable-next-line react/sort-comp, react/no-unused-class-component-methods
  _inherits(MpdInputByCharacter, _PureComponent);
  return _createClass(MpdInputByCharacter, [{
    key: "value",
    get: function get() {
      var _classPrivateFieldGet2$1;
      return (_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_input, this).current) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.value;
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(event) {
      var _input$selectionStart, _input$selectionEnd;
      var _this$props = this.props,
        stripSpaces = _this$props.stripSpaces,
        maxLength = _this$props.maxLength,
        onChange = _this$props.onChange;
      if (!stripSpaces) {
        return;
      }
      event.preventDefault();
      var pastedText = event.clipboardData.getData('text').replace(/\s/g, '');
      var input = _classPrivateFieldGet2(_input, this).current;
      if (!input) {
        return;
      }
      var start = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : 0;
      var end = (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : 0;
      var newValue = (input.value.slice(0, start) + pastedText + input.value.slice(end)).slice(0, maxLength);
      input.value = newValue;
      var newPos = Math.min(start + pastedText.length, maxLength);
      input.setSelectionRange(newPos, newPos);
      if (onChange) {
        onChange(newValue);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props2 = this.props,
        stripSpaces = _this$props2.stripSpaces,
        onChange = _this$props2.onChange;
      var value = event.target.value;
      if (stripSpaces) {
        value = value.replace(/\s/g, '');
        if (_classPrivateFieldGet2(_input, this).current) {
          _classPrivateFieldGet2(_input, this).current.value = value;
        }
      }
      if (!onChange) {
        return;
      }
      onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        id = _this$props3.id,
        label = _this$props3.label,
        maxLength = _this$props3.maxLength,
        required = _this$props3.required,
        errorMessage = _this$props3.errorMessage,
        defaultValue = _this$props3.defaultValue;
      var inputWidth = "".concat(maxLength * 2 + maxLength - 0.1, "ch");
      return /*#__PURE__*/jsxs("div", {
        className: "form-group form-group--letter",
        children: [/*#__PURE__*/jsx(MpdInputLabel, {
          id: id,
          label: label,
          required: required
        }), /*#__PURE__*/jsx("div", {
          className: "input-container",
          style: {
            width: inputWidth
          },
          children: /*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsx("input", {
              type: "text",
              id: id,
              required: required,
              maxLength: maxLength,
              style: {
                width: inputWidth
              },
              onChange: this.handleChange,
              onPaste: this.handlePaste,
              ref: _classPrivateFieldGet2(_input, this),
              defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.substring(0, maxLength)
            }), /*#__PURE__*/jsx(MpdInputMessages, {
              errorMessage: errorMessage
            })]
          })
        })]
      });
    }
  }]);
}(PureComponent);
_defineProperty(MpdInputByCharacter, "defaultProps", {
  // eslint-disable-next-line react/default-props-match-prop-types
  required: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  defaultValue: ''
});

var MpdLayoutScrollContext = /*#__PURE__*/createContext(null);
function useMpdLayoutScrollContext() {
  var context = useContext(MpdLayoutScrollContext);
  if (!context) {
    throw new Error('No MpdLayoutScroll context. Does your component has a MpdLayoutScrollContext.Provider up in the tree ?');
  }
  return context;
}

var LayoutMode = /*#__PURE__*/function (LayoutMode) {
  LayoutMode["DEFAULT"] = "default";
  LayoutMode["SPLIT"] = "split";
  LayoutMode["TABS"] = "tabs";
  LayoutMode["NAVIGATION"] = "menu";
  return LayoutMode;
}({});
function MpdLayout(_ref) {
  var _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? LayoutMode.DEFAULT : _ref$mode,
    header = _ref.header,
    sidebar = _ref.sidebar,
    leftContent = _ref.leftContent,
    action = _ref.action,
    isHalf = _ref.isHalf,
    _ref$hasInnerWidth = _ref.hasInnerWidth,
    hasInnerWidth = _ref$hasInnerWidth === void 0 ? false : _ref$hasInnerWidth,
    backgroundReversed = _ref.backgroundReversed,
    children = _ref.children,
    className = _ref.className;
  var containerClassnames = cn('mpd-layout', className);
  var mainContainerRef = useRef(null);
  var scrollToTop = useCallback(function () {
    var _mainContainerRef$cur;
    (_mainContainerRef$cur = mainContainerRef.current) === null || _mainContainerRef$cur === void 0 || _mainContainerRef$cur.scrollTo(0, 0);
  }, []);
  var value = useMemo(function () {
    return {
      scrollToTop: scrollToTop
    };
  }, [scrollToTop]);
  if ([LayoutMode.SPLIT, LayoutMode.NAVIGATION].includes(mode)) {
    var columnClasses = cn('column', {
      'has-action': !!action
    });
    return /*#__PURE__*/jsx(MpdLayoutScrollContext.Provider, {
      value: value,
      children: /*#__PURE__*/jsxs("div", {
        className: cn(containerClassnames, 'columns is-gapless', {
          'mpd-layout--split': mode === LayoutMode.SPLIT,
          'mpd-layout--reversed': backgroundReversed,
          'mpd-layout--navigation': mode === LayoutMode.NAVIGATION
        }),
        children: [/*#__PURE__*/jsxs("div", {
          className: columnClasses,
          children: [/*#__PURE__*/jsxs("div", {
            className: "mpd-layout__left-content",
            children: [header && /*#__PURE__*/jsx("div", {
              className: "mpd-layout__header",
              children: header
            }), leftContent]
          }), action && /*#__PURE__*/jsx("div", {
            className: "mpd-layout__action",
            children: action
          })]
        }), /*#__PURE__*/jsx("div", {
          ref: mainContainerRef,
          className: cn('column', {
            'has-inner-width': hasInnerWidth,
            'is-6': isHalf,
            'is-8': !isHalf
          }),
          children: children
        })]
      })
    });
  }
  var headerClassnames = cn('mpd-layout__header', {
    'mpd-layout__header--tabs': mode === LayoutMode.TABS
  });
  return /*#__PURE__*/jsx(MpdLayoutScrollContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsxs("div", {
      className: cn(containerClassnames, {
        'mpd-layout--sidebar': !!sidebar
      }),
      children: [/*#__PURE__*/jsx("div", {
        className: headerClassnames,
        children: header
      }), /*#__PURE__*/jsxs("div", {
        ref: mainContainerRef,
        className: "mpd-layout__content",
        children: [children, sidebar && /*#__PURE__*/jsx("div", {
          className: "mpd-layout__sidebar",
          children: sidebar
        })]
      })]
    })
  });
}

var MpdSelectContext = /*#__PURE__*/createContext(null);
function MpdSelectContextProvider(_ref) {
  var state = _ref.state,
    dispatch = _ref.dispatch,
    selectedValue = _ref.selectedValue,
    onChangeValue = _ref.onChangeValue,
    children = _ref.children;
  var value = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch,
      selectedValue: selectedValue,
      onChangeValue: onChangeValue
    };
  }, [state, dispatch, selectedValue, onChangeValue]);
  return /*#__PURE__*/jsx(MpdSelectContext.Provider, {
    value: value,
    children: children
  });
}
function useMpdSelectContext() {
  var context = useContext(MpdSelectContext);
  if (!context) {
    throw new Error('No MpdSelect context. Does your component has a MpdSelectContextProvider up in the tree ?');
  }
  return context;
}

var SELECT_ACTION = /*#__PURE__*/function (SELECT_ACTION) {
  SELECT_ACTION["CLOSE_DROPDOWN"] = "CLOSE_DROPDOWN";
  SELECT_ACTION["OPEN_DROPDOWN"] = "OPEN_DROPDOWN";
  SELECT_ACTION["TOGGLE_DROPDOWN"] = "TOGGLE_DROPDOWN";
  SELECT_ACTION["SET_DROPDOWN_POSITION"] = "SET_DROPDOWN_POSITION";
  SELECT_ACTION["ANIMATION_DONE"] = "ANIMATION_DONE";
  SELECT_ACTION["CHANGE_SELECTED_VALUE"] = "CHANGE_SELECTED_VALUE";
  SELECT_ACTION["FOCUS_NEXT_OPTION"] = "FOCUS_NEXT_OPTION";
  SELECT_ACTION["FOCUS_PREVIOUS_OPTION"] = "FOCUS_PREVIOUS_OPTION";
  SELECT_ACTION["SELECT_WIDTH"] = "SELECT_WIDTH";
  return SELECT_ACTION;
}({});
function reducer(state, action) {
  switch (action.type) {
    case SELECT_ACTION.CLOSE_DROPDOWN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        openedDropdown: false,
        dropdownAnimationDone: false
      });
    case SELECT_ACTION.OPEN_DROPDOWN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        openedDropdown: true,
        dropdownAnimationDone: false
      });
    case SELECT_ACTION.TOGGLE_DROPDOWN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        openedDropdown: !state.openedDropdown
      });
    case SELECT_ACTION.SET_DROPDOWN_POSITION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDropdownOnTop: action.isDropdownOnTop
      });
    case SELECT_ACTION.ANIMATION_DONE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        dropdownAnimationDone: true
      });
    case SELECT_ACTION.CHANGE_SELECTED_VALUE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        focusedValue: action.value,
        openedDropdown: false,
        dropdownAnimationDone: false
      });
    case SELECT_ACTION.FOCUS_NEXT_OPTION:
      {
        var optionList = state.optionList,
          focusedValue = state.focusedValue;
        var currentIndex = optionList.findIndex(function (option) {
          return option.value === focusedValue;
        });
        if (currentIndex === optionList.length - 1) {
          return state;
        }
        var foundOption = optionList.find(function (option, index) {
          if (index <= currentIndex) {
            return false;
          }
          if (option.disabled) {
            return false;
          }
          return true;
        });
        if (foundOption) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            focusedValue: foundOption.value
          });
        }
        return state;
      }
    case SELECT_ACTION.FOCUS_PREVIOUS_OPTION:
      {
        var _optionList = state.optionList,
          _focusedValue = state.focusedValue;
        var _currentIndex = _optionList.findIndex(function (option) {
          return option.value === _focusedValue;
        });
        if (_currentIndex === 0) {
          return state;
        }
        var _foundOption = _optionList.slice().reverse().find(function (option) {
          var index = _optionList.findIndex(function (opt) {
            return opt.value === option.value;
          });
          if (index >= _currentIndex) {
            return false;
          }
          if (option.disabled) {
            return false;
          }
          return true;
        });
        if (_foundOption) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            focusedValue: _foundOption.value
          });
        }
        return state;
      }
    case SELECT_ACTION.SELECT_WIDTH:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        selectWidth: action.width
      });
    default:
      // @ts-expect-error -- let the runtime fail in this case
      throw new Error("action type ".concat(action.type, " is not authorized"));
  }
}

function MpdSelectDropdown(_ref) {
  var displayOnTop = _ref.displayOnTop,
    children = _ref.children;
  var _useMpdSelectContext = useMpdSelectContext(),
    dispatch = _useMpdSelectContext.dispatch,
    state = _useMpdSelectContext.state;
  var ref = useRef(null);
  var classnames = cn('mpd-select__dropdown', {
    'mpd-select__dropdown--top': displayOnTop,
    'mpd-select__dropdown--opened-top': state.openedDropdown && displayOnTop,
    'mpd-select__dropdown--opened-bottom': state.openedDropdown && !displayOnTop
  });
  var handleKeyDown = function handleKeyDown(event) {
    // Close dropdown when press ESCAPE
    if (matchKeyEvent(event.nativeEvent, KEY_CODES.escape)) {
      dispatch({
        type: SELECT_ACTION.CLOSE_DROPDOWN
      });
      return;
    }

    // Navigate in focus in options when press UP / DOWN
    if (matchKeyEvent(event.nativeEvent, KEY_CODES.up) || matchKeyEvent(event.nativeEvent, KEY_CODES.down)) {
      event.preventDefault();
      if (matchKeyEvent(event.nativeEvent, KEY_CODES.up)) {
        dispatch({
          type: SELECT_ACTION.FOCUS_PREVIOUS_OPTION
        });
      } else {
        dispatch({
          type: SELECT_ACTION.FOCUS_NEXT_OPTION
        });
      }
    }
  };
  useEffect(function () {
    var _ref$current;
    // Set width of MpdSelect on Init
    dispatch({
      type: SELECT_ACTION.SELECT_WIDTH,
      width: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().width
    });
    var lostFocus = function lostFocus(event) {
      var _ref$current2;
      if (event.target instanceof Element && !((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && (_ref$current2 = _ref$current2.parentElement) !== null && _ref$current2 !== void 0 && _ref$current2.contains(event.target))) {
        dispatch({
          type: SELECT_ACTION.CLOSE_DROPDOWN
        });
      }
    };

    // Listen click and focus out of the dropdown to close it
    document.addEventListener('focusin', lostFocus);
    document.addEventListener('click', lostFocus);
    return function () {
      document.removeEventListener('focusin', lostFocus);
      document.removeEventListener('click', lostFocus);
    };
  }, [dispatch]);
  useEffect(function () {
    var dropdown = ref.current;
    var animationDone = function animationDone() {
      dispatch({
        type: SELECT_ACTION.ANIMATION_DONE
      });
    };
    dropdown === null || dropdown === void 0 || dropdown.addEventListener('animationend', animationDone);
    return function () {
      dropdown === null || dropdown === void 0 || dropdown.removeEventListener('animationend', animationDone);
    };
  }, [dispatch]);
  return /*#__PURE__*/jsx(MpdCard, {
    ref: ref,
    className: classnames,
    onKeyDown: handleKeyDown,
    children: Children.map(children, function (child) {
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      return child;
    })
  });
}

function MpdSelectOption(_ref) {
  var className = _ref.className,
    children = _ref.children,
    value = _ref.value,
    disabled = _ref.disabled;
  var _useMpdSelectContext = useMpdSelectContext(),
    selectedValue = _useMpdSelectContext.selectedValue,
    onChangeValue = _useMpdSelectContext.onChangeValue,
    state = _useMpdSelectContext.state;
  var ref = useRef(null);
  var isFocused = value === state.focusedValue;
  var isActive = value === selectedValue;
  var handleClick = function handleClick() {
    if (disabled) {
      return;
    }
    onChangeValue(value);
  };
  useEffect(function () {
    if (isFocused && state.dropdownAnimationDone) {
      var _ref$current;
      // Focus the dom element when focusedValue variable match with this value component
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    }
  }, [isFocused, state.dropdownAnimationDone]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: cn('mpd-select__option', className, {
      'mpd-select__option--selected': isActive,
      'mpd-select__option--disabled': disabled
    }),
    onClick: handleClick,
    onKeyPress: function onKeyPress(event) {
      // Select the focused value when press ENTER
      if (matchKeyEvent(event.nativeEvent, KEY_CODES.enter)) {
        onChangeValue(state.focusedValue);
      }
    },
    role: "option",
    "aria-selected": isActive,
    "aria-disabled": disabled,
    tabIndex: disabled ? -1 : 0,
    children: children
  });
}

var MAX_DROPDOWN_HEIGHT = 260;

/** @deprecated Use `MpdSingleSelect` instead */
function MpdSelect(_ref) {
  var _optionList$;
  var value = _ref.value,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    defaultLabel = _ref.defaultLabel,
    placeholder = _ref.placeholder,
    inline = _ref.inline,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    className = _ref.className,
    flexible = _ref.flexible,
    children = _ref.children;
  // Infinite flatten for children because it may be arrays of arrays (of arrays...)
  var flattenedChildren = [children].flat(Infinity).filter(function (c) {
    return Boolean(c) && /*#__PURE__*/isValidElement(c);
  });

  // Define an options list variable to know all options content
  // from children as usable object
  var optionList = Children.map(flattenedChildren, function (child) {
    return {
      label: child.props.children,
      value: child.props.value,
      disabled: child.props.disabled || false
    };
  });
  var _useReducer = useReducer(reducer, {
      optionList: optionList,
      openedDropdown: false,
      focusedValue: value || ((_optionList$ = optionList[0]) === null || _optionList$ === void 0 ? void 0 : _optionList$.value),
      isDropdownOnTop: false,
      dropdownAnimationDone: false,
      selectWidth: undefined
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var matchedOption = optionList.find(function (opt) {
    return opt.value === value;
  });
  if (value !== undefined && value !== null && value !== '' && optionList.length > 0 && !matchedOption && !disabled) {
    throw new Error('The `value` props do not match with any value in your MpdSelect options. This should not happen.');
  }

  /** @todo: Remove this variable when all components are using `placeholder` instead of `defaultLabel` */
  var defaultPlaceholder = defaultLabel || placeholder;
  var selectedValueRef = useRef(null);
  var selectedValue = (matchedOption === null || matchedOption === void 0 ? void 0 : matchedOption.label) || defaultPlaceholder;

  // Define if the dropdown is shown on top or bottom
  useEffect(function () {
    if (disabled || !selectedValueRef.current) {
      return;
    }
    var selectRect = selectedValueRef.current.getBoundingClientRect();
    var modal = document.querySelector('.base-modal__block--inner');
    if (modal) {
      var modalRect = modal.getBoundingClientRect();
      dispatch({
        type: SELECT_ACTION.SET_DROPDOWN_POSITION,
        isDropdownOnTop: modalRect.bottom < selectRect.bottom + MAX_DROPDOWN_HEIGHT
      });
      return;
    }
    var updateWindowResize = function updateWindowResize() {
      dispatch({
        type: SELECT_ACTION.SET_DROPDOWN_POSITION,
        isDropdownOnTop: window.innerHeight - selectRect.bottom < MAX_DROPDOWN_HEIGHT
      });
    };
    updateWindowResize();
    window.addEventListener('resize', updateWindowResize);

    // eslint-disable-next-line consistent-return
    return function () {
      window.removeEventListener('resize', updateWindowResize);
    };
  }, [disabled]);
  var handleOpenToggle = function handleOpenToggle() {
    if (disabled) {
      return;
    }
    dispatch({
      type: SELECT_ACTION.TOGGLE_DROPDOWN
    });
  };
  var handleChangeValue = function handleChangeValue(newValue) {
    var _selectedValueRef$cur;
    // Set selected and focused value with selected value
    dispatch({
      type: SELECT_ACTION.CHANGE_SELECTED_VALUE,
      value: newValue
    });

    // Trigger the onChange event with the new selected value
    onChange(newValue);

    // Force focus component
    (_selectedValueRef$cur = selectedValueRef.current) === null || _selectedValueRef$cur === void 0 || _selectedValueRef$cur.focus();
  };
  return /*#__PURE__*/jsxs(MpdSelectContextProvider, {
    state: state,
    dispatch: dispatch,
    selectedValue: value,
    onChangeValue: handleChangeValue,
    children: [label && /*#__PURE__*/jsxs("span", {
      className: "mpd-select__label",
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: "required"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: cn('mpd-select', {
        'mpd-select--open': state.openedDropdown,
        'mpd-select--inline': inline,
        'mpd-select--disabled': disabled,
        'mpd-select--flexible': flexible
      }, className),
      children: [/*#__PURE__*/jsxs("div", {
        ref: selectedValueRef,
        className: "mpd-select__value",
        role: "button",
        tabIndex: 0,
        onClick: handleOpenToggle,
        onKeyDown: function onKeyDown(event) {
          if (disabled) {
            return;
          }

          // Open dropdown when press UP / DOWN
          if (matchKeyEvent(event.nativeEvent, KEY_CODES.up) || matchKeyEvent(event.nativeEvent, KEY_CODES.down)) {
            event.preventDefault();
            dispatch({
              type: SELECT_ACTION.OPEN_DROPDOWN
            });
          }
        },
        children: [/*#__PURE__*/jsx("div", {
          className: cn('mpd-select__selected_value', {
            'mpd-color-gray': defaultPlaceholder === selectedValue
          }),
          style: {
            width: flexible ? undefined : state.selectWidth
          },
          children: selectedValue
        }), /*#__PURE__*/jsx(MpdIcon, {
          icon: state.openedDropdown ? 'arrow-top' : 'arrow-down',
          width: "24",
          className: "mpd-color-blue ml1"
        })]
      }), !disabled && /*#__PURE__*/jsx(MpdSelectDropdown, {
        displayOnTop: state.isDropdownOnTop,
        children: children || /*#__PURE__*/jsx(MpdSelectOption, {
          value: value,
          children: value || defaultPlaceholder
        })
      })]
    })]
  });
}

var SETUP_ANIMATION_DURATION = 200;
var _selector = /*#__PURE__*/new WeakMap();
var _container = /*#__PURE__*/new WeakMap();
var _initTimeout = /*#__PURE__*/new WeakMap();
var MpdTabs = /*#__PURE__*/function (_Component) {
  function MpdTabs(props) {
    var _this;
    _classCallCheck(this, MpdTabs);
    _this = _callSuper(this, MpdTabs, [props]);
    _classPrivateFieldInitSpec(_this, _selector, void 0);
    _classPrivateFieldInitSpec(_this, _container, void 0);
    _classPrivateFieldInitSpec(_this, _initTimeout, void 0);
    _classPrivateFieldSet2(_selector, _this, /*#__PURE__*/createRef());
    _classPrivateFieldSet2(_container, _this, /*#__PURE__*/createRef());
    _classPrivateFieldSet2(_initTimeout, _this, 0);
    var tabSelected = props.tabs.find(function (tab) {
      return tab.defaultSelected === true;
    });
    _this.state = {
      selectedTab: tabSelected && tabSelected.id || props.tabs[0] && props.tabs[0].id
    };
    _this.animateSelector = _this.animateSelector.bind(_this);
    _this.getTargetId = _this.getTargetId.bind(_this);
    _this.handleChangeEvent = _this.handleChangeEvent.bind(_this);
    return _this;
  }
  _inherits(MpdTabs, _Component);
  return _createClass(MpdTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      mpdTabInit();

      // Setup selector animation
      _classPrivateFieldSet2(_initTimeout, this, window.setTimeout(this.animateSelector, SETUP_ANIMATION_DURATION));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selectedTab = this.state.selectedTab;
      var _this$props = this.props,
        tabs = _this$props.tabs,
        onChangeTab = _this$props.onChangeTab;
      if (prevProps.tabs.length !== tabs.length) {
        var tabSelected = tabs.find(function (tab) {
          return tab.defaultSelected === true;
        });
        if (!tabSelected) {
          return;
        }

        // eslint-disable-next-line
        this.setState({
          selectedTab: tabSelected.id
        }, this.animateSelector);
      }
      if (selectedTab !== prevState.selectedTab) {
        if (onChangeTab && selectedTab) {
          onChangeTab(selectedTab);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(_classPrivateFieldGet2(_initTimeout, this));
    }
  }, {
    key: "getSelectorPosition",
    value: function getSelectorPosition(selectedItem) {
      var _classPrivateFieldGet2$1;
      var selectedPosition = selectedItem.getBoundingClientRect().left;
      var containerPosition = ((_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_container, this).current) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.getBoundingClientRect().left) || 0;
      return selectedPosition - containerPosition;
    }
  }, {
    key: "getTargetId",
    value: function getTargetId(id) {
      return "mpd-tab-content-target-".concat(id);
    }
  }, {
    key: "animateSelector",
    value: function animateSelector(selected) {
      var container = _classPrivateFieldGet2(_container, this).current;
      var selectedItem = selected || (container === null || container === void 0 ? void 0 : container.querySelector('.selected')) || (container === null || container === void 0 ? void 0 : container.querySelector('.mpd-tabs__tab'));
      if (selectedItem) {
        var position = this.getSelectorPosition(selectedItem);
        var selector = _classPrivateFieldGet2(_selector, this).current;
        if (!selector) {
          return;
        }
        selector.style.width = "".concat(selectedItem.offsetWidth, "px");
        selector.style.left = "".concat(position < 0 ? 0 : position, "px");
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "handleChangeEvent",
    value: function handleChangeEvent(event) {
      var _this2 = this;
      var target = event.target;
      this.setState({
        selectedTab: target.getAttribute('id')
      }, function () {
        _this2.animateSelector(target.parentNode);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        containerClassName = _this$props2.containerClassName,
        name = _this$props2.name,
        tabs = _this$props2.tabs,
        flex = _this$props2.flex;
      var selectedTab = this.state.selectedTab;
      var classNames = cn('mpd-tabs', {
        'mpd-tabs--flex': flex
      });
      return /*#__PURE__*/jsxs("section", {
        className: classNames,
        children: [/*#__PURE__*/jsxs("div", {
          ref: _classPrivateFieldGet2(_container, this),
          className: "mpd-tabs__tab-container ".concat(containerClassName),
          children: [/*#__PURE__*/jsx("div", {
            ref: _classPrivateFieldGet2(_selector, this),
            className: "selector"
          }), tabs.map(function (_ref) {
            var id = _ref.id,
              defaultSelected = _ref.defaultSelected,
              label = _ref.label,
              labelClassName = _ref.labelClassName;
            return /*#__PURE__*/jsxs("div", {
              className: "mpd-tabs__tab ".concat(defaultSelected || id === selectedTab ? 'selected' : ''),
              children: [/*#__PURE__*/jsx("input", {
                id: id,
                "data-target": _this3.getTargetId(id),
                type: "radio",
                name: name,
                className: "mpd-tabs__tab-selector",
                defaultChecked: defaultSelected,
                onChange: _this3.handleChangeEvent
              }), /*#__PURE__*/jsx("label", {
                htmlFor: id,
                className: "mpd-tabs__tab-label ".concat(labelClassName),
                children: label
              })]
            }, id);
          })]
        }), /*#__PURE__*/jsx("div", {
          className: "mpd-tabs__content-container",
          children: tabs.map(function (_ref2) {
            var defaultSelected = _ref2.defaultSelected,
              id = _ref2.id,
              TabContent = _ref2.TabContent;
            return /*#__PURE__*/jsx("div", {
              className: "mpd-tabs__content ".concat(defaultSelected || id === selectedTab ? 'mpd-tabs__content opened' : ''),
              id: _this3.getTargetId(id),
              children: TabContent
            }, id);
          })
        })]
      });
    }
  }]);
}(Component);
_defineProperty(MpdTabs, "defaultProps", {
  // eslint-disable-next-line react/default-props-match-prop-types
  containerClassName: '',
  // eslint-disable-next-line react/default-props-match-prop-types
  flex: false
});

/**
 * Listen children classNames changes from container ref object
 *
 * @param ref
 * @param callback
 */
function useClassNameChanges(ref, callback) {
  var observer = useRef(new MutationObserver(callback)).current;
  useEffect(function () {
    if (observer && ref.current) {
      observer.observe(ref.current, {
        attributeFilter: ['class'],
        subtree: true
      });
    }
    return function () {
      observer.disconnect();
    };
  }, [observer, ref]);
}

function useSelector() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$selectorQuer = options.selectorQuery,
    selectorQuery = _options$selectorQuer === void 0 ? '.selected' : _options$selectorQuer,
    _options$observeQuery = options.observeQuery,
    observeQuery = _options$observeQuery === void 0 ? '.mpd-btn-v2' : _options$observeQuery,
    closestSelector = options.closestSelector;
  var containerRef = useRef(null);
  var selectorRef = useRef(null);
  var getSelectorPosition = useCallback(function (selectedItem) {
    var _containerRef$current;
    var selectedPosition = selectedItem.getBoundingClientRect().left;
    var containerPosition = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect().left) || 0;
    return selectedPosition - containerPosition;
  }, []);
  var animateSelector = useCallback(function () {
    var container = containerRef.current;
    var selectedItem = container === null || container === void 0 ? void 0 : container.querySelector(selectorQuery);
    if (closestSelector && selectedItem) {
      selectedItem = selectedItem.closest(closestSelector);
    }
    if (selectedItem) {
      var position = getSelectorPosition(selectedItem);
      var selector = selectorRef.current;
      if (!selector) {
        return;
      }
      selector.style.width = "".concat(selectedItem.offsetWidth, "px");
      selector.style.left = "".concat(position < 0 ? 0 : position, "px");
    }
  }, [getSelectorPosition, selectorQuery, closestSelector]);
  useEffect(function () {
    if (typeof ResizeObserver === 'undefined' || !containerRef.current) {
      return;
    }
    var resizeObserver = new ResizeObserver(function () {
      animateSelector();
    });
    var elements = containerRef.current.querySelectorAll(observeQuery);
    elements.forEach(function (element) {
      resizeObserver.observe(element);
    });

    // eslint-disable-next-line consistent-return
    return function () {
      resizeObserver.disconnect();
    };
  }, [animateSelector, observeQuery]);
  if (typeof window !== 'undefined') {
    useClassNameChanges(containerRef, animateSelector);
  }
  return {
    containerRef: containerRef,
    selectorRef: selectorRef,
    animateSelector: animateSelector
  };
}

function MpdLinkTabs(_ref) {
  var children = _ref.children;
  var _useSelector = useSelector({
      selectorQuery: '.selected, .active',
      observeQuery: '.mpd-tabs__tab-label',
      closestSelector: '.mpd-tabs__tab-label'
    }),
    containerRef = _useSelector.containerRef,
    selectorRef = _useSelector.selectorRef;
  return /*#__PURE__*/jsx("div", {
    className: "mpd-tabs",
    children: /*#__PURE__*/jsxs("div", {
      ref: containerRef,
      className: "mpd-tabs__tab-container",
      children: [/*#__PURE__*/jsx("div", {
        ref: selectorRef,
        className: "selector"
      }), Children.map(children, function (child) {
        if (! /*#__PURE__*/isValidElement(child)) {
          return child;
        }
        return /*#__PURE__*/jsx("span", {
          className: "mpd-tabs__tab-label h2-like",
          children: child
        });
      })]
    })
  });
}

var _excluded$4 = ["selectMode", "name", "remainingStock", "remainingStockLabel", "price", "disabled", "onChange", "quantity", "contingentName", "color"];
var _inputRef = /*#__PURE__*/new WeakMap();
var MpdTicket = /*#__PURE__*/function (_PureComponent) {
  function MpdTicket(props) {
    var _this;
    _classCallCheck(this, MpdTicket);
    _this = _callSuper(this, MpdTicket, [props]);
    _classPrivateFieldInitSpec(_this, _inputRef, void 0);
    _this.state = {
      activeInput: false,
      inputQuantity: ''
    };
    _classPrivateFieldSet2(_inputRef, _this, /*#__PURE__*/createRef());
    _this.onChangeInput = _this.onChangeInput.bind(_this);
    _this.onClickTicket = _this.onClickTicket.bind(_this);
    _this.onClickInput = _this.onClickInput.bind(_this);
    _this.onFocusInput = _this.onFocusInput.bind(_this);
    _this.onBlurInput = _this.onBlurInput.bind(_this);
    _this.addKeyboardListener = _this.addKeyboardListener.bind(_this);
    _this.removeKeyboardListener = _this.removeKeyboardListener.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.increaseSelection = _this.increaseSelection.bind(_this);
    _this.decreaseSelection = _this.decreaseSelection.bind(_this);
    return _this;
  }
  _inherits(MpdTicket, _PureComponent);
  return _createClass(MpdTicket, [{
    key: "onChangeInput",
    value: function onChangeInput(event) {
      var inputQuantity = this.state.inputQuantity;
      var target = event.target;
      if (!target.value.length) {
        this.setState({
          inputQuantity: ''
        });
        return;
      }
      var value = target.validity.valid ? Number(target.value) : inputQuantity;
      this.setState({
        inputQuantity: value
      });
    }
  }, {
    key: "onClickInput",
    value: function onClickInput(event) {
      event.stopPropagation();
      event.currentTarget.select();
    }
  }, {
    key: "onFocusInput",
    value: function onFocusInput() {
      var quantity = this.props.quantity;
      this.setState({
        activeInput: true,
        inputQuantity: quantity
      });
    }
  }, {
    key: "onBlurInput",
    value: function onBlurInput() {
      this.setState({
        activeInput: false,
        inputQuantity: ''
      });

      // eslint-disable-next-line react/destructuring-assignment
      this.props.onChange(Number(this.state.inputQuantity));
    }
  }, {
    key: "onClickTicket",
    value: function onClickTicket() {
      var _this$props = this.props,
        selectMode = _this$props.selectMode,
        onChange = _this$props.onChange,
        quantity = _this$props.quantity,
        disabled = _this$props.disabled,
        remainingStock = _this$props.remainingStock;
      if (selectMode) {
        onChange(quantity ? 0 : 1);
        return;
      }
      if (disabled) {
        onChange(quantity - 1);
        return;
      }
      if (remainingStock === 0) {
        return;
      }
      onChange(quantity + 1);
    }
  }, {
    key: "addKeyboardListener",
    value: function addKeyboardListener() {
      var selectMode = this.props.selectMode;
      if (selectMode) {
        return;
      }
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "removeKeyboardListener",
    value: function removeKeyboardListener() {
      var selectMode = this.props.selectMode;
      if (selectMode) {
        return;
      }
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var _classPrivateFieldGet3;
      var activeInput = this.state.activeInput;
      var key = event.keyCode;
      if (activeInput) {
        // enter keyboard
        if (key === 13) {
          var _classPrivateFieldGet2$1;
          (_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_inputRef, this).current) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.blur();
        }
        return;
      }
      if (key < 48 || key > 57) {
        return;
      }
      (_classPrivateFieldGet3 = _classPrivateFieldGet2(_inputRef, this).current) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.select();
    }
  }, {
    key: "increaseSelection",
    value: function increaseSelection(event) {
      event.stopPropagation();
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        quantity = _this$props2.quantity;
      onChange(quantity + 1);
    }
  }, {
    key: "decreaseSelection",
    value: function decreaseSelection(event) {
      event.stopPropagation();
      var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        quantity = _this$props3.quantity;
      onChange(quantity - 1);
    }
  }, {
    key: "renderQuantity",
    value: function renderQuantity() {
      var _this$props4 = this.props,
        selectMode = _this$props4.selectMode,
        quantity = _this$props4.quantity;
      var _this$state = this.state,
        inputQuantity = _this$state.inputQuantity,
        activeInput = _this$state.activeInput;
      if (quantity === 0 && !activeInput) {
        return null;
      }
      if (selectMode) {
        return /*#__PURE__*/jsx("div", {
          className: "mpd-ticket__aside mpd-ticket__aside--select-mode",
          children: /*#__PURE__*/jsx(MpdIcon, {
            icon: "check-filled",
            height: "24",
            width: "24",
            className: "mpd-color-white"
          })
        });
      }
      return /*#__PURE__*/jsxs("div", {
        className: "mpd-ticket__aside",
        children: [/*#__PURE__*/jsx("button", {
          type: "button",
          onClick: this.increaseSelection,
          children: "+"
        }), /*#__PURE__*/jsx("input", {
          ref: _classPrivateFieldGet2(_inputRef, this),
          type: "text",
          value: activeInput ? inputQuantity : quantity,
          onChange: this.onChangeInput,
          onClick: this.onClickInput,
          onFocus: this.onFocusInput,
          onBlur: this.onBlurInput,
          pattern: "[0-9]*"
        }), /*#__PURE__*/jsx("button", {
          type: "button",
          onClick: this.decreaseSelection,
          children: "-"
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props;
        _this$props5.selectMode;
        var name = _this$props5.name,
        remainingStock = _this$props5.remainingStock,
        remainingStockLabel = _this$props5.remainingStockLabel,
        price = _this$props5.price,
        disabled = _this$props5.disabled;
        _this$props5.onChange;
        var quantity = _this$props5.quantity,
        contingentName = _this$props5.contingentName,
        color = _this$props5.color,
        rest = _objectWithoutProperties(_this$props5, _excluded$4);
      var activeInput = this.state.activeInput;
      var ticketClasses = cn('mpd-ticket', {
        'mpd-ticket--selected': activeInput || quantity > 0,
        'mpd-ticket--disabled': disabled || remainingStock === 0
      });
      return /*#__PURE__*/jsxs("div", _objectSpread2(_objectSpread2({
        onClick: this.onClickTicket
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        ,
        onKeyPress: function onKeyPress() {},
        onMouseEnter: this.addKeyboardListener,
        onMouseLeave: this.removeKeyboardListener,
        className: ticketClasses,
        role: "button",
        tabIndex: 0
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, rest), {}, {
        children: [this.renderQuantity(), /*#__PURE__*/jsxs("div", {
          className: "mpd-ticket__content",
          children: [/*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsx("span", {
              className: "h3-like name",
              children: name
            }), /*#__PURE__*/jsx("div", {
              className: "remaining-wrapper",
              children: contingentName && /*#__PURE__*/jsxs("div", {
                className: "contingent ellipsis",
                title: contingentName,
                children: [/*#__PURE__*/jsx(MpdIcon, {
                  icon: "seat-filled",
                  color: color,
                  width: "13",
                  className: "mr1"
                }), contingentName]
              })
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: "price-wrapper",
            children: [price && /*#__PURE__*/jsx("span", {
              className: "price",
              children: price
            }), !!remainingStockLabel && /*#__PURE__*/jsx("div", {
              className: cn('remaining mr1', {
                'remaining--empty': remainingStock === 0
              }),
              children: remainingStockLabel
            })]
          })]
        })]
      }));
    }
  }]);
}(PureComponent);
_defineProperty(MpdTicket, "defaultProps", {
  // eslint-disable-next-line react/default-props-match-prop-types
  disabled: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  selectMode: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  quantity: 0
});

var _excluded$3 = ["options", "onClear", "label", "required", "errorMessage", "id", "help", "placeholder"];
function MpdCalendar(_ref) {
  var _options$dateFormat, _options$onChange, _flatpickrRef$current;
  var options = _ref.options,
    onClear = _ref.onClear,
    label = _ref.label,
    required = _ref.required,
    errorMessage = _ref.errorMessage,
    id = _ref.id,
    help = _ref.help,
    placeholder = _ref.placeholder,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  // do use translation hook to get the translation function
  // do not use Suspense and fallback to an empty string. The translation should work on server side and when client download the translations
  // This might display a warning in the console: "Did not expect server HTML to contain the text node "lundi 28 février 2022 à 18:51" in <div>."
  // but this will work fine and be SEO friendly
  var _useTranslation = useTranslation(undefined, {
      useSuspense: false
    }),
    i18n = _useTranslation.i18n,
    ready = _useTranslation.ready;
  var flatpickrRef = useRef(null);
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInputTouched = _useState2[0],
    setIsInputTouched = _useState2[1];
  if (!ready) {
    return null;
  }
  var className = rest.className,
    value = rest.value;
  var filteredClassName = className === null || className === void 0 ? void 0 : className.split(' ').filter(function (cls) {
    return cls !== 'flatpickr-input--inline';
  }).join(' ').concat(isInputTouched ? ' flatpickr-input--touched' : '');
  // In the minisite context, with NextJS, the import of react-flatpickr is some weird CommonJS exports
  // so we have an object containing `default` instead of a default export
  // @ts-expect-error default is not defined on the type
  var FlatpickrComponent = Flatpickr.default || Flatpickr;
  var formatObj = new Intl.DateTimeFormat(i18n.language).formatToParts(new Date());
  var defaultDateFormat = (_options$dateFormat = options === null || options === void 0 ? void 0 : options.dateFormat) !== null && _options$dateFormat !== void 0 ? _options$dateFormat : formatObj.map(function (obj) {
    switch (obj.type) {
      case 'day':
        return 'd';
      case 'month':
        return 'm';
      case 'year':
        return 'Y';
      default:
        return obj.value;
    }
  }).join('');
  var allowInput = options === null || options === void 0 ? void 0 : options.allowInput;
  if (options !== null && options !== void 0 && options.enableTime) {
    defaultDateFormat = defaultDateFormat.concat(' H:i');

    // When enableTime is set, we force allowInput to be false to avoid blur issue not updating correctly the input value
    // https://github.com/flatpickr/flatpickr/issues/2394#issuecomment-3467435596
    allowInput = false;
  }
  var updatedValidValue = value;
  var originalOnChange = (_options$onChange = options === null || options === void 0 ? void 0 : options.onChange) !== null && _options$onChange !== void 0 ? _options$onChange : rest.onChange;
  if (
  // if onChange is defined (and is not an array of function)
  typeof originalOnChange === 'function' &&
  // fix the endDate of the "range" mode
  (options === null || options === void 0 ? void 0 : options.mode) === 'range') {
    // eslint-disable-next-line no-param-reassign
    delete rest.onChange; // we will handle onChange in options to be sure to have the correct parameters

    // eslint-disable-next-line no-param-reassign
    options.onChange = function (selectedDates, dateStr, instance) {
      var _selectedDates = _slicedToArray(selectedDates, 2),
        startDate = _selectedDates[0],
        endDate = _selectedDates[1];
      if (endDate && (
      // do not touch the endDate when enableTime is set if the time is not stricly the same as the start date
      (options === null || options === void 0 ? void 0 : options.enableTime) !== true || (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) === endDate.getTime())) {
        endDate.setHours(23, 59, 59); // set end date to the end of the day
      }
      originalOnChange([startDate, endDate].filter(Boolean), dateStr, instance);
    };
  }
  var onClose = options === null || options === void 0 ? void 0 : options.onClose;

  // allowInput option does not trigger onChange event = we need to trigger onClose event
  if (options !== null && options !== void 0 && options.allowInput && options !== null && options !== void 0 && options.onChange && !onClose) {
    onClose = options.onChange;
  }
  var flatpickrObj = (_flatpickrRef$current = flatpickrRef.current) === null || _flatpickrRef$current === void 0 ? void 0 : _flatpickrRef$current.flatpickr;
  var inputIsHidden = className === null || className === void 0 ? void 0 : className.includes('flatpickr-input--inline');

  // assure the date format sent to flatpickr is iso
  if (typeof value === 'string' || typeof value === 'number') {
    updatedValidValue = new Date(value);
  }
  var restUpdated = _objectSpread2(_objectSpread2({}, rest), value ? {
    value: updatedValidValue
  } : {});
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-calendar', filteredClassName, {
      'mpd-calendar--above': (options === null || options === void 0 ? void 0 : options.position) === 'above'
    }),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: inputId,
      label: label,
      required: required
    }), /*#__PURE__*/jsxs("div", {
      className: "flatpickr-container",
      children: [/*#__PURE__*/jsx(FlatpickrComponent, _objectSpread2({
        ref: flatpickrRef,
        required: required,
        placeholder: placeholder,
        onFocus: function onFocus() {
          return setIsInputTouched(true);
        },
        options: _objectSpread2(_objectSpread2({}, options), {}, {
          locale: i18n.language,
          dateFormat: defaultDateFormat,
          altFormat: defaultDateFormat,
          minuteIncrement: 1,
          onClose: onClose,
          allowInput: allowInput
        })
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, restUpdated)), !inputIsHidden && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("button", {
          className: "mpd-btn mpd-btn--icon-only flatpickr-calendar-btn",
          type: "button",
          onClick: function onClick() {
            if (flatpickrRef.current) {
              flatpickrObj === null || flatpickrObj === void 0 || flatpickrObj.open();
            }
          },
          children: /*#__PURE__*/jsx(MpdIcon, {
            className: "flatpickr-calendar-icon",
            icon: "agenda",
            width: "20"
          })
        }), (flatpickrObj === null || flatpickrObj === void 0 ? void 0 : flatpickrObj.input.value) && onClear && /*#__PURE__*/jsx("button", {
          className: "mpd-btn mpd-btn--icon-only flatpickr-clear-btn",
          type: "button",
          onClick: function onClick() {
            if (onClear) {
              onClear();
            }

            // using .setDate() instead of .clear() because otherwise it sets the input to today's date (bug)
            flatpickrObj === null || flatpickrObj === void 0 || flatpickrObj.setDate('');
          },
          children: /*#__PURE__*/jsx(MpdIcon, {
            icon: "cross",
            width: "12"
          })
        })]
      })]
    }), /*#__PURE__*/jsx(MpdInputMessages, {
      helpMessage: help,
      errorMessage: errorMessage
    })]
  });
}

function MpdOfferHeader(_ref) {
  var title = _ref.title,
    ticketCount = _ref.ticketCount,
    ticketCountTrans = _ref.ticketCountTrans,
    color = _ref.color,
    price = _ref.price,
    _ref$hideIndividualPr = _ref.hideIndividualPrice,
    hideIndividualPrice = _ref$hideIndividualPr === void 0 ? false : _ref$hideIndividualPr,
    actionBtnBlock = _ref.actionBtnBlock;
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-offer-header gradiant-background-color-".concat(color, "-vertical"),
    children: [/*#__PURE__*/jsx("div", {
      className: "mpd-offer-header__left",
      children: /*#__PURE__*/jsx("div", {
        className: "offer",
        children: /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("span", {
            className: "h2-like",
            children: ticketCount
          }), /*#__PURE__*/jsx("span", {
            className: "small",
            children: ticketCountTrans
          })]
        })
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-offer-header__details",
      children: [/*#__PURE__*/jsx("h2", {
        className: "title",
        children: title
      }), hideIndividualPrice && /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx("span", {
          className: "h3-like white mr2",
          children: price
        })
      }), /*#__PURE__*/jsx("div", {
        className: "actions",
        children: actionBtnBlock
      })]
    })]
  });
}

function EventHeaderImageBlock(_ref) {
  var imageUrl = _ref.imageUrl,
    id = _ref.id;
  var colorClass = generatorBackgroundColorClass(id);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    jsx(Fragment, {
      children: typeof imageUrl === 'string' ? /*#__PURE__*/jsx("div", {
        className: "image",
        children: /*#__PURE__*/jsx("img", {
          alt: "",
          src: imageUrl
        })
      }) : /*#__PURE__*/jsx("div", {
        className: "h100 w100 ".concat(colorClass)
      })
    })
  );
}

function MpdEventHeader(_ref) {
  var title = _ref.title,
    imageUrl = _ref.imageUrl,
    dateBlock = _ref.dateBlock,
    ticketCountTrans = _ref.ticketCountTrans,
    seatingName = _ref.seatingName,
    formattedDateAndEndDate = _ref.formattedDateAndEndDate,
    id = _ref.id,
    actionBtnBlock = _ref.actionBtnBlock,
    eventDateAccessBlock = _ref.eventDateAccessBlock;
  var displayImageBlock = typeof imageUrl === 'string' || !imageUrl && !dateBlock;
  var displayDateBlock = !!dateBlock && !imageUrl;
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-event-header', {
      'mpd-event-header--with-img': displayImageBlock
    }),
    children: [/*#__PURE__*/jsxs("div", {
      className: cn('mpd-event-header__left', {
        'mpd-event-header__left--with-border': displayDateBlock
      }),
      children: [displayImageBlock && /*#__PURE__*/jsx(EventHeaderImageBlock, {
        imageUrl: imageUrl,
        id: id
      }), displayDateBlock && dateBlock]
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-event-header__details",
      children: [/*#__PURE__*/jsxs("div", {
        children: [displayImageBlock && /*#__PURE__*/jsx("div", {
          children: formattedDateAndEndDate
        }), /*#__PURE__*/jsx("h2", {
          className: "title ellipsis-title",
          children: /*#__PURE__*/jsx("span", {
            children: title
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "mpd-color-light-gray ellipsis",
          children: [seatingName && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx("span", {
              className: "small",
              children: seatingName
            }), /*#__PURE__*/jsx("span", {
              className: "small ml2 mr2",
              children: "|"
            })]
          }), /*#__PURE__*/jsx("span", {
            className: "small",
            children: ticketCountTrans
          })]
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "actions",
        children: actionBtnBlock
      })]
    }), eventDateAccessBlock && /*#__PURE__*/jsx("div", {
      className: "flex-center",
      children: eventDateAccessBlock
    })]
  });
}

var _excluded$2 = ["id", "label", "className", "inputClassName", "disabled", "required", "errorMessage", "successMessage", "help", "icon", "submitLabel", "onSubmit", "onClear"];
var MpdInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    errorMessage = _ref.errorMessage,
    successMessage = _ref.successMessage,
    help = _ref.help,
    icon = _ref.icon,
    submitLabel = _ref.submitLabel,
    onSubmit = _ref.onSubmit,
    onClear = _ref.onClear,
    input = _objectWithoutProperties(_ref, _excluded$2);
  var hasSubmit = !!onSubmit && !!submitLabel;
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-input', className, {
      'mpd-input--disabled': disabled,
      'mpd-input--error': !!errorMessage,
      'mpd-input--success': !!successMessage,
      'mpd-input--with-icon': !!icon,
      'mpd-input--with-submit': hasSubmit,
      'mpd-input--time': input.type === 'time',
      'mpd-input--readonly': input.readOnly
    }),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: inputId,
      label: label,
      required: required
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-input__control",
      children: [icon && /*#__PURE__*/jsx(MpdIcon, {
        icon: icon,
        width: "20",
        className: "input-icon mpd-color-blue"
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("input", _objectSpread2({
          ref: ref,
          id: inputId,
          className: inputClassName,
          disabled: disabled,
          required: required
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, input)), !!errorMessage && /*#__PURE__*/jsx(MpdIcon, {
          icon: "cross",
          className: "message-icon"
        }), !!successMessage && /*#__PURE__*/jsx(MpdIcon, {
          icon: "check",
          className: "message-icon"
        })]
      }), hasSubmit && /*#__PURE__*/jsx("button", {
        type: "button",
        className: "mpd-btn mpd-btn--primary",
        onClick: onSubmit,
        disabled: !input.value,
        children: submitLabel
      }), !!onClear && input.value && /*#__PURE__*/jsx("button", {
        className: "mpd-input__clear-icon mpd-btn mpd-btn--icon-only",
        type: "button",
        onClick: onClear,
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "cross",
          width: "12"
        })
      })]
    }), /*#__PURE__*/jsx(MpdInputMessages, {
      helpMessage: help,
      successMessage: successMessage,
      errorMessage: errorMessage
    })]
  });
});

var _excluded$1 = ["id", "label", "value", "onChange", "defaultCountryCode", "showInternationalPrefix", "disabled", "required", "errorMessage", "successMessage", "helpMessage", "className"];
var DEFAULT_COUNTRY_CODE = 'FR';
var CUSTOM_FLAGS = _objectSpread2(_objectSpread2({}, flags), {}, {
  // Guyane
  GF: flags.FR,
  // Martinique
  MQ: flags.FR,
  // Saint-Barthélemy
  BL: flags.FR,
  // Saint-Martin
  MF: flags.FR,
  // Wallis-et-Futuna
  WF: flags.FR,
  // Mayotte
  YT: flags.FR
});
function MpdPhoneInput(_ref) {
  var id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    defaultCountryCode = _ref.defaultCountryCode,
    _ref$showInternationa = _ref.showInternationalPrefix,
    showInternationalPrefix = _ref$showInternationa === void 0 ? true : _ref$showInternationa,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    errorMessage = _ref.errorMessage,
    successMessage = _ref.successMessage,
    helpMessage = _ref.helpMessage,
    className = _ref.className,
    inputProps = _objectWithoutProperties(_ref, _excluded$1);
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  var countryCode = defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : DEFAULT_COUNTRY_CODE;
  var getCleanValue = function getCleanValue() {
    if (value && !value.startsWith('+') && isPossiblePhoneNumber(value, countryCode)) {
      var _parsedPhoneNumber$nu;
      var parsedPhoneNumber = parsePhoneNumber(value, countryCode);
      return (_parsedPhoneNumber$nu = parsedPhoneNumber === null || parsedPhoneNumber === void 0 ? void 0 : parsedPhoneNumber.number) !== null && _parsedPhoneNumber$nu !== void 0 ? _parsedPhoneNumber$nu : value;
    }
    return value;
  };
  var cleanValue = getCleanValue();
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-phone-input', className, {
      'mpd-input--error': !!errorMessage,
      'mpd-input--success': !!successMessage,
      'mpd-input--disabled': disabled
    }),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: inputId,
      label: label,
      required: required
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-phone-input__control",
      children: [/*#__PURE__*/jsx(Phone, _objectSpread2({
        className: "mpd-phone-input__react-phone",
        international: showInternationalPrefix,
        labels: countryCode === DEFAULT_COUNTRY_CODE ? frLabels : enLabels,
        flags: CUSTOM_FLAGS,
        defaultCountry: countryCode,
        value: cleanValue,
        onChange: function onChange(v) {
          if (_onChange) {
            _onChange(v);
          }
        },
        disabled: disabled,
        required: required
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, inputProps)), !!errorMessage && /*#__PURE__*/jsx(MpdIcon, {
        icon: "cross",
        className: "message-icon"
      }), !!successMessage && /*#__PURE__*/jsx(MpdIcon, {
        icon: "check",
        className: "message-icon"
      })]
    }), /*#__PURE__*/jsx(MpdInputMessages, {
      helpMessage: helpMessage,
      successMessage: successMessage,
      errorMessage: errorMessage
    })]
  });
}

function MpdFieldset(_ref) {
  var legend = _ref.legend,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/jsxs("fieldset", {
    className: cn('mpd-fieldset', className),
    children: [/*#__PURE__*/jsx("legend", {
      children: legend
    }), children]
  });
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, react/function-component-definition
var DropdownIndicator = function DropdownIndicator(props) {
  // eslint-disable-next-line react/destructuring-assignment
  var menuIsOpen = props.selectProps.menuIsOpen;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx(components.DropdownIndicator, _objectSpread2(_objectSpread2({}, props), {}, {
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: menuIsOpen ? 'arrow-top' : 'arrow-down',
        width: "24",
        className: "mpd-color-blue ml1"
      })
    }))
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, react/function-component-definition
var ClearIndicator = function ClearIndicator(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx(components.ClearIndicator, _objectSpread2(_objectSpread2({}, props), {}, {
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: "cross",
        className: "mpd-color-light-gray ml1"
      })
    }))
  );
};

var NoOptionsMessage = function NoOptionsMessage(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // eslint-disable-next-line react/destructuring-assignment
  var customElement = props.selectProps.renderNoOptions;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx(components.NoOptionsMessage, _objectSpread2(_objectSpread2({}, props), {}, {
      children: customElement || /*#__PURE__*/jsx("div", {
        children: t('multi_select.no_option')
      })
    }))
  );
};

var LoadingIndicator = function LoadingIndicator() {
  return /*#__PURE__*/jsx(MpdLoader, {
    size: "xs"
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, react/function-component-definition
var GroupHeading = function GroupHeading(props) {
  var data = props.data;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsxs(components.GroupHeading, _objectSpread2(_objectSpread2({}, props), {}, {
      className: "mpd-select-group-heading",
      children: [/*#__PURE__*/jsx("span", {
        className: "mpd-select-group-heading-label",
        children: data.label
      }), /*#__PURE__*/jsx("span", {
        className: "mpd-select-group-heading-count",
        children: data.groupCountLabel
      })]
    }))
  );
};

var Option$1 = function Option(props) {
  var children = props.children,
    _props$data = props.data,
    iconName = _props$data.iconName,
    iconColor = _props$data.iconColor,
    asideLabel = _props$data.asideLabel,
    subLabel = _props$data.subLabel,
    imageUrl = _props$data.imageUrl,
    isGrouped = props.selectProps.isGrouped,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    jsx(Fragment, {
      children: /*#__PURE__*/jsxs(components.Option, _objectSpread2(_objectSpread2({}, props), {}, {
        className: cn({
          'mpd-single-select-option--grouped': isGrouped,
          'mpd-single-select-option--selected': isSelected
        }),
        children: [/*#__PURE__*/jsxs("div", {
          className: cn('mpd-single-select-label', {
            'mpd-color-black': !isDisabled
          }),
          children: [iconName && /*#__PURE__*/jsx(MpdIcon, {
            icon: iconName,
            color: iconColor,
            width: "12",
            className: "mr2"
          }), imageUrl && /*#__PURE__*/jsx("img", {
            className: "mr2",
            src: imageUrl,
            loading: "lazy",
            title: imageUrl,
            alt: imageUrl,
            width: 20
          }), /*#__PURE__*/jsxs("div", {
            className: "flex-column",
            children: [/*#__PURE__*/jsx("span", {
              className: cn({
                bold: !!subLabel
              }),
              children: children
            }), subLabel && /*#__PURE__*/jsx("small", {
              className: "small",
              children: subLabel
            })]
          })]
        }), asideLabel && /*#__PURE__*/jsx("span", {
          className: "mpd-single-select-value-aside-label",
          children: asideLabel
        })]
      }))
    })
  );
};

// eslint-disable-next-line react/function-component-definition
var Control = function Control(props) {
  var children = props.children,
    autocomplete = props.selectProps.autocomplete;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsxs(components.Control, _objectSpread2(_objectSpread2({}, props), {}, {
      children: [autocomplete && !props.selectProps.value && /*#__PURE__*/jsx(MpdIcon, {
        className: "mpd-single-select-control__icon ml1",
        icon: "magnifying-glass"
      }), children]
    }))
  );
};

var ValueContainer = function ValueContainer(props) {
  var selectProps = props.selectProps;
  var value = selectProps === null || selectProps === void 0 ? void 0 : selectProps.value;
  var inputValue = selectProps === null || selectProps === void 0 ? void 0 : selectProps.inputValue;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs(components.ValueContainer, _objectSpread2(_objectSpread2({}, props), {}, {
      children: [/*#__PURE__*/jsxs("div", {
        className: "mpd-single-select-label",
        children: [(value === null || value === void 0 ? void 0 : value.iconName) && !inputValue && /*#__PURE__*/jsx(MpdIcon, {
          icon: value.iconName,
          color: value.iconColor,
          width: "12",
          className: "ml1 mr2"
        }), (value === null || value === void 0 ? void 0 : value.imageUrl) && !inputValue && /*#__PURE__*/jsx("img", {
          className: "mr2",
          src: value === null || value === void 0 ? void 0 : value.imageUrl,
          loading: "lazy",
          title: value === null || value === void 0 ? void 0 : value.imageUrl,
          alt: value === null || value === void 0 ? void 0 : value.imageUrl,
          width: 20
        }), props.children]
      }), (value === null || value === void 0 ? void 0 : value.asideLabel) && !inputValue && /*#__PURE__*/jsx("span", {
        className: "mpd-single-select-value-aside-label",
        children: value.asideLabel
      })]
    }))
  });
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
    subLabel = props.data.subLabel;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(components.SingleValue, _objectSpread2(_objectSpread2({}, props), {}, {
      children: /*#__PURE__*/jsxs("div", {
        className: "flex-column",
        children: [/*#__PURE__*/jsx("span", {
          className: cn({
            bold: !!subLabel
          }),
          children: children
        }), subLabel && /*#__PURE__*/jsx("small", {
          className: "small",
          children: subLabel
        })]
      })
    }))
  });
};

// This import is necessary for module augmentation. It allows us to extend the 'Props' interface in the 'react-select/base' module and add our custom properties to it.

function isGroupedOption(option) {
  return option.options !== undefined;
}
var secondaryLightGray = '#d2d7dc';
var secondaryWhite = '#f7f5f7';
var alertRed = '#cf1b01';
var getSelectTheme = function getSelectTheme(theme, errorMessage) {
  var borderColor = errorMessage ? alertRed : secondaryLightGray;
  return _objectSpread2(_objectSpread2({}, theme), {}, {
    borderRadius: 2,
    colors: _objectSpread2(_objectSpread2({}, theme.colors), {}, {
      neutral20: borderColor,
      neutral30: borderColor,
      primary: borderColor,
      primary25: secondaryWhite,
      primary50: secondaryLightGray
    }),
    spacing: _objectSpread2(_objectSpread2({}, theme.spacing), {}, {
      controlHeight: 60
    })
  });
};

var DEFAULT_DELAY = 100;
function debounce(func) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DELAY;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return func.apply(void 0, args);
    }, ms);
  };
}

function useLoadData(loadOptions, defaultInputValue) {
  var mounted = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasMore = _useState4[0],
    setHasMore = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    options = _useState6[0],
    setOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    searchedOptions = _useState8[0],
    setSearchedOptions = _useState8[1];
  var _useState9 = useState(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : null),
    _useState0 = _slicedToArray(_useState9, 2),
    searchedValue = _useState0[0],
    setSearchedValue = _useState0[1];
  var debouncedLoadOptions = useMemo(function () {
    return debounce(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
        var _yield, hasMoreItem, newOptionArray;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return loadOptions(1, query);
            case 1:
              _yield = _context.v;
              hasMoreItem = _yield.hasMore;
              newOptionArray = _yield.options;
              setHasMore(function (prev) {
                return hasMoreItem || prev;
              });
              setSearchedOptions(newOptionArray);
              setIsLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 600);
  }, [loadOptions]);
  var searchData = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var query,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          query = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
          setSearchedValue(query);
          if (!(typeof loadOptions !== 'function')) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          if (query) {
            _context2.n = 2;
            break;
          }
          setSearchedOptions(null); // reset search
          return _context2.a(2);
        case 2:
          setIsLoading(true);
          debouncedLoadOptions(query);
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  })), [loadOptions, debouncedLoadOptions]);
  var loadData = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(page) {
      var displayLoader,
        _yield$loadOptions,
        hasMoreItem,
        newOptionArray,
        _args3 = arguments;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            displayLoader = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
            if (!(typeof loadOptions !== 'function')) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            setIsLoading(displayLoader);
            _context3.n = 2;
            return loadOptions(page, searchedValue);
          case 2:
            _yield$loadOptions = _context3.v;
            hasMoreItem = _yield$loadOptions.hasMore;
            newOptionArray = _yield$loadOptions.options;
            setHasMore(hasMoreItem !== null && hasMoreItem !== void 0 ? hasMoreItem : false);
            if (searchedOptions) {
              setSearchedOptions(function (prev) {
                return (prev || []).concat(newOptionArray);
              });
            } else {
              setOptions(function (prev) {
                return prev.concat(newOptionArray);
              });
            }
            setIsLoading(false);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [loadOptions, searchedOptions, searchedValue]);
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  useEffect(function () {
    if (!mounted.current) {
      return;
    }
    loadData(1, !!defaultInputValue);
    // Inspired by https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/useAsync.ts#L126
    // We don't want any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [isLoading, hasMore, searchedOptions !== null && searchedOptions !== void 0 ? searchedOptions : options, loadData, searchData];
}

function MpdSingleSelect(_ref) {
  var _optionsProps$options, _optionsProps$options2;
  var id = _ref.id,
    _placeholder = _ref.placeholder,
    label = _ref.label,
    options = _ref.options,
    loadOptions = _ref.loadOptions,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? false : _ref$searchable,
    _ref$creatable = _ref.creatable,
    creatable = _ref$creatable === void 0 ? false : _ref$creatable,
    _ref$autocomplete = _ref.autocomplete,
    autocomplete = _ref$autocomplete === void 0 ? false : _ref$autocomplete,
    name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    classnames = _ref.classnames,
    errorMessage = _ref.errorMessage,
    helpMessage = _ref.helpMessage,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    filterOption = _ref.filterOption,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    clearable = _ref.clearable,
    _ref$isBorderless = _ref.isBorderless,
    isBorderless = _ref$isBorderless === void 0 ? false : _ref$isBorderless,
    _ref$menuPosition = _ref.menuPosition,
    menuPosition = _ref$menuPosition === void 0 ? 'fixed' : _ref$menuPosition,
    renderNoOptions = _ref.renderNoOptions,
    defaultInputValue = _ref.defaultInputValue,
    defaultMenuIsOpen = _ref.defaultMenuIsOpen;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var selectRef = useRef(null);
  var _useLoadData = useLoadData(loadOptions, defaultInputValue),
    _useLoadData2 = _slicedToArray(_useLoadData, 5),
    isLoading = _useLoadData2[0],
    hasMore = _useLoadData2[1],
    loadedOptions = _useLoadData2[2],
    loadData = _useLoadData2[3],
    searchData = _useLoadData2[4];
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var isUsingModalPolyfill = typeof HTMLDialogElement !== 'function';
  var handleOnFocus = function handleOnFocus(e) {
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleOnBlur = function handleOnBlur(e) {
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleOnChange = function handleOnChange(option) {
    if (onChange) {
      onChange(option);
    }
  };
  var handleInputChange = function handleInputChange(newValue, _ref2) {
    var action = _ref2.action;
    var query = newValue || null;
    if (action === 'input-change') {
      searchData(query);
      setCurrentPage(1);
    }
    if (action === 'menu-close') {
      searchData(null);
      setCurrentPage(1);
    }
  };
  var handleLoadMore = function handleLoadMore() {
    if (!hasMore) {
      return;
    }
    loadData(currentPage + 1);
    setCurrentPage(function (prev) {
      return prev + 1;
    });
  };
  var getOptionsProps = function getOptionsProps() {
    if (typeof loadOptions === 'function') {
      return {
        isLoading: isLoading,
        loadingMessage: function loadingMessage() {
          return t('loading');
        },
        options: loadedOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: debounce(handleLoadMore)
      };
    }
    if (creatable) {
      return {
        options: options,
        // options have been set as prop. No need to load options
        onInputChange: handleInputChange
      };
    }
    return {
      options: options // options have been set as prop. No need to load options
    };
  };
  var optionsProps = getOptionsProps();
  var components = {
    DropdownIndicator: autocomplete ? null : DropdownIndicator,
    ClearIndicator: ClearIndicator,
    NoOptionsMessage: NoOptionsMessage,
    LoadingIndicator: LoadingIndicator,
    Control: Control,
    Option: Option$1,
    ValueContainer: ValueContainer,
    GroupHeading: GroupHeading,
    SingleValue: SingleValue
  };
  var selectId = id !== null && id !== void 0 ? id : generateRandomID();
  var SelectComponent = creatable ? Creatable : Select;
  var isSearchable = creatable || searchable || !!loadOptions || autocomplete; // Creatable, Async and Autcomplete select are always searchable.

  var isGrouped = (_optionsProps$options = (_optionsProps$options2 = optionsProps.options) === null || _optionsProps$options2 === void 0 ? void 0 : _optionsProps$options2.some(function (option) {
    return isGroupedOption(option);
  })) !== null && _optionsProps$options !== void 0 ? _optionsProps$options : false;
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-single-select', classnames),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: selectId,
      label: label,
      required: required
    }), /*#__PURE__*/jsx(SelectComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _objectSpread2(_objectSpread2({}, optionsProps), {}, {
      // modal css position changes depending on polyfill use
      menuPosition: isUsingModalPolyfill ? 'absolute' : menuPosition,
      menuPlacement: "auto",
      minMenuHeight: 300,
      ref: selectRef,
      id: selectId,
      name: name,
      placeholder: _placeholder,
      required: required,
      value: value,
      defaultValue: defaultValue,
      isDisabled: disabled,
      isSearchable: isSearchable,
      isClearable: clearable !== null && clearable !== void 0 ? clearable : isSearchable,
      isOptionDisabled: function isOptionDisabled(option) {
        var _option$disabled;
        return (_option$disabled = option.disabled) !== null && _option$disabled !== void 0 ? _option$disabled : false;
      },
      formatCreateLabel: function formatCreateLabel(optionName) {
        return t('multi_select.add_option', {
          optionName: optionName
        });
      },
      renderNoOptions: renderNoOptions,
      isGrouped: isGrouped,
      autocomplete: autocomplete,
      openMenuOnClick: !autocomplete,
      onBlur: handleOnBlur,
      onFocus: handleOnFocus,
      onChange: handleOnChange,
      filterOption: filterOption,
      isValidNewOption: function isValidNewOption(inputValue) {
        return inputValue.trim().length > 0;
      },
      autoFocus: autoFocus,
      defaultInputValue: defaultInputValue,
      defaultMenuIsOpen: defaultMenuIsOpen,
      components: components,
      theme: function theme(_theme) {
        return getSelectTheme(_theme, errorMessage);
      },
      classNames: {
        indicatorSeparator: function indicatorSeparator() {
          return 'hidden';
        },
        placeholder: function placeholder() {
          return _placeholder ? 'mpd-color-gray' : 'hidden';
        },
        control: function control(_ref3) {
          var isFocused = _ref3.isFocused;
          return cn('mpd-single-select-control', {
            'mpd-single-select-control--is-borderless': isBorderless,
            'mpd-single-select-control--error': errorMessage,
            'mpd-single-select-control--is-focused': isFocused
          });
        },
        input: function input(props) {
          return cn('mpd-single-select-input', {
            hidden: autocomplete && !!props.selectProps.value
          });
        },
        valueContainer: function valueContainer() {
          return 'mpd-single-select-value-container';
        },
        option: function option() {
          return 'mpd-single-select-option';
        },
        singleValue: function singleValue() {
          return 'mpd-single-select-single-value';
        },
        menu: function menu(props) {
          return cn('mpd-select-menu', {
            hidden: autocomplete && !props.selectProps.inputValue
          });
        },
        menuList: function menuList(props) {
          return cn({
            'mpd-select-custom-no-options': !!props.selectProps.renderNoOptions
          });
        },
        noOptionsMessage: function noOptionsMessage(props) {
          return cn({
            'mpd-select-custom-no-options': !!props.selectProps.renderNoOptions
          });
        }
      }
    })), /*#__PURE__*/jsx(MpdInputMessages, {
      helpMessage: helpMessage,
      errorMessage: errorMessage
    })]
  });
}

var MultiValueRemove = function MultiValueRemove(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx(components.MultiValueRemove, _objectSpread2(_objectSpread2({}, props), {}, {
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: "cross",
        width: "8px"
      })
    }))
  );
};

var MultiValueLabel = function MultiValueLabel(props) {
  var children = props.children,
    _props$data = props.data,
    iconName = _props$data.iconName,
    iconColor = _props$data.iconColor,
    backgroundColor = _props$data.backgroundColor,
    asideLabel = _props$data.asideLabel;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsxs(components.MultiValueLabel, _objectSpread2(_objectSpread2({}, props), {}, {
      children: [iconName && /*#__PURE__*/jsx(MpdIcon, {
        icon: iconName,
        color: iconColor,
        width: "12",
        className: "mr1"
      }), /*#__PURE__*/jsxs("span", {
        className: backgroundColor ? 'mpd-color-white' : 'mpd-color-black',
        children: [children, asideLabel && /*#__PURE__*/jsxs("span", {
          className: "mpd-color-gray",
          children: [" - ", asideLabel]
        })]
      })]
    }))
  );
};

var Option = function Option(props) {
  var children = props.children,
    _props$data = props.data,
    iconName = _props$data.iconName,
    iconColor = _props$data.iconColor,
    backgroundColor = _props$data.backgroundColor,
    asideLabel = _props$data.asideLabel,
    subLabel = _props$data.subLabel,
    imageUrl = _props$data.imageUrl,
    isGrouped = props.selectProps.isGrouped;
  return /*#__PURE__*/jsx(components.Option, _objectSpread2(_objectSpread2({}, props), {}, {
    className: cn({
      'mpd-multi-select-option--grouped': isGrouped
    }),
    children: /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("div", {
        className: "flex-row",
        children: [iconName && /*#__PURE__*/jsx(MpdIcon, {
          icon: iconName,
          color: iconColor,
          width: "12",
          className: "mr2"
        }), imageUrl && /*#__PURE__*/jsx("img", {
          className: "mr2",
          src: imageUrl,
          loading: "lazy",
          title: imageUrl,
          alt: imageUrl,
          width: 20
        }), backgroundColor && /*#__PURE__*/jsx("div", {
          className: "mpd-multi-select-option-indicator mr2",
          style: {
            backgroundColor: backgroundColor
          }
        }), /*#__PURE__*/jsxs("div", {
          className: "flex-column",
          children: [/*#__PURE__*/jsx("span", {
            className: cn({
              bold: !!subLabel
            }),
            children: children
          }), subLabel && /*#__PURE__*/jsx("small", {
            className: "small",
            children: subLabel
          })]
        })]
      }), asideLabel && /*#__PURE__*/jsx("span", {
        className: "mpd-multi-select-value-aside-label",
        children: asideLabel
      })]
    })
  }));
};

function MpdMultiSelect(_ref) {
  var _optionsProps$options, _optionsProps$options2;
  var id = _ref.id,
    _placeholder = _ref.placeholder,
    label = _ref.label,
    options = _ref.options,
    loadOptions = _ref.loadOptions,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? false : _ref$searchable,
    _ref$creatable = _ref.creatable,
    creatable = _ref$creatable === void 0 ? false : _ref$creatable,
    name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    classnames = _ref.classnames,
    errorMessage = _ref.errorMessage,
    helpMessage = _ref.helpMessage,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    filterOption = _ref.filterOption,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$menuPosition = _ref.menuPosition,
    menuPosition = _ref$menuPosition === void 0 ? 'fixed' : _ref$menuPosition,
    renderNoOptions = _ref.renderNoOptions,
    defaultInputValue = _ref.defaultInputValue,
    defaultMenuIsOpen = _ref.defaultMenuIsOpen;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLoadData = useLoadData(loadOptions, defaultInputValue),
    _useLoadData2 = _slicedToArray(_useLoadData, 5),
    isLoading = _useLoadData2[0],
    hasMore = _useLoadData2[1],
    loadedOptions = _useLoadData2[2],
    loadData = _useLoadData2[3],
    searchData = _useLoadData2[4];
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var isUsingModalPolyfill = typeof HTMLDialogElement !== 'function';
  var handleOnFocus = function handleOnFocus(e) {
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleOnBlur = function handleOnBlur(e) {
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleOnChange = function handleOnChange(selectedOptions) {
    if (onChange) {
      onChange(selectedOptions);
    }
  };
  var handleInputChange = function handleInputChange(newValue, _ref2) {
    var action = _ref2.action;
    var query = newValue || null;
    if (action === 'input-change') {
      searchData(query);
      setCurrentPage(1);
    }
    if (action === 'menu-close') {
      searchData(null);
      setCurrentPage(1);
    }
  };
  var handleLoadMore = function handleLoadMore() {
    if (!hasMore) {
      return;
    }
    loadData(currentPage + 1);
    setCurrentPage(function (prev) {
      return prev + 1;
    });
  };
  var getOptionsProps = function getOptionsProps() {
    if (typeof loadOptions === 'function') {
      return {
        isLoading: isLoading,
        loadingMessage: function loadingMessage() {
          return t('loading');
        },
        options: loadedOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: debounce(handleLoadMore)
      };
    }
    return {
      options: options // options have been set as prop. No need to load options
    };
  };
  var optionsProps = getOptionsProps();
  var selectId = id !== null && id !== void 0 ? id : generateRandomID();
  var MultiSelectComponent = creatable ? Creatable : Select;
  var isSearchable = creatable || searchable || !!loadOptions; // Creatable and Async select are always searchable.
  var isGrouped = (_optionsProps$options = (_optionsProps$options2 = optionsProps.options) === null || _optionsProps$options2 === void 0 ? void 0 : _optionsProps$options2.some(function (option) {
    return isGroupedOption(option);
  })) !== null && _optionsProps$options !== void 0 ? _optionsProps$options : false;
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-multi-select', classnames),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: selectId,
      label: label,
      required: required
    }), /*#__PURE__*/jsx(MultiSelectComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _objectSpread2(_objectSpread2({}, optionsProps), {}, {
      id: selectId,
      autoFocus: autoFocus,
      name: name,
      placeholder: _placeholder,
      defaultValue: defaultValue,
      value: value,
      required: required,
      isDisabled: disabled,
      isMulti: true,
      isSearchable: isSearchable,
      isClearable: isSearchable,
      isOptionDisabled: function isOptionDisabled(option) {
        var _option$disabled;
        return (_option$disabled = option.disabled) !== null && _option$disabled !== void 0 ? _option$disabled : false;
      },
      renderNoOptions: renderNoOptions,
      formatCreateLabel: function formatCreateLabel(optionName) {
        return t('multi_select.add_option', {
          optionName: optionName
        });
      },
      isGrouped: isGrouped
      // modal css position changes depending on polyfill use
      ,
      menuPosition: isUsingModalPolyfill ? 'absolute' : menuPosition,
      menuPlacement: "auto",
      minMenuHeight: 300,
      defaultInputValue: defaultInputValue,
      defaultMenuIsOpen: defaultMenuIsOpen,
      onBlur: handleOnBlur,
      onFocus: handleOnFocus,
      onChange: handleOnChange,
      filterOption: filterOption,
      isValidNewOption: function isValidNewOption(inputValue) {
        return inputValue.trim().length > 0;
      },
      components: {
        DropdownIndicator: DropdownIndicator,
        ClearIndicator: ClearIndicator,
        NoOptionsMessage: NoOptionsMessage,
        LoadingIndicator: LoadingIndicator,
        MultiValueRemove: MultiValueRemove,
        MultiValueLabel: MultiValueLabel,
        Option: Option,
        GroupHeading: GroupHeading
      },
      theme: function theme(_theme) {
        return getSelectTheme(_theme, errorMessage);
      },
      classNames: {
        indicatorSeparator: function indicatorSeparator() {
          return 'hidden';
        },
        placeholder: function placeholder() {
          return _placeholder ? 'mpd-color-gray' : 'hidden';
        },
        control: function control(_ref3) {
          var isFocused = _ref3.isFocused;
          return cn('mpd-multi-select-control', {
            'mpd-multi-select-control--error': errorMessage,
            'mpd-multi-select-control--is-focused': isFocused
          });
        },
        option: function option() {
          return 'mpd-multi-select-option';
        },
        multiValue: function multiValue() {
          return 'mpd-multi-select-value';
        },
        multiValueRemove: function multiValueRemove() {
          return 'mpd-multi-select-value-remove';
        },
        menu: function menu() {
          return 'mpd-select-menu';
        },
        menuList: function menuList(props) {
          return cn({
            'mpd-select-custom-no-options': !!props.selectProps.renderNoOptions
          });
        },
        noOptionsMessage: function noOptionsMessage(props) {
          return cn({
            'mpd-select-custom-no-options': !!props.selectProps.renderNoOptions
          });
        }
      },
      styles: {
        multiValue: function multiValue(styles, _ref4) {
          var data = _ref4.data;
          return _objectSpread2(_objectSpread2({}, styles), {}, {
            backgroundColor: data.backgroundColor || 'none',
            borderColor: data.backgroundColor || secondaryLightGray
          });
        }
      }
    })), /*#__PURE__*/jsx(MpdInputMessages, {
      helpMessage: helpMessage,
      errorMessage: errorMessage
    })]
  });
}

function MpdColorSelector(_ref) {
  var colorList = _ref.colorList,
    selectedColor = _ref.selectedColor,
    onChange = _ref.onChange,
    _ref$isGradiant = _ref.isGradiant,
    isGradiant = _ref$isGradiant === void 0 ? false : _ref$isGradiant;
  var colorSelectorRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDropdown = _useState2[0],
    setOpenDropdown = _useState2[1];
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var _colorSelectorRef$cur;
      if (openDropdown && !(colorSelectorRef !== null && colorSelectorRef !== void 0 && (_colorSelectorRef$cur = colorSelectorRef.current) !== null && _colorSelectorRef$cur !== void 0 && _colorSelectorRef$cur.contains(event.target))) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdown, colorSelectorRef]);
  var selectColor = function selectColor(color) {
    onChange(color);
    setOpenDropdown(false);
  };
  var selectorClassnames = cn('mpd-color-selector__btn mpd-color-selector__color flex-center', _defineProperty({}, "gradiant-background-color-".concat(selectedColor), isGradiant));
  var selectorStyle = isGradiant ? {} : {
    backgroundColor: selectedColor || colorList[0]
  };
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-color-selector",
    ref: colorSelectorRef,
    children: [/*#__PURE__*/jsx("button", {
      type: "button",
      onClick: function onClick() {
        return setOpenDropdown(!openDropdown);
      },
      className: selectorClassnames,
      "aria-label": "color selector button",
      style: selectorStyle,
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: "arrow-down",
        width: "10",
        color: "white"
      })
    }), /*#__PURE__*/jsx("div", {
      className: cn('mpd-color-selector__dropdown', {
        active: openDropdown
      }),
      children: colorList.map(function (color) {
        var buttonClassnames = cn('mpd-color-selector__btn mpd-color-selector__color--small', _defineProperty({
          selected: selectedColor === color
        }, "gradiant-background-color-".concat(color), isGradiant));
        var buttonStyles = isGradiant ? {} : {
          backgroundColor: color
        };
        return /*#__PURE__*/jsx("button", {
          type: "button",
          onClick: function onClick() {
            return selectColor(color);
          },
          "aria-label": "color selector button",
          className: buttonClassnames,
          style: buttonStyles
        }, color);
      })
    })]
  });
}

var SIDEBAR_DISPLAY_STATUS = /*#__PURE__*/function (SIDEBAR_DISPLAY_STATUS) {
  SIDEBAR_DISPLAY_STATUS["OPENING"] = "opening";
  SIDEBAR_DISPLAY_STATUS["OPENED"] = "opened";
  SIDEBAR_DISPLAY_STATUS["CLOSING"] = "closing";
  SIDEBAR_DISPLAY_STATUS["CLOSED"] = "closed";
  return SIDEBAR_DISPLAY_STATUS;
}(SIDEBAR_DISPLAY_STATUS || {});
function MpdSidebar(_ref) {
  var opened = _ref.opened,
    actionButton = _ref.actionButton,
    children = _ref.children,
    onClose = _ref.onClose;
  var ref = useRef(null);
  var _useState = useState(opened ? SIDEBAR_DISPLAY_STATUS.OPENED : SIDEBAR_DISPLAY_STATUS.CLOSED),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  useEffect(function () {
    if (status === SIDEBAR_DISPLAY_STATUS.CLOSED && opened) {
      setStatus(SIDEBAR_DISPLAY_STATUS.OPENING);
    }
    if (status === SIDEBAR_DISPLAY_STATUS.OPENED && !opened) {
      setStatus(SIDEBAR_DISPLAY_STATUS.CLOSING);
    }
  }, [opened, status]);
  var updateStatus = useCallback(function () {
    if (status === SIDEBAR_DISPLAY_STATUS.OPENING) {
      setStatus(SIDEBAR_DISPLAY_STATUS.OPENED);
    }
    if (status === SIDEBAR_DISPLAY_STATUS.CLOSING) {
      setStatus(SIDEBAR_DISPLAY_STATUS.CLOSED);
    }
  }, [status]);
  useEffect(function () {
    var sidebar = ref.current;
    sidebar === null || sidebar === void 0 || sidebar.addEventListener('animationend', updateStatus);
    return function () {
      sidebar === null || sidebar === void 0 || sidebar.removeEventListener('animationend', updateStatus);
    };
  }, [updateStatus]);
  if (status === SIDEBAR_DISPLAY_STATUS.CLOSED) {
    return null;
  }
  return /*#__PURE__*/jsxs("aside", {
    ref: ref,
    className: "mpd-sidebar mpd-sidebar--".concat(status),
    children: [/*#__PURE__*/jsx("div", {
      className: "mpd-sidebar__close-btn",
      children: /*#__PURE__*/jsx("button", {
        type: "button",
        onClick: onClose,
        className: "mpd-btn mpd-btn--icon-only",
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "cross",
          width: "20"
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "mpd-sidebar__children",
      children: children
    }), actionButton && /*#__PURE__*/jsx("div", {
      className: "mpd-sidebar__action",
      children: /*#__PURE__*/jsx("button", {
        type: "button",
        className: cn('mpd-btn mpd-btn--primary', actionButton.isLoading && 'mpd-btn--loading'),
        onClick: actionButton.onClick,
        disabled: actionButton.isDisabled,
        children: actionButton.label
      })
    })]
  });
}

var _slideBoxRef = /*#__PURE__*/new WeakMap();
var MpdSlidebox = /*#__PURE__*/function (_PureComponent) {
  function MpdSlidebox(props) {
    var _this;
    _classCallCheck(this, MpdSlidebox);
    _this = _callSuper(this, MpdSlidebox, [props]);
    _classPrivateFieldInitSpec(_this, _slideBoxRef, void 0);
    _this.state = {
      isSlideboxOpened: false
    };
    _classPrivateFieldSet2(_slideBoxRef, _this, null);
    return _this;
  }
  _inherits(MpdSlidebox, _PureComponent);
  return _createClass(MpdSlidebox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var options = this.props.options;
      var slideboxOptions = _objectSpread2(_objectSpread2({}, options), {}, {
        closeElementHtml: '',
        isReactPortal: true,
        onOpen: function onOpen(url, element) {
          if (typeof options.onOpen === 'function') {
            options.onOpen();
          }
          _classPrivateFieldSet2(_slideBoxRef, _this2, element);
          _this2.setState({
            isSlideboxOpened: true
          });
        },
        onClose: function onClose() {
          if (typeof options.onClose === 'function') {
            options.onClose();
          }
        },
        onAfterClose: function onAfterClose() {
          if (typeof options.onAfterClose === 'function') {
            options.onAfterClose();
          }
        }
      });
      Slidebox.openSlideboxElement(slideboxOptions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (Slidebox.isOpen()) {
        Slidebox.destroy();
      }
    }

    // eslint-disable-next-line react/no-unused-class-component-methods
  }, {
    key: "close",
    value: function close() {
      Slidebox.close();
    }
  }, {
    key: "render",
    value: function render() {
      var isSlideboxOpened = this.state.isSlideboxOpened;
      if (isSlideboxOpened === null || !_classPrivateFieldGet2(_slideBoxRef, this)) {
        return null;
      }
      return /*#__PURE__*/createPortal(/*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs("button", {
          type: "button",
          className: "mclosebtn mpd-slidebox__close",
          onClick: Slidebox.close,
          children: [/*#__PURE__*/jsx(MpdIcon, {
            icon: "cross",
            height: "20",
            width: "20"
          }), this.props.closeBtnText]
        }), this.props.children]
      }), _classPrivateFieldGet2(_slideBoxRef, this));
    }
  }]);
}(PureComponent);

var TOAST_TYPE = /*#__PURE__*/function (TOAST_TYPE) {
  TOAST_TYPE["WARNING"] = "warning";
  TOAST_TYPE["ERROR"] = "error";
  TOAST_TYPE["SUCCESS"] = "success";
  TOAST_TYPE["INFO"] = "info";
  return TOAST_TYPE;
}({});
var TOAST_STATUS = /*#__PURE__*/function (TOAST_STATUS) {
  TOAST_STATUS["OPENING"] = "opening";
  TOAST_STATUS["OPENED"] = "opened";
  TOAST_STATUS["CLOSING"] = "closing";
  TOAST_STATUS["CLOSED"] = "closed";
  return TOAST_STATUS;
}({});
var TOAST_DISAPEAR_TIME = /*#__PURE__*/function (TOAST_DISAPEAR_TIME) {
  TOAST_DISAPEAR_TIME[TOAST_DISAPEAR_TIME["DEFAULT"] = 5000] = "DEFAULT";
  TOAST_DISAPEAR_TIME[TOAST_DISAPEAR_TIME["ACTION"] = 8000] = "ACTION";
  return TOAST_DISAPEAR_TIME;
}({});

function MpdToast(_ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TOAST_TYPE.INFO : _ref$type,
    title = _ref.title,
    message = _ref.message,
    action = _ref.action,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? TOAST_STATUS.OPENING : _ref$status,
    onStatusChange = _ref.onStatusChange,
    _ref$isPermanent = _ref.isPermanent,
    isPermanent = _ref$isPermanent === void 0 ? false : _ref$isPermanent;
  var ref = useRef(null);
  var handleAnimationEnd = useCallback(function () {
    if (status === TOAST_STATUS.OPENING) {
      onStatusChange(id, TOAST_STATUS.OPENED);
    }
    if (status === TOAST_STATUS.CLOSING) {
      onStatusChange(id, TOAST_STATUS.CLOSED);
    }
  }, [status, onStatusChange, id]);
  useEffect(function () {
    var toast = ref.current;
    toast === null || toast === void 0 || toast.addEventListener('animationend', handleAnimationEnd);
    return function () {
      toast === null || toast === void 0 || toast.removeEventListener('animationend', handleAnimationEnd);
    };
  }, [handleAnimationEnd]);
  useEffect(function () {
    var toast = ref.current;
    if (status === TOAST_STATUS.OPENED && !isPermanent) {
      var launchTimeout = function launchTimeout() {
        return window.setTimeout(function () {
          onStatusChange(id, TOAST_STATUS.CLOSING);
        }, action ? TOAST_DISAPEAR_TIME.ACTION : TOAST_DISAPEAR_TIME.DEFAULT);
      };
      var openingTimeout = launchTimeout();
      toast === null || toast === void 0 || toast.addEventListener('mouseenter', function () {
        window.clearTimeout(openingTimeout);
      });
      toast === null || toast === void 0 || toast.addEventListener('mouseleave', function () {
        openingTimeout = launchTimeout();
      });
    }
  }, [status, isPermanent, action, onStatusChange, id]);
  if (status === TOAST_STATUS.CLOSED) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: "mb2 mpd-toast mpd-toast--".concat(status, " mpd-alert mpd-alert--").concat(type),
    children: [/*#__PURE__*/jsxs("div", {
      className: "mpd-toast__info",
      children: [/*#__PURE__*/jsx("div", {
        className: cn({
          bold: message
        }),
        children: title
      }), message && /*#__PURE__*/jsx("div", {
        children: message
      })]
    }), action && /*#__PURE__*/jsx("div", {
      className: "mpd-toast__action",
      children: action
    }), isPermanent && /*#__PURE__*/jsx("button", {
      type: "button",
      className: "mpd-btn mpd-btn--icon-only mpd-toast__close",
      onClick: function onClick() {
        return onStatusChange(id, TOAST_STATUS.CLOSING);
      },
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: "cross"
      })
    })]
  });
}

function ToastList(_ref) {
  var toastList = _ref.toastList,
    onStatusChange = _ref.onStatusChange;
  return /*#__PURE__*/jsx("div", {
    className: "mpd-toast-list",
    children: toastList.map(function (toast) {
      return /*#__PURE__*/jsx(MpdToast, {
        id: toast.id,
        title: toast.title,
        message: toast.message,
        type: toast.type,
        action: toast.action,
        status: toast.status,
        onStatusChange: onStatusChange,
        isPermanent: toast.isPermanent
      }, toast.id);
    })
  });
}

var MpdToastContext = /*#__PURE__*/createContext(undefined);
function MpdToastProvider(_ref) {
  var children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    toastList = _useState2[0],
    setToastList = _useState2[1];
  var toastIdCounter = useRef(0);
  var toast = useCallback(function (toastOptions) {
    toastIdCounter.current += 1;
    var id = "toast-".concat(toastIdCounter.current);
    setToastList(function (prev) {
      return [].concat(_toConsumableArray(prev), [_objectSpread2(_objectSpread2({}, toastOptions), {}, {
        id: id,
        status: TOAST_STATUS.OPENING
      })]);
    });
    var instance = {
      close: function close() {
        setToastList(function (prev) {
          return prev.map(function (item) {
            return item.id === id ? _objectSpread2(_objectSpread2({}, item), {}, {
              status: TOAST_STATUS.CLOSING
            }) : item;
          });
        });
      }
    };
    return instance;
  }, []);
  var updateToastStatus = useCallback(function (id, newStatus) {
    setToastList(function (prev) {
      return prev.map(function (item) {
        return item.id === id ? _objectSpread2(_objectSpread2({}, item), {}, {
          status: newStatus
        }) : item;
      });
    });
  }, []);
  return /*#__PURE__*/jsxs(MpdToastContext.Provider, {
    value: toast,
    children: [children, toastList && /*#__PURE__*/jsx(ToastList, {
      toastList: toastList,
      onStatusChange: updateToastStatus
    })]
  });
}
function useMpdToast() {
  var context = useContext(MpdToastContext);
  if (typeof context === 'undefined') {
    throw new Error('You need a `MpdToastProvider` component up in the tree to use `useMpdToast`');
  }
  return context;
}

// eslint-disable-next-line react/function-component-definition
var MpdDropDownLink = function MpdDropDownLink(_ref) {
  var _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/jsx("a", {
    className: cn('mpd-dropDown-link', className, {
      'mpd-dropDown-link--show': show,
      'mpd-dropDown-link--hide': hide
    }),
    href: "#toggle",
    onClick: onClick,
    children: children
  });
};
// eslint-disable-next-line react/no-multi-comp, react/function-component-definition
var MpdDropDownContent = function MpdDropDownContent(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/jsx("div", {
    className: "mpd-dropDown-contentWrapper",
    children: /*#__PURE__*/jsx("div", {
      className: "mpd-dropDown-content",
      children: children
    })
  });
};
// eslint-disable-next-line react/no-multi-comp, react/function-component-definition
var MpdDropDown = function MpdDropDown(_ref3) {
  var _ref3$animate = _ref3.animate,
    animate = _ref3$animate === void 0 ? false : _ref3$animate,
    _ref3$absolute = _ref3.absolute,
    absolute = _ref3$absolute === void 0 ? false : _ref3$absolute,
    _ref3$keepOpen = _ref3.keepOpen,
    keepOpen = _ref3$keepOpen === void 0 ? false : _ref3$keepOpen,
    openFrom = _ref3.openFrom,
    onChange = _ref3.onChange,
    _ref3$opened = _ref3.opened,
    opened = _ref3$opened === void 0 ? null : _ref3$opened,
    _ref3$defaultOpened = _ref3.defaultOpened,
    defaultOpened = _ref3$defaultOpened === void 0 ? false : _ref3$defaultOpened,
    children = _ref3.children;
  var dropdownRef = useRef(null);
  var _useState = useState(defaultOpened),
    _useState2 = _slicedToArray(_useState, 2),
    renderChildren = _useState2[0],
    setRenderChildren = _useState2[1];
  useEffect(function () {
    dropDownInit();
    if (onChange && dropdownRef.current) {
      dropdownRef.current.addEventListener('mpd_dropdown::change', function (event) {
        if (!(event instanceof CustomEvent)) {
          throw new Error('"mpd_dropdown::change" event must be a CustomEvent');
        }
        onChange({
          opened: event.detail.opened
        });
      }, false);
    }
  }, [onChange]);
  useEffect(function () {
    if (opened === null || !dropdownRef.current) {
      return;
    }
    if (opened) {
      if (!renderChildren) {
        setRenderChildren(true);
      } else if (!dropdownRef.current.classList.contains('mpd-dropDown--open')) {
        toggleDropDown(dropdownRef.current, 'open');
      }
    } else if (renderChildren) {
      toggleDropDown(dropdownRef.current, 'close');
    }
  }, [opened, renderChildren]);
  return /*#__PURE__*/jsx("div", {
    ref: dropdownRef,
    className: cn('mpd-dropDown', animate && 'mpd-dropDown--animate', absolute && 'mpd-dropDown--absolute', keepOpen && 'mpd-dropDown--keepOpen', openFrom && "mpd-dropDown--open-from-".concat(openFrom), defaultOpened && 'mpd-dropDown--open'),
    children: renderChildren && children
  });
};

function MpdTicketOffer(_ref) {
  var image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? OFFER_COLOR.PINK : _ref$color,
    onClick = _ref.onClick,
    labelAction = _ref.labelAction,
    _ref$pack = _ref.pack,
    pack = _ref$pack === void 0 ? false : _ref$pack;
  var hasImage = image !== undefined;
  if (pack) {
    return /*#__PURE__*/jsxs("div", {
      className: "mpd-ticket-offer mpd-ticket-offer--pack",
      onClick: onClick,
      role: "button",
      "aria-hidden": true,
      children: [/*#__PURE__*/jsxs("div", {
        className: "mpd-ticket-offer__description",
        children: [/*#__PURE__*/jsx("h3", {
          children: title
        }), /*#__PURE__*/jsx("p", {
          children: description
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-ticket-offer__button gradiant-background-color-".concat(color),
        children: /*#__PURE__*/jsx("span", {
          children: labelAction
        })
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-ticket-offer__striped mpd-ticket-offer__striped--".concat(color)
      })]
    });
  }
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-ticket-offer",
    onClick: onClick,
    role: "button",
    "aria-hidden": true,
    children: [/*#__PURE__*/jsx("div", {
      className: cn('mpd-ticket-offer__image', _defineProperty({}, "gradiant-background-color-".concat(color), !hasImage)),
      children: hasImage && /*#__PURE__*/jsx("img", {
        src: image,
        alt: ""
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "mpd-ticket-offer__description",
      children: [/*#__PURE__*/jsx("h3", {
        children: title
      }), /*#__PURE__*/jsx("p", {
        children: description
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "mpd-ticket-offer__button gradiant-background-color-".concat(color),
      children: /*#__PURE__*/jsx("span", {
        children: labelAction
      })
    })]
  });
}

function CopyButton(_ref) {
  var value = _ref.value,
    successMessage = _ref.successMessage,
    errorMessage = _ref.errorMessage;
  var toast = useMpdToast();
  return /*#__PURE__*/jsx("button", {
    type: "button",
    className: "mpd-btn mpd-btn--icon-only mpd-btn--inline",
    children: /*#__PURE__*/jsx(MpdIcon, {
      icon: "copy",
      className: "ml2 mr0",
      onClick: function onClick() {
        try {
          navigator.clipboard.writeText(value);
          toast({
            type: TOAST_TYPE.SUCCESS,
            title: successMessage
          });
        } catch (err) {
          toast({
            type: TOAST_TYPE.ERROR,
            title: errorMessage
          });
        }
      }
    })
  });
}

var TIMEOUT_ALERT = 5000;
function MpdCopyInput(_ref) {
  var value = _ref.value,
    successMessage = _ref.successMessage,
    label = _ref.label;
  var ref = useRef(null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displaySuccess = _useState2[0],
    setDisplaySuccess = _useState2[1];
  var handleCopyText = useCallback(function () {
    if (!(ref !== null && ref !== void 0 && ref.current)) {
      return;
    }
    ref.current.select();
    navigator.clipboard.writeText(value);
    if (successMessage) {
      setDisplaySuccess(true);
    }
  }, [value, successMessage]);
  var handleSelect = useCallback(function () {
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.select();
    }
  }, []);
  useEffect(function () {
    // Hide success message after few seconds
    var timeout = setTimeout(function () {
      return setDisplaySuccess(false);
    }, TIMEOUT_ALERT);
    return function () {
      clearTimeout(timeout);
    };
  }, [displaySuccess]);
  return /*#__PURE__*/jsx(MpdInput, {
    ref: ref,
    value: value,
    label: label,
    readOnly: true,
    submitLabel: /*#__PURE__*/jsxs("div", {
      className: "flex-center",
      children: [t('copy'), /*#__PURE__*/jsx(MpdIcon, {
        icon: "copy",
        className: "ml2 mr0"
      })]
    }),
    onClick: handleSelect,
    onSubmit: handleCopyText,
    successMessage: displaySuccess ? successMessage : undefined
  });
}

function MpdTag(_ref) {
  var label = _ref.label,
    color = _ref.color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx("div", {
    className: cn('mpd-tag', className),
    style: {
      backgroundColor: color
    },
    children: label
  });
}

function MpdDateCard(_ref) {
  var date = _ref.date,
    locale = _ref.locale,
    timeZone = _ref.timeZone,
    color = _ref.color;
  var timeFormatOptions = {
    hour: '2-digit',
    // two digits (e.g., 01, 02)
    minute: '2-digit',
    // two digits (e.g., 05, 15)
    timeZone: timeZone !== null && timeZone !== void 0 ? timeZone : undefined // Specifies the time zone to be used (e.g., "America/New_York", "Europe/Paris")
  };
  var dateFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    // number (e.g., 1, 2, 3)
    month: 'short',
    // abbreviated form (e.g., Jan, Feb, Mar)
    year: '2-digit',
    // 2-digit number (e.g., 23)
    timeZone: timeZone !== null && timeZone !== void 0 ? timeZone : undefined // Specifies the time zone to be used (e.g., "America/New_York", "Europe/Paris")
  };
  var timeFormatter = new Intl.DateTimeFormat(locale, timeFormatOptions);
  var dateFormatter = new Intl.DateTimeFormat(locale, dateFormatOptions);
  var dateParts = dateFormatter.formatToParts(date);
  var dayAndMonth = dateParts.filter(function (p) {
    return p.type === 'day' || p.type === 'month';
  });
  var year = dateParts.find(function (p) {
    return p.type === 'year';
  });
  var weekDay = dateParts.find(function (p) {
    return p.type === 'weekday';
  });
  if (!year || !weekDay) {
    throw new Error('Year and weekDay must be defined');
  }
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-date-card",
    style: {
      backgroundColor: color
    },
    children: [/*#__PURE__*/jsx("div", {
      className: "mpd-date-card__header",
      style: {
        color: color
      },
      children: weekDay.value
    }), /*#__PURE__*/jsx("div", {
      className: "mpd-date-card__date",
      children: dayAndMonth.map(function (_ref2) {
        var value = _ref2.value,
          type = _ref2.type;
        return /*#__PURE__*/jsxs("div", {
          children: [value, " ", type === 'month' && year.value]
        });
      })
    }), /*#__PURE__*/jsx("div", {
      className: "mpd-date-card__footer",
      style: {
        color: color
      },
      children: timeFormatter.format(date)
    })]
  });
}

function MpdModal(_ref) {
  var _secondaryButtonProps, _primaryButtonProps$l;
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
    isForm = _ref.isForm,
    _ref$disableNativeFor = _ref.disableNativeFormValidation,
    disableNativeFormValidation = _ref$disableNativeFor === void 0 ? false : _ref$disableNativeFor,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    children = _ref.children,
    primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    tertiaryAction = _ref.tertiaryAction,
    contentClassNames = _ref.contentClassNames;
  // minisite is not ready for suspense yet (nextjs 13)
  var _useTranslation = useTranslation(undefined, {
      useSuspense: false
    }),
    ready = _useTranslation.ready,
    t = _useTranslation.t;
  var refModal = useRef(null);
  var MainTag = isForm ? 'form' : 'div';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentScrollable = _useState2[0],
    setIsContentScrollable = _useState2[1];
  var isUsingPolyfill = typeof HTMLDialogElement !== 'function';

  // handle open and close on unmount
  useEffect(function () {
    if (!ready) {
      return;
    }
    var refModalCurrent = refModal.current;
    if (refModalCurrent) {
      dialogPolyfill.registerDialog(refModalCurrent);
      refModalCurrent.showModal();
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    // eslint-disable-next-line consistent-return
    return function () {
      refModalCurrent === null || refModalCurrent === void 0 || refModalCurrent.close();
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [ready]);

  // handle escape to close modal
  useEffect(function () {
    if (!ready) {
      return;
    }
    var closeListener = function closeListener(event) {
      var isEscape = event instanceof KeyboardEvent && event.key === 'Escape';
      if (isEscape) {
        onCancel();
      }
    };
    document.addEventListener('keydown', closeListener);

    // eslint-disable-next-line consistent-return
    return function () {
      document.removeEventListener('keydown', closeListener);
    };
  }, [onCancel, ready]);

  // overflow is visible by default for components to not be hidden inside the modal when opened (like Select), but we need to check for long scrollable content to change overflow to auto
  useEffect(function () {
    if (!ready) {
      return;
    }
    var refModalCurrent = refModal.current;
    if (!refModalCurrent || typeof ResizeObserver === 'undefined') {
      return;
    }
    var observerCallback = function observerCallback(entries) {
      window.requestAnimationFrame(function () {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        var modalContentElement = refModalCurrent.querySelector('.mpd-modal__content');
        if (modalContentElement) {
          var windowAvailableHeight = window.innerHeight;
          var modalContentHeight = modalContentElement.scrollHeight;
          // we add a total of 320px to account for fixed sized elements: the modal header (70px), larger footer (140px in responsive with 3 btn), external margins (2 x 40px), and a 30px buffer
          var needsScroll = modalContentHeight + 320 > windowAvailableHeight;
          setIsContentScrollable(needsScroll);
        }
      });
    };

    // in case the data displayed is not instant, we need to listen to height change
    var resizeObserver = new ResizeObserver(observerCallback);
    resizeObserver.observe(refModalCurrent);

    // eslint-disable-next-line consistent-return
    return function () {
      return resizeObserver.disconnect();
    };
  }, [ready]);
  if (!ready) {
    return null;
  }
  return /*#__PURE__*/jsx("dialog", {
    ref: refModal,
    className: cn('mpd-modal', isUsingPolyfill && 'mpd-modal--polyfill', isSmall && 'mpd-modal--small-width'),
    children: /*#__PURE__*/jsxs(MainTag
    // @ts-expect-error if `isForm`, then MainTag will be a `form`, but TS do not manage to infer this
    , {
      onSubmit: isForm ? onSubmit : undefined,
      noValidate: isForm && disableNativeFormValidation ? true : undefined,
      children: [/*#__PURE__*/jsxs("div", {
        className: "mpd-modal__header",
        children: [/*#__PURE__*/jsx("button", {
          type: "button",
          onClick: onCancel,
          className: "mpd-modal__close-icon mpd-btn mpd-btn--icon-only",
          children: /*#__PURE__*/jsx(MpdIcon, {
            icon: "cross",
            width: "22"
          })
        }), /*#__PURE__*/jsx("div", {
          className: "h2-like m0",
          children: title
        }), subtitle && /*#__PURE__*/jsx("div", {
          className: cn(typeof subtitle === 'string' && 'small mpd-color-gray'),
          children: subtitle
        })]
      }), children && /*#__PURE__*/jsx("div", {
        className: cn('mpd-modal__content', contentClassNames, isContentScrollable && 'mpd-modal__content--scrollable'),
        children: children
      }), (primaryButtonProps || secondaryButtonProps || tertiaryAction) && /*#__PURE__*/jsxs("div", {
        className: cn('mpd-modal__footer', tertiaryAction && 'mpd-modal__footer--with-tertiary-action', isContentScrollable && 'mpd-modal__footer--with-border'),
        children: [tertiaryAction && tertiaryAction, /*#__PURE__*/jsxs("div", {
          children: [secondaryButtonProps && /*#__PURE__*/jsx("button", {
            type: "button",
            className: "mpd-btn mpd-btn--secondary",
            onClick: secondaryButtonProps.onClick,
            disabled: secondaryButtonProps.isDisabled,
            children: (_secondaryButtonProps = secondaryButtonProps.label) !== null && _secondaryButtonProps !== void 0 ? _secondaryButtonProps : t('cancel')
          }), primaryButtonProps && /*#__PURE__*/jsx("button", {
            type: isForm ? 'submit' : 'button',
            className: cn('mpd-btn mpd-btn--primary', primaryButtonProps.isLoading && 'mpd-btn--loading'),
            onClick: !isForm ? primaryButtonProps.onClick : undefined,
            disabled: primaryButtonProps.isDisabled,
            children: (_primaryButtonProps$l = primaryButtonProps.label) !== null && _primaryButtonProps$l !== void 0 ? _primaryButtonProps$l : t('confirm')
          })]
        })]
      })]
    })
  });
}

function MpdInputPassword(_ref) {
  var input = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPasswordVisible = _useState2[0],
    setIsPasswordVisible = _useState2[1];
  var togglePasswordVisibility = function togglePasswordVisibility() {
    setIsPasswordVisible(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/jsx("div", {
    className: "mpd-input--password",
    children: /*#__PURE__*/jsx(MpdInput, _objectSpread2({
      type: isPasswordVisible ? 'text' : 'password',
      onSubmit: togglePasswordVisibility,
      submitLabel: /*#__PURE__*/jsx(MpdIcon, {
        width: "18",
        height: "18",
        icon: isPasswordVisible ? 'eye-closed' : 'eye',
        className: "mpd-color-blue"
      })
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, input))
  });
}

function MpdCharacterLengthIndicator(_ref) {
  var currentLength = _ref.currentLength,
    maxLength = _ref.maxLength;
  if (maxLength === undefined) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: "mpd-character-length-indicator",
    children: "".concat(currentLength, "/").concat(maxLength)
  });
}

var _excluded = ["id", "label", "className", "disabled", "required", "errorMessage", "successMessage", "help", "rows", "cols"];
function MpdTextarea(_ref) {
  var _input$value$toString, _input$value;
  var id = _ref.id,
    label = _ref.label,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    errorMessage = _ref.errorMessage,
    successMessage = _ref.successMessage,
    help = _ref.help,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 4 : _ref$rows,
    _ref$cols = _ref.cols,
    cols = _ref$cols === void 0 ? 50 : _ref$cols,
    input = _objectWithoutProperties(_ref, _excluded);
  var inputId = id !== null && id !== void 0 ? id : generateRandomID();
  return /*#__PURE__*/jsxs("div", {
    className: cn('mpd-textarea', className, {
      'mpd-textarea--disabled': disabled,
      'mpd-textarea--error': !!errorMessage,
      'mpd-textarea--success': !!successMessage
    }),
    children: [/*#__PURE__*/jsx(MpdInputLabel, {
      id: inputId,
      label: label,
      required: required
    }), /*#__PURE__*/jsx("textarea", _objectSpread2({
      id: inputId,
      disabled: disabled,
      rows: rows,
      cols: cols,
      required: required
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, input)), /*#__PURE__*/jsxs("div", {
      className: "flex-row",
      children: [/*#__PURE__*/jsx(MpdInputMessages, {
        helpMessage: help,
        successMessage: successMessage,
        errorMessage: errorMessage
      }), /*#__PURE__*/jsx(MpdCharacterLengthIndicator, {
        currentLength: (_input$value$toString = (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.toString().length) !== null && _input$value$toString !== void 0 ? _input$value$toString : 0,
        maxLength: input.maxLength
      })]
    })]
  });
}

function useResponsive(breakpoint) {
  if (!breakpoint) {
    throw new Error('`breakpoint` param should be defined.');
  }
  var getMatchMedia = useCallback(function () {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.matchMedia("(max-width: ".concat(breakpoint, ")")).matches;
  }, [breakpoint]);
  var handleResizeChange = useCallback(function () {
    return setIsResponsive(getMatchMedia());
  }, [getMatchMedia]);
  var _useState = useState(getMatchMedia()),
    _useState2 = _slicedToArray(_useState, 2),
    isResponsive = _useState2[0],
    setIsResponsive = _useState2[1];
  useEffect(function () {
    setIsResponsive(getMatchMedia());
    window.addEventListener('resize', handleResizeChange);
    return function () {
      window.removeEventListener('resize', handleResizeChange);
    };
  }, [getMatchMedia, handleResizeChange]);
  return isResponsive;
}

var BUTTON_GROUP_ITEM_TYPE = /*#__PURE__*/function (BUTTON_GROUP_ITEM_TYPE) {
  BUTTON_GROUP_ITEM_TYPE["BUTTON"] = "button";
  BUTTON_GROUP_ITEM_TYPE["LINK"] = "link";
  return BUTTON_GROUP_ITEM_TYPE;
}({});
function MpdButtonGroup(_ref) {
  var items = _ref.items,
    className = _ref.className;
  var groupClassName = cn('mpd-btn-group-v2', className);
  var _useSelector = useSelector({
      selectorQuery: '.selected',
      observeQuery: '.mpd-btn-v2'
    }),
    containerRef = _useSelector.containerRef,
    selectorRef = _useSelector.selectorRef;
  var renderItem = function renderItem(item, index) {
    var label = item.label,
      icon = item.icon,
      _item$selected = item.selected,
      selected = _item$selected === void 0 ? false : _item$selected,
      _item$disabled = item.disabled,
      disabled = _item$disabled === void 0 ? false : _item$disabled;
    var btnClassName = cn('mpd-btn-v2', 'mpd-btn-v2--tertiary', 'no-background', {
      selected: selected,
      disabled: disabled
    });
    var iconElement = /*#__PURE__*/jsx(MpdIcon, {
      icon: icon,
      width: "18",
      height: "18"
    });
    if (item.type === BUTTON_GROUP_ITEM_TYPE.LINK) {
      return /*#__PURE__*/jsx(Fragment$1, {
        children: item.link(iconElement, label, item.href, btnClassName)
      }, index);
    }
    var content = /*#__PURE__*/jsxs(Fragment, {
      children: [iconElement, label]
    });
    return /*#__PURE__*/jsx("button", {
      type: "button",
      className: btnClassName,
      onClick: item.onClick,
      disabled: disabled,
      children: content
    }, index);
  };
  return /*#__PURE__*/jsxs("div", {
    ref: containerRef,
    className: groupClassName,
    children: [/*#__PURE__*/jsx("div", {
      ref: selectorRef,
      className: "selector"
    }), items.map(renderItem)]
  });
}

function MpdCollapse(_ref) {
  var data = _ref.data,
    _ref$isBorderless = _ref.isBorderless,
    isBorderless = _ref$isBorderless === void 0 ? false : _ref$isBorderless,
    _ref$isAccordion = _ref.isAccordion,
    isAccordion = _ref$isAccordion === void 0 ? false : _ref$isAccordion,
    _ref$defaultOpenIndex = _ref.defaultOpenIndexes,
    defaultOpenIndexes = _ref$defaultOpenIndex === void 0 ? [] : _ref$defaultOpenIndex,
    className = _ref.className;
  var _useState = useState(defaultOpenIndexes),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndexes = _useState2[0],
    setActiveIndexes = _useState2[1];
  var isOpen = function isOpen(index) {
    return activeIndexes.includes(index);
  };
  var toggleTab = function toggleTab(index) {
    if (isAccordion) {
      setActiveIndexes(isOpen(index) ? [] : [index]);
      return;
    }
    setActiveIndexes(function (prev) {
      return prev.reduce(function (acc, curr) {
        if (curr !== index) {
          acc.push(curr);
        }
        return acc;
      }, isOpen(index) ? [] : [index]);
    });
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: data.map(function (item, index) {
      return /*#__PURE__*/jsxs("div", {
        className: cn('mpd-collapse-tab', className, {
          'mpd-collapse-tab--is-borderless': isBorderless
        }),
        children: [/*#__PURE__*/jsxs("button", {
          className: "mpd-collapse-tab__header",
          type: "button",
          onClick: function onClick() {
            return toggleTab(index);
          },
          children: [/*#__PURE__*/jsx("div", {
            className: "mpd-collapse-tab__header__title",
            children: item.title
          }), /*#__PURE__*/jsx(MpdIcon, {
            className: "mpd-collapse-tab__header__icon",
            icon: isOpen(index) ? 'arrow-top' : 'arrow-down',
            width: "24px"
          })]
        }), /*#__PURE__*/jsx("div", {
          className: cn('mpd-collapse-tab__content', {
            'mpd-collapse-tab__content--is-active': isOpen(index)
          }),
          children: /*#__PURE__*/jsx("div", {
            className: "mpd-collapse-tab__content__inner",
            children: item.content
          })
        })]
      }, item.key);
    })
  });
}

export { BUTTON_GROUP_ITEM_TYPE, GRADIANT_COLOR, GRADIANT_COLOR_LIST, IMAGE_NAME, LayoutMode, MENU_ITEM_TYPE, MpdAside, MpdBadge, MpdButtonGroup, MpdCalendar, MpdCard, MpdCharacterLengthIndicator, MpdCheckbox, MpdCircleProgress, MpdCollapse, MpdColorSelector, CopyButton as MpdCopyButton, MpdCopyInput, MpdDateCard, MpdDropDown, MpdDropDownContent, MpdDropDownLink, MpdEventHeader, MpdFieldset, MpdFilters, MpdFiltersActiveItem, MpdIcon, MpdInput, MpdInputByCharacter, MpdInputLabel, MpdInputMessages, MpdInputPassword, MpdLayout, MpdLinkCard, MpdLinkTabs, MpdLoader, MpdMenu, MpdModal, MpdMultiSelect, MpdOffer, MpdOfferHeader, MpdPhoneInput, MpdPopover, MpdRadio, MpdSelect, MpdSelectOption, MpdSidebar, MpdSingleSelect, MpdSlidebox, MpdTabs, MpdTag, MpdTextarea, MpdTicket, MpdTicketOffer, MpdToastProvider, OFFER_COLOR, SOLID_COLOR, SOLID_COLOR_LIST, Slidebox, TOAST_TYPE, checkScrollable, delegate, dropDownInit as dropdown, generateColor, getImgPath, hexToRGB, mpdTabInit, scrollToY as scrollTo, shortenInit as shorten, useMpdLayoutScrollContext, useMpdToast, useResponsive };
//# sourceMappingURL=makeup.js.map
